webpackJsonp([0],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABkCAMAAABHPGVmAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAEtQTFRF4+Pj6urq7/Dw5+fn9fb25OTk8/T0/f399PX15eXl7e7u5ufn6Onp7+/v+/v7+vr68fHx+Pj48/Pz7u/v8vPz6erq5ebm7Ozs////7ptf1QAAABl0Uk5T////////////////////////////////AAE0CrcAAAFrSURBVHja7NrJbsQgEATQLtsJ4N2Tjf//0ngyS2YkLyzdTg5dF248NYIDUpG/xdgaLTHFAeN035qu61ATe5rRPCKmI5E00y9iWpLKeEMEDaL6gogaRPYH6UQNcv2M9CQczEgtjdBARtygmqw84qijAwJFFFFEEUUUUeTfI+WbPFJWVSGNlFXx8lrIIuV5jHgF0UaCgngjXkGCEa0gxYhVkGREKkgz4hQkGlEKUo0YBclGhIJ0I1xBhhGsIMcIVZBlBCrIM8IUZBpBCnKNEAXZRoCCfGNfAYOxq4DD2FPAYuwo4DG2FTAZmwq4jC0FbMaGAj5jXQGjsaqA01hTwGqsKOA1lhUwG4sKuI0lBezGgvKEfLAYs/L+qf94RRRRRBFFFPlb5OsIZDwCGeSJlnwjjljy4tUCZ8iLj3I691Ym4TdyqflY2cO6FpYEFTfcq1fWSZ2VeSiR9SI9HHd6bqr5vuO+ZbDXopr/FmAA4hgSET1r1yYAAAAASUVORK5CYII="

/***/ }),
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store__ = __webpack_require__(98);


/* harmony default export */ __webpack_exports__["a"] = ({
  startTime: Date.now(),
  isLocalIp: /192|10|127/.test(location.host),
  isLocal: /localhost|192|10|127/.test(location.host),
  isProd: /www.xianshang.com/.test(location.hostname),
  isIos: /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream,
  userInfo: {},
  ls: new __WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */](localStorage),
  ss: new __WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */](sessionStorage),
  log: function log(msg) {
    var time = Date.now() - this.startTime;
    time = time < 1000 ? '[' + time + 'ms]' : '[' + (time / 1000).toFixed(2) + 's]';
    console.log(time, msg);
  },
  logc: function logc(msg) {
    var time = Date.now() - this.startTime;
    time = time < 1000 ? '[' + time + 'ms]' : '[' + (time / 1000).toFixed(2) + 's]';
    console.log('%c' + time + '%c' + msg, 'font-size: 1em;', 'background-image: -webkit-gradient(linear, left top, right top, color-stop(0, #F00), color-stop(0.17, #F60), color-stop(0.33, #FF0), color-stop(0.5, #0C0), color-stop(0.67, #699), color-stop(0.83, #06C), color-stop(1, #909) ); color: transparent; -webkit-background-clip: text; font-size: 1.2em;');
  },
  hideLoading: function hideLoading() {
    document.querySelector('#loading').style.display = 'none';
  },
  showLoading: function showLoading() {
    document.querySelector('#loading').style.display = 'block';
  },
  go: function go(hash) {
    var refresh = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

    var href = location.href.split('#')[0].split('?');
    var searchParamString = '';
    if (href[1]) {
      var paramArr = href[1].split('&');
      var paramObj = {};
      paramArr.forEach(function (v, k) {
        var arr = v.split('=');
        paramObj[arr[0]] = arr[1];
      });
      if (refresh) paramObj['_t'] = new Date().getTime();
      searchParamString += '?';
      for (var key in paramObj) {
        searchParamString += key + '=' + paramObj[key] + '&';
      }
      searchParamString = searchParamString.slice(0, searchParamString.length - 1);
    } else if (refresh) {
      searchParamString = '?_t=' + new Date().getTime();
    }
    location.href = '' + href[0] + searchParamString + '#' + hash;
  },
  random: function random(start, end) {
    return Math.floor(start + Math.random() * (end - start + 1));
  },
  queryHref: function queryHref(key) {
    if (!location.href.split('?')[1]) return '';
    var params = location.href.split('?')[1].split('#')[0].split('&');
    var res = params.find(function (v) {
      return v.split('=')[0] === key;
    });
    return res ? res.split('=')[1] : '';
  }
});

/***/ }),
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "img/img10.3252ba5.png";

/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "img/img2.35d2f71.png";

/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "img/img7.318fe43.png";

/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "img/img1.6dc59d3.png";

/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "img/img1.f7de365.png";

/***/ }),
/* 55 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAIwAAACMCAIAAAAhotZpAAAMb2lDQ1BEaXNwbGF5AABIiZVXd1STdxd+3pGEhBFGREGQADIEUWQGkRHCFARkg4uQBAgjxJcEFbe1VMG6RRRHHXVXW62A1IlYXMW96vhw4KjUYt2T748Eau13vu9895y8v3vu77nPvfd5c3JyAX6bVK0uIk2BYpWGSYoKE2ZkZgk590GBDxOYwk0qK1WLExPjAKD7/Lu9vAwCAC54SNXqon/e/1czlytKZQAxGkCOvFRWDBCHAXqWTM1oAHY4AMcJGrUGYOcDEDAZmVkAewoAQZ7OXwhAkKPzNwIQMClJEoDdABgYSaVMHmDSDEBYJsvTACb3AHiq5EoVwBcACJblS+UAPwXAwOLiEjnAnwHAtUyWpwb4WwCIcj7hzPsbf04Pv1Sa1+Pr5gIAGIQrS9VF0kn/pzT/24qLtN01nAEY5TPRSQAEAHG1sCQ2CYARQHSocuITAJgDxGulXKc7QPLytdGpOjxpIyuVZAGwBEhPuTQ8FoANQEaqiuLj9PGcXGVkDABTgJyo1MSk6HPnKEojkvWcq5iSpIRuP5eRiPW5O6UMoMc3awtTxXr+q/mKmG7+5+X5KekAeADFK1OmxQMwAShBaWFyrA5DOZTnS+K7MYw2KRVAf4ASKVRRYTp+anQuE5mkx6uLS7vnpSrylTHxer9Gk58SrdOH2iaTRiQD6ANQdQqVOLWbR1GaEdc9i1wRHqGbnWpVqFL181K31JqwJH1up7ooUY+nDRRFUUkAHADaurQsWZ9LD9MwKfp3RMepNYkpuj7p7ALp8ERdP3QZ4iBBOITQQogclKAAytaO+g4I9TeRkIJBHhTw0Ee6M9IhBQMVpEhGOX6HCgqU9uSFQQoGCpRBhQ89Ud3TA7mQgkEZFChFIe6DQTFiUQQFtGCggKqnWhrugYHyH9VlKEERSsBA+R9iYkgQp49ou3mF/G4kO4Idzo5mR7IH0NZ0MB1Ix9HBdCgdTHvRIjqgu9u/8Kz7rHOsO6xLrDbWtXHKWcxnvYxAG7R6pRTI+XRi2pn2on3pMDqIDqYDIKQtaWt40D60iBbTIXQg7UsHQKLvWwvmM6U+m+ATzfU4rieX5PbmhnJdP880cTPx7WFRQPU3fXS95vSoKum5+by+5BOd5ShB7OdIag61h2qhjlAnqP1UPYTUIaqBOk0doOo/+Q7dA4O8nmpJUECFQhRB+Y96Un1NBgqUem73fOT5Xn8HjWKiBgAkJepJjDIvXyMUq9VFCmGMSjZooNDL08sLyMjMEup+pp5ZggBAWJ78K1b8HhA5A1TVX7GcJUD9BcAs4q+YcxRgygEOjpFpmTJdjAYAFnjgQwAr9IMjXOEBL/ghEKGIwHAkIAWZGAsZ8lEMBhMwBTNRgSosxDKsxFpswBZ8h92ox34cwc84hbO4hOtoQzseoxMv8Y4gCA5hTFgQVoQd4US4E16EiAgmIog4IonIJLKJPEJFaIkpxBdEFbGYWEmsI7YSPxD7iCPECeIccY24TTwi/iTekhRpRApIW9KZHEyKSDEZS6aQY8g8cjxZTs4m55M15HpyB1lHHiFPkZfINvIx+YICZUhZUvaUByWiJFQClUXlUgw1jaqkqqn11E6qkWqhLlBtVAf1hmbTFrSQ9qAD6Wg6lZbR4+lp9Dx6Jb2FrqOb6Qv0bbqT/sgyZtmw3FlDWTGsDFYeawKrglXN2sTayzrGusRqZ71ks9mWbBe2PzuanckuYE9mz2OvZu9iH2afY99lv+BwOFYcd04QJ4Ej5Wg4FZwVnB2cQ5zznHbOawNDAzsDL4NIgywDlcEsg2qDbQYHDc4bPDB4xzXlOnGHchO4cu4k7gLuRm4j9wy3nfuOZ8Zz4QXxUngFvJm8Gt5O3jHeDd4zQ0NDB8MAw5GGSsMZhjWG3xseN7xt+MbI3MjNSGI02khrNN9os9Fho2tGz4yNjZ2NQ42zjDXG8423Gh81vmX82sTCZJBJjIncZLpJrUmdyXmTJ3wu34kv5o/ll/Or+Xv4Z/gdplxTZ1OJqdR0mmmt6T7TK6YvzCzMhpglmBWbzTPbZnbC7KE5x9zZPMJcbj7bfIP5UfO7FpSFo4XEQmbxhcVGi2MW7QK2wEUQIygQVAm+E7QKOnuZ9/LpldZrYq/aXgd6tVlSls6WMZZFlgssd1tetnzb27a3uLei99zeO3uf7/2qT98+oX0UfSr77Opzqc9bK6FVhFWh1SKrequb1rS1m/VI6wnWa6yPWXf0FfQN7CvrW9l3d99fbUgbN5skm8k2G2xO27yw7WcbZau2XWF71Lajn2W/0H4F/Zb2O9jvkZ2FXbCd0m6p3SG734S9hGJhkbBG2CzstLexj7bX2q+zb7V/5+DikOowy2GXw01HnqPIMddxqWOTY2d/u/4j+k/pv73/r05cJ5FTvtNypxanV84uzunOXznXOz906eMS41Lust3lhquxa4jreNf1rhcHsAeIBhQOWD3grBvp5uuW71brdsaddPdzV7qvdj83kDUwYKBq4PqBVzyMPMQeZR7bPW4PshwUN2jWoPpBTwb3H5w1eNHglsEfPX09izw3el4fYj5k+JBZQxqH/Onl5iXzqvW66G3sHek93bvB+6mPu4/CZ43PVV8L3xG+X/k2+X7w8/dj/Hb6PfLv75/tv8r/ikggShTNEx0PYAWEBUwP2B/wZqjfUM3Q3UP/CPQILAzcFvhwmMswxbCNw+4GOQRJg9YFtQULg7ODvwluC7EPkYasD7kT6hgqD90U+kA8QFwg3iF+EuYZxoTtDXslGSqZKjkcToVHhVeGt0aYR6RGrIy4FekQmRe5PbIzyjdqctThaFZ0bPSi6CsxtjGymK0xncP9h08d3hxrFJscuzL2TpxbHBPXOIIcMXzEkhE34p3iVfH1CUiISViScDPRJXF84k8j2SMTR9aOvJ80JGlKUkuyRfK45G3JL1PCUhakXE91TdWmNqXx00anbU17lR6evji9LWNwxtSMU5nWmcrMhixOVlrWpqwXoyJGLRvVPtp3dMXoy2Ncxkwcc2Ks9diisQfG8cdJx+3JZmWnZ2/Lfi9NkK6XvsiJyVmV0ymTyJbLHstD5UvljxRBisWKB7lBuYtzH+YF5S3Je5Qfkl+d36GUKFcqnxZEF6wteFWYULi5sKsovWhXsUFxdvE+lbmqUNVc0q9kYsk5tbu6Qt02fuj4ZeM7mVhmUylROqa0QSPQqDWnta7aL7W3y4LLasteT0ibsGei2UTVxNOT3CbNnfSgPLL828n0ZNnkpin2U2ZOuT1VPHXdNGJazrSm6Y7TZ09vnxE1Y8tM3szCmb/M8py1eNbzL9K/aJxtO3vG7LtfRn25vcKkgqm48lXgV2vn0HOUc1rnes9dMfdjpbzyZJVnVXXV+3myeSe/HvJ1zddd83Pnty7wW7BmIXuhauHlRSGLtiw2W1y++O6SEUvqlgqXVi59vmzcshPVPtVrl/OWa5e31cTVNKzov2Lhivcr81deqg2r3bXKZtXcVa9Wy1efXxO6Zuda27VVa99+o/zm6rqodXXrnddXb2BvKNtwf2PaxpZvRd9u3WS9qWrTh82qzW1bkrY0b/XfunWbzbYF28nt2u2Pdozecfa78O8adnrsXLfLclfV9/he+/1vP2T/cHl37O6mPaI9O390+nHVXou9lXVE3aS6zvr8+raGzIZz+4bva2oMbNz706CfNu+33197oNeBBQd5B2cf7DpUfujFYfXhjiN5R+42jWu6fjTj6MXmkc2tx2KPHf858uejLeKWQ8eDju8/MfTEvpOik/Wn/E7VnfY9vfcX31/2tvq11p3xP9NwNuBs47lh5w6eDzl/5EL4hZ8vxlw8dSn+0rnLqZevXhl9pe2q/OrDa0XXnv5a9uu76zNusG5U3jS9WX3L5tb6fw341642v7YDt8Nvn76TfOf6Xdndx/dK771vn33f+H71A7sHWx96Pdz/KPLR2d9G/db+WP34XUfF72a/r3ri+uTHP0L/ON2Z0dn+lHna9ee8Z1bPNj/3ed70IvHFrZfFL9+9qnxt9XrLG9Gblrfpbx+8m/Ce877mw4APjR9jP97oKu7qUksZKQCAAkDm5gJ/bgaMMwGLswBvlG7nAwAQuj0V0P0H+c++bi8EAPgBGw4DKTOABABrQwHnGQA/FEgEkBIK0tu756O30lxvLx2XEQOwXnd1PbMFOI3AB6ar693qrq4PGwHqGnB4vG7XBAC2KfCNGAAub5o7A5+Zbg/9ZMbPT4D09vbB5+e/AZW2hXuygWsqAAAACXBIWXMAAAsTAAALEwEAmpwYAAAF7WlUWHRYTUw6Y29tLmFkb2JlLnhtcAAAAAAAPD94cGFja2V0IGJlZ2luPSLvu78iIGlkPSJXNU0wTXBDZWhpSHpyZVN6TlRjemtjOWQiPz4gPHg6eG1wbWV0YSB4bWxuczp4PSJhZG9iZTpuczptZXRhLyIgeDp4bXB0az0iQWRvYmUgWE1QIENvcmUgNS42LWMxNDggNzkuMTY0MDM2LCAyMDE5LzA4LzEzLTAxOjA2OjU3ICAgICAgICAiPiA8cmRmOlJERiB4bWxuczpyZGY9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkvMDIvMjItcmRmLXN5bnRheC1ucyMiPiA8cmRmOkRlc2NyaXB0aW9uIHJkZjphYm91dD0iIiB4bWxuczp4bXA9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC8iIHhtbG5zOnhtcE1NPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvbW0vIiB4bWxuczpzdEV2dD0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL3NUeXBlL1Jlc291cmNlRXZlbnQjIiB4bWxuczpkYz0iaHR0cDovL3B1cmwub3JnL2RjL2VsZW1lbnRzLzEuMS8iIHhtbG5zOnBob3Rvc2hvcD0iaHR0cDovL25zLmFkb2JlLmNvbS9waG90b3Nob3AvMS4wLyIgeG1wOkNyZWF0b3JUb29sPSJBZG9iZSBQaG90b3Nob3AgMjEuMCAoTWFjaW50b3NoKSIgeG1wOkNyZWF0ZURhdGU9IjIwMjItMDQtMDZUMTM6NDg6MTUrMDg6MDAiIHhtcDpNZXRhZGF0YURhdGU9IjIwMjItMDQtMDZUMTM6NDg6MTUrMDg6MDAiIHhtcDpNb2RpZnlEYXRlPSIyMDIyLTA0LTA2VDEzOjQ4OjE1KzA4OjAwIiB4bXBNTTpJbnN0YW5jZUlEPSJ4bXAuaWlkOjcxYWNlNTdjLWM0OGUtNGMzMC05Njg1LTQ0ZWNkODZhY2U0MiIgeG1wTU06RG9jdW1lbnRJRD0iYWRvYmU6ZG9jaWQ6cGhvdG9zaG9wOjIzNDM3NDUzLWY1ZWMtMGQ0ZC04NGZkLWQwYWIwOTUwMzYwOSIgeG1wTU06T3JpZ2luYWxEb2N1bWVudElEPSJ4bXAuZGlkOjMwZWZkYzYxLTM5OTktNGQ5OS04ZDRlLTk0ZmUyYTYxOWQxZiIgZGM6Zm9ybWF0PSJpbWFnZS9wbmciIHBob3Rvc2hvcDpDb2xvck1vZGU9IjMiIHBob3Rvc2hvcDpJQ0NQcm9maWxlPSJEaXNwbGF5Ij4gPHhtcE1NOkhpc3Rvcnk+IDxyZGY6U2VxPiA8cmRmOmxpIHN0RXZ0OmFjdGlvbj0iY3JlYXRlZCIgc3RFdnQ6aW5zdGFuY2VJRD0ieG1wLmlpZDozMGVmZGM2MS0zOTk5LTRkOTktOGQ0ZS05NGZlMmE2MTlkMWYiIHN0RXZ0OndoZW49IjIwMjItMDQtMDZUMTM6NDg6MTUrMDg6MDAiIHN0RXZ0OnNvZnR3YXJlQWdlbnQ9IkFkb2JlIFBob3Rvc2hvcCAyMS4wIChNYWNpbnRvc2gpIi8+IDxyZGY6bGkgc3RFdnQ6YWN0aW9uPSJzYXZlZCIgc3RFdnQ6aW5zdGFuY2VJRD0ieG1wLmlpZDo3MWFjZTU3Yy1jNDhlLTRjMzAtOTY4NS00NGVjZDg2YWNlNDIiIHN0RXZ0OndoZW49IjIwMjItMDQtMDZUMTM6NDg6MTUrMDg6MDAiIHN0RXZ0OnNvZnR3YXJlQWdlbnQ9IkFkb2JlIFBob3Rvc2hvcCAyMS4wIChNYWNpbnRvc2gpIiBzdEV2dDpjaGFuZ2VkPSIvIi8+IDwvcmRmOlNlcT4gPC94bXBNTTpIaXN0b3J5PiA8L3JkZjpEZXNjcmlwdGlvbj4gPC9yZGY6UkRGPiA8L3g6eG1wbWV0YT4gPD94cGFja2V0IGVuZD0iciI/PmO7V3YAABMFSURBVHic7Z1vaBxFG8B39/4md7nkAjVRmqrVRFtbKwUrlBK1BbVS/SLmw6EGpVeQgjUkFbGHlJoPxVooRkGMIKmQD1G/1EJRbKwx/mlUTEhoUgxpIW3NH83l7jZ3l413+34YHeaduZudmd277r7v/T7d3c49O7vP7swz8zzzjKzrulTB3ig3uwIVjKkoyQFUlOQAKkpyABUlOYCKkhxARUkOoKIkB1BRkgNw0w+vX78+lUqVoR4jIyP33HOPJEm9vb1dXV3ooWg0+s477/AKpMhJpVKbNm1CrwuenUWO5dTU1Fy7do1SwEBJS0tLmUzG0ioVJp/Pgw+apiWTSfRQNpsVEEiRo+t6KpVCj8Kzs8ixnLW1NXoBg+bO4/FYV5kKhTG8yZU+yQH8zypJUfBLc7v/adurq6vT6TR6iNLc2QGDPgnj7NmzGzduNH/Wffv2zczMlFTO3r17L126BD7PzMzs27fv9OnTX331lSRJVVVVFy9erKqqgoW5LioSicRiMRO1/qc+7OX5lLRt27b169dzVqkA6A0yw9jYWDG76JFHHtm0aRP4XFNTI0lSPB6Px+Pgl+3btwuftKGhAUoWA9SHHb7mzipz3KrmhXK1aHOHVTsUCpkx2DRNE/5vwfoY4oA+qa6uzlqBiqKEQiFrZZYUvuYOZWBgYGhoiKWk3+/v7u72+/1iJzpz5szy8rJ5OZB0On3gwAGv1wt/icVijY2NvHKy2WwsFmMcxrW2tra1tfGeAiCupM8//3xgYICxcCwWE7654+Pj4+PjBeWIDbQ1Tevt7UV/iUajYko6efIkY+HFxUVhJYk3d+vWrWMsGQqFSINYAFLO+fPnL/1LJBIRloy+VexwNZvst4tE/E2yA6jp3NDQcBNrUlIcYDhA6E8uZnTV1tbCzxs2bKBLFmjryomT3iTQB6B9UiQSCYfDBQsPDw+///774PPc3JwkSVu3bm1tbS1Y+OOPP/b5fOgvFMnlx2FKwrwGu3btKnYrh4aGMOPz6aef7u7uLli4rq4ukUgwSi4/TmruSLg6fGDHF+S2224zI7nUOFtJXNjqvnPhpObOJPPz85OTk5IkKYrS3NxsyaigPNhOSVjfYCH9/f39/f2SJLnd7j///BM1/2yO7ZS0a9eugwcPgs/xeBzcVgFQWw6TU11dLcuyyXqWE9spqbW1Fd7cTCYjrCTUljMjxw6It8u5XI6xpGGgRTGuX7/OXhirz19//QU/X7lyxZL6kLCLYr9dJOJvUiAQYJy5qqmpYW9eNE2D88rQRydQn0AgAD+7XC70EFd9KMiyXF9fz+gcQuvDi7iSuru733zzTZaSsiwHg0FGsX19fXDEyuUbxOqDGtzNzc2zs7Ni9aEQDAYnJycZl0qaGQCIK8nv95t37ZBks1kxtymlPiXy8smyzOsIF8N2YwUHDV/KRuWOOAA+JVkV5ePo1wXG7wnDexv5zrdnzx5sSl8MrqA7GOemquru3btVVS1YrLu7Gx0ModFxWJxbMBgcHBwUth1g/J4wq6urXOX5lGRJRCMvaJyby+UqVuzKlStgag5+hZ8zmQx6SDI3akHj98qDA5od6HJNJpMUexdrQ9CvWOsaCoWcNS3kACVRuOOOO+Bny8Pz7IPt5u642L9/P/SfMgYBOhG7KAlOLvz999/YIUpYL2XaFP0XNnORTqexZpOM36PUp/zI9FmNy5cvl2dZyMaNG4HdGI/HQdwIJBwOg2ieZDLZ1NREn4+A6z7gvyRJWl1dRU0e0uk3MzODWVyU+liOoijFFoMCDJRkK1iUNDs7a8m6D1vhbMOBxD4hPhZi0Cf19vbSV3oUjE8T8KiKxbmh/xoaGhofHz9+/HixSEfoq9U0ra+vD70uxrNj1+X1etvb29Hp7f7+foEhlNfrjUajtBI6FcPJ49HRUfJfo6OjvBUtKAcjkUhg9QEmAODIkSP0Uzz77LOgJHkfWc5e8Lri8ThaQGzaLBQK0c9rtrkr6CYR8J2IuVuuXr0KP1PC6gC33HIL+EB6LhjPjhUjFxCg4zYLMaskqxwq5XHMWIssy5iySzRxbHacNDY2BvzHqMl7E+WUk1wu9/PPP6MTtaVKTEJvDdkdmtFolNJ2s4PKwaD3JYZLtNra2kBJsm+7dOkS/T4A4HJ2azHskwzepGg0ii43pFgvaHvd0NAAY+cMAVZZQTkYfr+/s7MTrQ+6JumZZ56hL9QqtqSipEC7cXx8HJu4gtamcRQCyxME2bZtWzE5Bw8e5BIFwawyYTnslPNNgvYnuXT1yJEjjBXm6+hWVlaKHdJFZy6wGQRhOWZgTKEkkGkJhg4uLi5ih9DIQDp8hkM4HC7WS7lcLux2e71e8CLruq6qarG7D5qvYDAITCNSDgX4L5PE43HspFCycBwgJjmXy2G3jj0Sj09Jg4ODxeZb+/r6mpqa0F9gfjlVVbH8cijgFgwODoJJRlIOhR9//LGlpYW9/rIsy3KB6crdu3djyoYZ8ITjADHJ7e3taOyfxDM05FMSJS6AfANg26jrumHePPiOcr1J6XSaPRse0JDL5SJ952TcBCwjHAeISSbfJHYs8yeRjycaj+DxeOhKgkHVXH1SOp1mjPKFGnK73SwB3NC/btX41IzD3i5OP0a8Xu+JEyeee+65+vp6gb/n8/l0Op1IJG6KeSKMZUriyi9HAqcm6S3122+//corr5C/ZzKZn3766bvvvrtx44bH42lpadmzZ8/mzZvJSgaDwXw+bzg1wFgfdsxE6/E5/ej55fbv3w8+gzg3OMFTVVXV29tbbIYYxMuxeEIDgcDS0hJ51zRN++23386cOXPhwoW5uTm3293S0rJ37969e/feeeedpJxEIvHrr7+Gw2Gvx6MQMWKG9WHMd4fFAZLTXRx587iGgRSn58svvwyLYWYM/SwdHR1MFS0yfXL16tVjx45t3boVPKqw6Q8Gg48//vgnn3ySSqXIf83Nzamqura2JlCfjo4OlntlKOell15ikaMbTgthmMkvV8y2YU8fpxMv/cTExBtvvPHFF1+QZVRV/fLLL7///vupqamuri4s4CuVTBYbphjWh7HChsXYnU+W9UnoXcDcKvSVJ8LxctPT0x0dHV9//TWljKqqJ0+elGX58OHD/7XEzMT6JMYKGxZjv3DLlASz0knEyJzML4ciFi93/fr1U6dO0TUEyGazPT09TU1NBw4cgD8ePnw4EAi4XC7QAHDlu6Pk3+vu7oYdmOF1oXIMstMzNosAk7lHTeJ2u2FNPvjgAy6305NPPoleCHYUdXmwz99LhPtcbM1lyd3nZ8+eBenmSEMlEomAQyMjI2aWP0YikfHx8V9++eWbb76BP547d255eVlhZmpqCpWJ3U0xO5t0nxumAxPDbHMH8xuTxi7jaghDGhoa7r333mw2i9ojO3fu3LBhg6IowJwDM3L5fB5O58iy7PP5wCSQpmmYVszUp/zwKYl84uCNI4eHqPViZlKkYKKArq4ucvi8trYGqiHLciAQUBQlnU77fD5FUYqtagKgbwB7phTSZC1RrCtf3N38/Dy7aJhxLpvNYtOgXFF20KOKzrlduHBhcXERzMiBQ4qiPPTQQ/CFnp6ePnfu3PT0dFNT0xNPPLFlyxZUJhZUjEbrDQ8Po4coWfIURenp6UGflRdffLHYArESemYNJ26hT/O9994zOBMCGi/HwtraWiqVmpqagr88/PDDdXV1oVAoFArV1tYGg8FQKPTuu+/mcjld14eHh3fu3Anee4/H88ADD3z22WeoQPaq0v2nWOHl5eViJcvnmbUKNF6OHQVpM1dWVpaXl5PJZDKZTCQSqqqmUqlcLqcoyh9//PHWW2/98MMPoA1YW1sbHR3t6ekRqyolnI9s7m7cuFGs8MLCArtkDMvi7riCN8Wi7ILIv/x+P9ZBQkfw2NjYxYsXsf+WYiEpuWKQcl1m1oRbFneH5e9h/BcETmiiwCUruVxudXV1YWHh1ltvpUvWdX15eZlcVGTJAh5sCY2qqpj/kLwuCNf9wTCrJK7dSyj/mpiYuO+++7Afp6ensQ4fdgP5fB7rEnRdz+fzsizfddddtbW1mDknnLwFDSAh64PBdTfI0JRi8MXdoWDxchQriFzFQFLQAUrximqahr0u4G2TJOn+++9vb28/ceIEtAa9Xu+jjz6KFvZ4PKitSLE20Ysy46Ul7w97HKCBkihzSrFYDFUSJVewJEmffvqp+c1SUDZv3gxGQmA8m8lk3G737bffruu6z+fr7Oz0eDwDAwNzc3Pr1q176qmnsLUlVVVVqJI++ugjq/KIFIN+f+iIN3eYcUKxVTKZjGGXwBvS1tfXRzlaX19/9OjRo0ePFiuAPTHXrl1rbm7mqgAvZqJZShLjkM/n0S4BuN3QAmi8XDab1TQNxqdBI60gS0tLYtENKLlcLhwOq6oKbTNss0wUen0wyOuCh8ioIw7JjOMpEmy2GA0PnpqaCiGQSQBHRkYS/wIaIjAaDYVCnZ2dUA4Z1nvq1CnhCkNSyeTs7OzCwkI8Hgd12L59e6gI9PpgkNeFqoQimU5J3qRcLkd/u9FIWPA0wTePEsksSdJrr70my/Lzzz8vtjYWRAutalp9fb3X63W5XODpobxJ9PpgkNcF0TQNa2PZJZdESYbTqWinjXVX9PlpTdMOHTp06NAh8PXbb79l7EvQuLuqqiqPx4OaapRQHq75csp1mZHssLg7jEAgwD55AfUEHLJwctb+iCuJ8vQZPkSovWtGjs/n4xqlyv8iMXtP0OoZmumM1wVgH5MYCNqxY0cxTwzFd3L33XejfSyZpw7Nm2dGDmi+wGcszo1EbH9YNLudYZ46ynWRZ2fvVg2UdPnyZQED3+fzYdEQWPvLON1pKAcFy3dXsADLSTG4sttRrsvM7rTlcFXQ89RZJYerLSo/ZiZcbJe2hhKNZtUGjo7DdtYdGr+HoWmaYeD//ySWKYnyOuu6zn5z0V1lDUHNP2sncC3HTPUMlDQyMsLoLqPYKjU1NRMTE4xy+vv7i80Wk1mI0S1Mjx07hsbIU+SwAPPmUSCtTcq/zKQPM1ASPVkeI4ZJ91AKLlYBuFyuBx98sNjRxsZGNKaVIocFGE9IB7M2Gf/Fi+36YcqwSdd19vEAGQfItfUYyypP0tpkXBvKi9l8d1YBfaNcO5GRGVpYdp4l89RRoMTLlQ/6JHkpNkspSMGMc5i5EQqFwHJXCDn0gXLocYBYoD05zITxhGTHBvPmCWdW4cUuzV3B59owPI/ML8fyfnCNt8hxG8ybVzbsoqSCYDPcLPnlxOIAraJEWftsN5hFFxJjU2Es+eXE4gCtghJ3R8HQ+rWdkk6fPv3qq68WPKSq6o4dO+h/Z4l8SyaT7LGS5L63lHg5sShE0NdSCvApSSznMAklbx7phqFkIaZAscG4NrpDrU3ATcibR7crKNmDzUDmzaOszkBXH7AvBmZfs6BTrTsKpHUnhsXLMcVWQ5Bwjb3gfGsymWTfHsrkFkcscYAC6e/EEO+TsLgyCmDLUPMBBVz7ulLy77FAZsAjIeMJKVDObmgTiispFov19vaylKypqZmcnDRvnnLt60rJv8cCmQGPRNd1+ipPlPb29mJnN3x8xZW0srLCOJMGssMInwjCta8rJf8eC+x3nxG/3y/cgYkPZtnDxsrWdqOQj8XNXXFuZoGUrWccKgBspySunci45JjfH9YMZs5uuxmHF1544bHHHkN/gcNnLk8oKgfk34MRdCb3mYXQ5WBxgJTdaYPB4MjICOVEtlNSOBwuNqkB5u7QXygJIFE5wNxAI+jM7DMLoXuK0ez/EjV+z9CgsF1zR0F4lxUy/54lUeA61VNsobPUSUoS3q+oRNsa0bFw31vbNXcoc3NzqGOUjLtD95mlULZdsLny3bFjayXNz8+DqIRi8O4cCGDZZ1ZMzvHjx7mGzIzYurnDfOHACrqEYBgahwLz701MTGAzF+fPn4cyI5GIsBwy3x1jPkD6GW39JmGQ1hSXj5yyrgFVNmaVcckhYcwHSEf8TWJP6MHlCUXBHsxEIoGFiXO5TgrmzSMxk4WYDIOBXSY5nLJsERkFw52/IFyeUDTODXTCaF44TM7rr7/OngcQelS59plFPbwgDhDG75GQ+QBhJj1TdgTdJ1iiuDKuODcuHysL9L0BMWc5enZr13Sw77lmO8OBHF6w54VjhGufWfTsVjmmeeFTklVxZf+fa8EwSrXJlVhcGYnYuCSfz//+++/Cjhm77WA7Pz8PFvlaHHcnFldmFalUasuWLaQPgpFoNPrhhx9KkpTP57E5N9SIwKxW9Ku1axf6+/vBYNziuLubiyzL1dXVwumuYPPCtV8tGmVnZv9cMzhJSVZB3xuira2t2ObPjY2N7EmbsXyAZjDowFm2v6tQEHaj1PAmG7xJ7HFuJoH2Hkg5hh6CA1iuaCES4TSswqdjDA8yvCi+7eIq3BQq4xUHUFGSA6goyQFUlOQAKkpyABUlOYCKkhxARUkOoKIkB/Aff5OOtRT+PbYAAAAASUVORK5CYII="

/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "img/img18.eeaf7c5.png";

/***/ }),
/* 57 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__resources__ = __webpack_require__(97);



/* unused harmony default export */ var _unused_webpack_default_export = ({
  test: function test() {
    return __WEBPACK_IMPORTED_MODULE_0__resources__["a" /* default */].get('blog/1/show');
  }
});

/***/ }),
/* 58 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function uaredirect(f) {
  try {
    if (document.getElementById("bdmark") != null) {
      return;
    }
    var b = false;
    if (arguments[1]) {
      var e = window.location.host;
      var a = window.location.href;
      if (isSubdomain(arguments[1], e) == 1) {
        f = f + "/#m/" + a;
        b = true;
      } else {
        if (isSubdomain(arguments[1], e) == 2) {
          f = f + "/#m/" + a;
          b = true;
        } else {
          f = a;
          b = false;
        }
      }
    } else {
      b = true;
    }
    if (b) {
      var c = window.location.hash;
      if (!c.match("fromapp")) {
        if (navigator.userAgent.match(/(iPhone|iPod|Android|ios)/i)) {
          location.replace(f);
        }
      }
    }
  } catch (d) {}
}
function isSubdomain(c, d) {
  this.getdomain = function (f) {
    var e = f.indexOf("://");
    if (e > 0) {
      var h = f.substr(e + 3);
    } else {
      var h = f;
    }
    var g = /^www\./;
    if (g.test(h)) {
      h = h.substr(4);
    }
    return h;
  };
  if (c == d) {
    return 1;
  } else {
    var c = this.getdomain(c);
    var b = this.getdomain(d);
    if (c == b) {
      return 1;
    } else {
      c = c.replace(".", "\\.");
      var a = new RegExp("\\." + c + "$");
      if (b.match(a)) {
        return 2;
      } else {
        return 0;
      }
    }
  }
}
/* harmony default export */ __webpack_exports__["a"] = ({
  uaredirect: uaredirect
});

/***/ }),
/* 59 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(455);



__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  mode: "history",
  scrollBehavior: function scrollBehavior() {
    return { y: 0 };
  },
  routes: [{ path: "/index", component: __webpack_require__(436) }, { path: "/findUs", component: __webpack_require__(435) }, { path: "/lifeHome", component: __webpack_require__(437) }, { path: "/serviceRules", component: __webpack_require__(438) }, { path: "/contactUs", component: __webpack_require__(434) }, { path: "/case1", component: __webpack_require__(426) }, { path: "/case2", component: __webpack_require__(427) }, { path: "/case3", component: __webpack_require__(428) }, { path: "/case4", component: __webpack_require__(429) }, { path: "/case5", component: __webpack_require__(430) }, { path: "/case6", component: __webpack_require__(431) }, { path: "/case7", component: __webpack_require__(432) }, { path: "/case8", component: __webpack_require__(433) }, { path: "*", redirect: "/index" }]
}));

/***/ }),
/* 60 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 61 */,
/* 62 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(158)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(81),
  /* template */
  __webpack_require__(454),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_header_vue__ = __webpack_require__(425);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_header_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_header_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_footer_vue__ = __webpack_require__(424);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_footer_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_footer_vue__);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'app',
  components: {
    DwHeader: __WEBPACK_IMPORTED_MODULE_0__components_header_vue___default.a,
    DwFooter: __WEBPACK_IMPORTED_MODULE_1__components_footer_vue___default.a
  }
});

/***/ }),
/* 82 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {};
  },

  methods: {
    clickLable: function clickLable(el) {
      this.$bus.$emit('scrollTopFn', el);
    }
  }
});

/***/ }),
/* 83 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {};
  }
});

/***/ }),
/* 84 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      scrollTop: false
    };
  },
  mounted: function mounted() {
    window.addEventListener("scroll", this.showbtn, true);
  },

  methods: {
    showbtn: function showbtn() {
      var that = this;
      var scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
      that.scrollTop = scrollTop;
    },
    backtop: function backtop() {
      var timer = setInterval(function () {
        var osTop = document.documentElement.scrollTop || document.body.scrollTop;
        var ispeed = Math.floor(-osTop / 5);
        document.documentElement.scrollTop = document.body.scrollTop = osTop + ispeed;
        if (osTop === 0) {
          clearInterval(timer);
        }
      }, 30);
    }
  }
});

/***/ }),
/* 85 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      scrollTop: false
    };
  },
  mounted: function mounted() {
    window.addEventListener("scroll", this.showbtn, true);
  },

  methods: {
    showbtn: function showbtn() {
      var that = this;
      var scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
      that.scrollTop = scrollTop;
    },
    backtop: function backtop() {
      var timer = setInterval(function () {
        var osTop = document.documentElement.scrollTop || document.body.scrollTop;
        var ispeed = Math.floor(-osTop / 5);
        document.documentElement.scrollTop = document.body.scrollTop = osTop + ispeed;
        if (osTop === 0) {
          clearInterval(timer);
        }
      }, 30);
    }
  }
});

/***/ }),
/* 86 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      scrollTop: false
    };
  },
  mounted: function mounted() {
    window.addEventListener("scroll", this.showbtn, true);
  },

  methods: {
    showbtn: function showbtn() {
      var that = this;
      var scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
      that.scrollTop = scrollTop;
    },
    backtop: function backtop() {
      var timer = setInterval(function () {
        var osTop = document.documentElement.scrollTop || document.body.scrollTop;
        var ispeed = Math.floor(-osTop / 5);
        document.documentElement.scrollTop = document.body.scrollTop = osTop + ispeed;
        if (osTop === 0) {
          clearInterval(timer);
        }
      }, 30);
    }
  }
});

/***/ }),
/* 87 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      scrollTop: false
    };
  },
  mounted: function mounted() {
    window.addEventListener("scroll", this.showbtn, true);
  },

  methods: {
    showbtn: function showbtn() {
      var that = this;
      var scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
      that.scrollTop = scrollTop;
    },
    backtop: function backtop() {
      var timer = setInterval(function () {
        var osTop = document.documentElement.scrollTop || document.body.scrollTop;
        var ispeed = Math.floor(-osTop / 5);
        document.documentElement.scrollTop = document.body.scrollTop = osTop + ispeed;
        if (osTop === 0) {
          clearInterval(timer);
        }
      }, 30);
    }
  }
});

/***/ }),
/* 88 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      scrollTop: false
    };
  },
  mounted: function mounted() {
    window.addEventListener("scroll", this.showbtn, true);
  },

  methods: {
    showbtn: function showbtn() {
      var that = this;
      var scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
      that.scrollTop = scrollTop;
    },
    backtop: function backtop() {
      var timer = setInterval(function () {
        var osTop = document.documentElement.scrollTop || document.body.scrollTop;
        var ispeed = Math.floor(-osTop / 5);
        document.documentElement.scrollTop = document.body.scrollTop = osTop + ispeed;
        if (osTop === 0) {
          clearInterval(timer);
        }
      }, 30);
    }
  }
});

/***/ }),
/* 89 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      scrollTop: false
    };
  },
  mounted: function mounted() {
    window.addEventListener("scroll", this.showbtn, true);
  },

  methods: {
    showbtn: function showbtn() {
      var that = this;
      var scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
      that.scrollTop = scrollTop;
    },
    backtop: function backtop() {
      var timer = setInterval(function () {
        var osTop = document.documentElement.scrollTop || document.body.scrollTop;
        var ispeed = Math.floor(-osTop / 5);
        document.documentElement.scrollTop = document.body.scrollTop = osTop + ispeed;
        if (osTop === 0) {
          clearInterval(timer);
        }
      }, 30);
    }
  }
});

/***/ }),
/* 90 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      scrollTop: false
    };
  },
  mounted: function mounted() {
    window.addEventListener("scroll", this.showbtn, true);
  },

  methods: {
    showbtn: function showbtn() {
      var that = this;
      var scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
      that.scrollTop = scrollTop;
    },
    backtop: function backtop() {
      var timer = setInterval(function () {
        var osTop = document.documentElement.scrollTop || document.body.scrollTop;
        var ispeed = Math.floor(-osTop / 5);
        document.documentElement.scrollTop = document.body.scrollTop = osTop + ispeed;
        if (osTop === 0) {
          clearInterval(timer);
        }
      }, 30);
    }
  }
});

/***/ }),
/* 91 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      scrollTop: false
    };
  },
  mounted: function mounted() {
    window.addEventListener("scroll", this.showbtn, true);
  },

  methods: {
    showbtn: function showbtn() {
      var that = this;
      var scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
      that.scrollTop = scrollTop;
    },
    backtop: function backtop() {
      var timer = setInterval(function () {
        var osTop = document.documentElement.scrollTop || document.body.scrollTop;
        var ispeed = Math.floor(-osTop / 5);
        document.documentElement.scrollTop = document.body.scrollTop = osTop + ispeed;
        if (osTop === 0) {
          clearInterval(timer);
        }
      }, 30);
    }
  }
});

/***/ }),
/* 92 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      tabDta: [{
        id: 1,
        text: "合作咨询",
        active: true
      }, {
        id: 2,
        text: "招聘信息",
        active: false
      }],
      currentTab: 1,
      recruitmentData: [{
        title: "采购经理",
        open: true,
        contData: [["岗位职责：", "1、供应商管理：根据货品需求拓展供应商，并根据供应商准入机制进行验厂，商务谈判和合同签订及订单跟进；", "2、供应商运营：统筹供应商的分层运营规划，维护好供应商的合作关系，确保日常运营工作的正常开展。并根据日常运营数据（销量、服务、品质）考核合作供应商，汰换不合格供应商，解决日常售后问题；", "3、货品规划：根据行业趋势和用户需求，确认各个梯队的货品矩阵。补充好货，汰换非畅销商品；", "4、新品开发：统筹所辖风格的新品选品，打样及量产工作；", "5、备货与库存：关注采购备货需求及实时库存情况，避免出现滞销库存。"], ["任职要求：", "1、本科以上学历，3年以上外贸家具零售经验采购经验，优秀者可适当放宽；", "2、对行业整体发展有较强的宏观思考及规划能力；", "3、有较好的用户视角和审美能力；", "4、有较强的商业谈判和解决突然情况的解决问题的能力；", "5、对数据敏感，有一定的逻辑及分析判断能力；", "6、拥抱变化，有良好的抗压性，对家具行业充满热爱；", "7、良好的团队管理能力和沟通技巧，能和不同部门进行沟通及合作。"]]
      }, {
        title: "门店销售",
        open: false,
        contData: [["岗位职责：", "1、提高品牌形象，达成个人销售指标；", "2、店铺陈列及产品的清洁与维护；", "3、负责门店客户的日常接待，产品介绍，维护及跟进；", "4、能为客户提供简单的软装建议；", "5、底薪+提成（多劳多得，提成丰厚）"], ["任职要求：", "1、年龄：22-35岁，学历：大专/本科优先；", "2、有家具家居经验者优先；", "3、有室内设计能力及经验者优先。"]]
      }]
    };
  },

  watch: {
    $route: function $route() {
      var _this = this;

      var currentTab = this.$route.query.currentTab;
      if (currentTab) {
        this.currentTab = this.$route.query.currentTab;
        this.tabDta.forEach(function (val, index) {
          if (val.id == currentTab) {
            val.active = true, _this.currentTab = currentTab;
          } else {
            val.active = false;
          }
        });
      }
    }
  },
  created: function created() {
    var _this2 = this;

    var currentTab = this.$route.query.currentTab;
    if (currentTab) {
      this.currentTab = this.$route.query.currentTab;
      this.tabDta.forEach(function (val, index) {
        if (val.id == currentTab) {
          val.active = true, _this2.currentTab = currentTab;
        } else {
          val.active = false;
        }
      });
    }
  },

  methods: {
    clickTab: function clickTab(i) {
      var _this3 = this;

      this.tabDta.forEach(function (val, index) {
        if (i == index) {
          val.active = true, _this3.currentTab = val.id;
        } else {
          val.active = false;
        }
      });
    },
    clickOpen: function clickOpen(flag, i) {
      this.recruitmentData.forEach(function (val, index) {
        val.open = false;
        if (i == index) {
          val.open = !flag;
        }
      });
    }
  }
});

/***/ }),
/* 93 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      scrollTop: false
    };
  },
  mounted: function mounted() {
    this.$nextTick(function () {
      var mySwiper = new Swiper(".d-swiper1", {
        paginationClickable: true,
        loop: true,
        speed: 500,
        autoplayDisableOnInteraction: false,
        nextButton: ".swiper-button-next",
        prevButton: ".swiper-button-prev",

        effect: "slide",
        onInit: function onInit(swiper) {}
      });
      var mySwiper1 = new Swiper(".d-swiper2", {
        paginationClickable: true,
        loop: true,
        speed: 500,
        autoplayDisableOnInteraction: false,
        nextButton: ".swiper-button-next",
        prevButton: ".swiper-button-prev",

        effect: "slide",
        onInit: function onInit(swiper) {}
      });
    });
    window.addEventListener("scroll", this.showbtn, true);
  },

  methods: {
    showbtn: function showbtn() {
      var that = this;
      var scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
      that.scrollTop = scrollTop;
    },
    backtop: function backtop() {
      var timer = setInterval(function () {
        var osTop = document.documentElement.scrollTop || document.body.scrollTop;
        var ispeed = Math.floor(-osTop / 5);
        document.documentElement.scrollTop = document.body.scrollTop = osTop + ispeed;
        if (osTop === 0) {
          clearInterval(timer);
        }
      }, 30);
    }
  }
});

/***/ }),
/* 94 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      scrollTop: false
    };
  },

  computed: {},
  created: function created() {
    var _this = this;

    this.$bus.$on("scrollTopFn", function (el) {
      _this.goTop(el);
    });
  },
  mounted: function mounted() {
    var _this2 = this;

    this.$nextTick(function () {
      var mySwiper = new Swiper(".swiper-container", {
        paginationClickable: true,
        loop: true,
        speed: 2200,
        autoplay: 2200,
        autoplayDisableOnInteraction: false,
        effect: "fade",
        onInit: function onInit(swiper) {}
      });
      var scrollEl = _this2.$route.query.scrollEl;
      if (scrollEl) {
        _this2.goTop(scrollEl);
      }
    });
    window.addEventListener("scroll", this.showbtn, true);
  },

  methods: {
    goTop: function goTop(el) {
      var top = document.getElementsByClassName(el)[0].offsetTop;
      document.documentElement.scrollTop = top;
    },
    showbtn: function showbtn() {
      var that = this;
      var scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
      that.scrollTop = scrollTop;
    },
    backtop: function backtop() {
      var timer = setInterval(function () {
        var osTop = document.documentElement.scrollTop || document.body.scrollTop;
        var ispeed = Math.floor(-osTop / 5);
        document.documentElement.scrollTop = document.body.scrollTop = osTop + ispeed;
        if (osTop === 0) {
          clearInterval(timer);
        }
      }, 30);
    }
  }
});

/***/ }),
/* 95 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      scrollTop: false
    };
  },
  created: function created() {},
  mounted: function mounted() {
    this.$nextTick(function () {
      var mySwiper = new Swiper(".swiper-container", {
        paginationClickable: true,
        loop: true,
        speed: 500,

        autoplayDisableOnInteraction: false,
        nextButton: ".swiper-button-next",
        prevButton: ".swiper-button-prev",

        effect: "slide",
        onInit: function onInit(swiper) {}
      });
    });
    window.addEventListener("scroll", this.showbtn, true);
  },

  methods: {
    showbtn: function showbtn() {
      var that = this;
      var scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
      that.scrollTop = scrollTop;
    },
    backtop: function backtop() {
      var timer = setInterval(function () {
        var osTop = document.documentElement.scrollTop || document.body.scrollTop;
        var ispeed = Math.floor(-osTop / 5);
        document.documentElement.scrollTop = document.body.scrollTop = osTop + ispeed;
        if (osTop === 0) {
          clearInterval(timer);
        }
      }, 30);
    }
  }
});

/***/ }),
/* 96 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      tabDta: [{
        id: 1,
        text: "配送说明",
        active: true
      }, {
        id: 2,
        text: "售后服务",
        active: false
      }, {
        id: 3,
        text: "常见问题",
        active: false
      }],
      currentTab: 1
    };
  },

  watch: {
    $route: function $route() {
      var _this = this;

      var currentTab = this.$route.query.currentTab;
      if (currentTab) {
        this.currentTab = this.$route.query.currentTab;
        this.tabDta.forEach(function (val, index) {
          if (val.id == currentTab) {
            val.active = true, _this.currentTab = currentTab;
          } else {
            val.active = false;
          }
        });
      }
    }
  },
  created: function created() {
    var _this2 = this;

    var currentTab = this.$route.query.currentTab;
    if (currentTab) {
      this.currentTab = this.$route.query.currentTab;
      this.tabDta.forEach(function (val, index) {
        if (val.id == currentTab) {
          val.active = true, _this2.currentTab = currentTab;
        } else {
          val.active = false;
        }
      });
    }
  },

  methods: {
    clickTab: function clickTab(i) {
      var _this3 = this;

      this.tabDta.forEach(function (val, index) {
        if (i == index) {
          val.active = true, _this3.currentTab = val.id;
        } else {
          val.active = false;
        }
      });
    }
  }
});

/***/ }),
/* 97 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_qs__ = __webpack_require__(159);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_qs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_qs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_common_app__ = __webpack_require__(28);




var host = __WEBPACK_IMPORTED_MODULE_3_common_app__["a" /* default */].isProd ? '正' : '测';
if (__WEBPACK_IMPORTED_MODULE_3_common_app__["a" /* default */].isLocal) host = 'http://127.0.0.1:3001';
__WEBPACK_IMPORTED_MODULE_1_axios___default.a.defaults.baseURL = host;
__WEBPACK_IMPORTED_MODULE_1_axios___default.a.defaults.timeout = 10000;
__WEBPACK_IMPORTED_MODULE_1_axios___default.a.defaults.withCredentials = true;
__WEBPACK_IMPORTED_MODULE_1_axios___default.a.defaults.params = {};
__WEBPACK_IMPORTED_MODULE_1_axios___default.a.defaults.validateStatus = function () {
  return true;
};
__WEBPACK_IMPORTED_MODULE_1_axios___default.a.defaults.transformRequest = function (data) {
  return data ? __WEBPACK_IMPORTED_MODULE_2_qs___default.a.stringify(JSON.parse(data)) : data;
};

__WEBPACK_IMPORTED_MODULE_1_axios___default.a.interceptors.request.use(function (config) {
  return config;
}, function (error) {
  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
});

__WEBPACK_IMPORTED_MODULE_1_axios___default.a.interceptors.response.use(function (response) {
  return response.data;
}, function (error) {
  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
});

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_1_axios___default.a);

/***/ }),
/* 98 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);




var _class = function () {
  function _class(storage) {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, _class);

    this.storage = storage;
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(_class, [{
    key: 'pre',
    value: function pre(key) {
      var now = new Date();
      var year = now.getFullYear().toString();
      var month = (now.getMonth() + 1).toString();
      var day = now.getDate().toString();
      var date = year + month + day;
      return key + '__' + date;
    }
  }, {
    key: 'get',
    value: function get() {
      var key = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

      var value = JSON.parse(this.storage.getItem(this.pre(key)));
      if (value) return value.data;
      return null;
    }
  }, {
    key: 'set',
    value: function set(key, value) {
      this.storage.setItem(this.pre(key), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()({ data: value }));
    }
  }, {
    key: 'remove',
    value: function remove(key) {
      this.storage.removeItem(this.pre(key));
    }
  }]);

  return _class;
}();

/* harmony default export */ __webpack_exports__["a"] = (_class);

/***/ }),
/* 99 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api___ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_app__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__router__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_swiper__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_swiper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_swiper__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_swiper_dist_css_swiper_min_css__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_swiper_dist_css_swiper_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_swiper_dist_css_swiper_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__plugin_uaredirect_js__ = __webpack_require__(58);










__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].prototype.$bus = new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]();

new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_4__router__["a" /* default */],
  template: '<app/>',
  components: { app: __WEBPACK_IMPORTED_MODULE_1__App___default.a }
});

__WEBPACK_IMPORTED_MODULE_7__plugin_uaredirect_js__["a" /* default */].uaredirect("https://m.dwnest.com/index");
document.querySelector("html").style.fontSize = document.body.clientWidth / 1920 * 32 + 'px';
window.onresize = function () {
  document.querySelector("html").style.fontSize = document.body.clientWidth / 1920 * 32 + 'px';
};

/***/ }),
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 144 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 145 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 146 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 147 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 148 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 149 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 150 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 151 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 152 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 153 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 154 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 155 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 156 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 157 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 158 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "img/img1.00c50e1.png";

/***/ }),
/* 165 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "img/img10.669c780.png";

/***/ }),
/* 166 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "img/img11.3871295.png";

/***/ }),
/* 167 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "img/img12.3c1d487.png";

/***/ }),
/* 168 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "img/img13.86cae99.png";

/***/ }),
/* 169 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "img/img14.431ff1e.png";

/***/ }),
/* 170 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "img/img15.413adbc.png";

/***/ }),
/* 171 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "img/img16.9e9c4f8.png";

/***/ }),
/* 172 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "img/img17.a12225f.png";

/***/ }),
/* 173 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "img/img18.26464f9.png";

/***/ }),
/* 174 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "img/img19.1ad7961.png";

/***/ }),
/* 175 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "img/img2.2660bc9.png";

/***/ }),
/* 176 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "img/img20.a7d6730.png";

/***/ }),
/* 177 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "img/img21.c8c328b.png";

/***/ }),
/* 178 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "img/img3.9984358.png";

/***/ }),
/* 179 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "img/img4.653ffbb.png";

/***/ }),
/* 180 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "img/img5.191cdcf.png";

/***/ }),
/* 181 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "img/img6.518c672.png";

/***/ }),
/* 182 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "img/img7.0f71e07.png";

/***/ }),
/* 183 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "img/img8.32ce43e.png";

/***/ }),
/* 184 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "img/img9.a772054.png";

/***/ }),
/* 185 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "img/img1.8d6de61.png";

/***/ }),
/* 186 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "img/img10.0ae4ff0.png";

/***/ }),
/* 187 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "img/img11.3552a25.png";

/***/ }),
/* 188 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "img/img12.e5ad05e.png";

/***/ }),
/* 189 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "img/img13.d2ce21a.png";

/***/ }),
/* 190 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "img/img14.fa0cddb.png";

/***/ }),
/* 191 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "img/img15.f1beb0a.png";

/***/ }),
/* 192 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "img/img16.3d5aa91.png";

/***/ }),
/* 193 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "img/img17.897d873.png";

/***/ }),
/* 194 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "img/img18.b0f0172.png";

/***/ }),
/* 195 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "img/img19.76c0e21.png";

/***/ }),
/* 196 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "img/img2.84c4df1.png";

/***/ }),
/* 197 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "img/img20.c3116b1.png";

/***/ }),
/* 198 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "img/img21.b24e4cd.png";

/***/ }),
/* 199 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "img/img22.9a1d819.png";

/***/ }),
/* 200 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "img/img23.b872ab5.png";

/***/ }),
/* 201 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "img/img24.c36c59e.png";

/***/ }),
/* 202 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "img/img25.2dc7b09.png";

/***/ }),
/* 203 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "img/img26.568873d.png";

/***/ }),
/* 204 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "img/img27.4c50df4.png";

/***/ }),
/* 205 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "img/img28.55da459.png";

/***/ }),
/* 206 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "img/img29.534e96e.png";

/***/ }),
/* 207 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "img/img3.65702d2.png";

/***/ }),
/* 208 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "img/img30.0bccebe.png";

/***/ }),
/* 209 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "img/img31.17ba2fc.png";

/***/ }),
/* 210 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "img/img32.b71f710.png";

/***/ }),
/* 211 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "img/img33.addbeb6.png";

/***/ }),
/* 212 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "img/img34.acd9476.png";

/***/ }),
/* 213 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "img/img4.86e1ae3.png";

/***/ }),
/* 214 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "img/img5.8616930.png";

/***/ }),
/* 215 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "img/img6.624e00b.png";

/***/ }),
/* 216 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "img/img7.59ade59.png";

/***/ }),
/* 217 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "img/img8.0e90d9f.png";

/***/ }),
/* 218 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "img/img9.8649f9c.png";

/***/ }),
/* 219 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "img/img1.b2ce737.png";

/***/ }),
/* 220 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "img/img11.0c7c370.png";

/***/ }),
/* 221 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "img/img12.850e69d.png";

/***/ }),
/* 222 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "img/img15.9a34bd3.png";

/***/ }),
/* 223 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "img/img16.d7a1e1f.png";

/***/ }),
/* 224 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "img/img17.8103fdb.png";

/***/ }),
/* 225 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "img/img18.8baf123.png";

/***/ }),
/* 226 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "img/img19.77ea65a.png";

/***/ }),
/* 227 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "img/img3.f24f190.png";

/***/ }),
/* 228 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "img/img4.356b016.png";

/***/ }),
/* 229 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "img/img6.af3a3d3.png";

/***/ }),
/* 230 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "img/img8.3045a5e.png";

/***/ }),
/* 231 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "img/img9.4a22c64.png";

/***/ }),
/* 232 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "img/img10.ca93e48.png";

/***/ }),
/* 233 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "img/img11.3fbbd49.png";

/***/ }),
/* 234 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "img/img2.c7b7f2a.png";

/***/ }),
/* 235 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "img/img3.e41a446.png";

/***/ }),
/* 236 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "img/img5.f29ba1b.png";

/***/ }),
/* 237 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "img/img6.feb6d02.png";

/***/ }),
/* 238 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "img/img7.87ddbe0.png";

/***/ }),
/* 239 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "img/img8.3c51cb9.png";

/***/ }),
/* 240 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "img/img9.cb16a74.png";

/***/ }),
/* 241 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "img/img10.19da3f4.png";

/***/ }),
/* 242 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "img/img2.c5a5f7b.png";

/***/ }),
/* 243 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "img/img3.c786436.png";

/***/ }),
/* 244 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "img/img5.59ba6d1.png";

/***/ }),
/* 245 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "img/img6.b0af42a.png";

/***/ }),
/* 246 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "img/img7.cb5a4d5.png";

/***/ }),
/* 247 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "img/img8.f27f4f2.png";

/***/ }),
/* 248 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "img/img9.3d8ba7d.png";

/***/ }),
/* 249 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "img/img1.a20db35.png";

/***/ }),
/* 250 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "img/img10.8b13306.png";

/***/ }),
/* 251 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "img/img11.43f6c73.png";

/***/ }),
/* 252 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "img/img12.9e2724d.png";

/***/ }),
/* 253 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "img/img13.d78d71d.png";

/***/ }),
/* 254 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "img/img14.4d2fad4.png";

/***/ }),
/* 255 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "img/img15.403902d.png";

/***/ }),
/* 256 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "img/img16.b11fa65.png";

/***/ }),
/* 257 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "img/img17.7aa8921.png";

/***/ }),
/* 258 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "img/img18.bb5aac5.png";

/***/ }),
/* 259 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "img/img19.4fce062.png";

/***/ }),
/* 260 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "img/img2.52534aa.png";

/***/ }),
/* 261 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "img/img20.ba8add0.png";

/***/ }),
/* 262 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "img/img21.0ca88a7.png";

/***/ }),
/* 263 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "img/img22.469881c.png";

/***/ }),
/* 264 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "img/img23.3e58fa5.png";

/***/ }),
/* 265 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "img/img24.f1fe4ce.png";

/***/ }),
/* 266 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "img/img25.7952ecf.png";

/***/ }),
/* 267 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "img/img3.fa2b486.png";

/***/ }),
/* 268 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "img/img4.bc03064.png";

/***/ }),
/* 269 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "img/img5.526789b.png";

/***/ }),
/* 270 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "img/img6.c345844.png";

/***/ }),
/* 271 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "img/img7.a02daa0.png";

/***/ }),
/* 272 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "img/img8.8734abf.png";

/***/ }),
/* 273 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "img/img9.271c22f.png";

/***/ }),
/* 274 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "img/img1.156d41d.png";

/***/ }),
/* 275 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "img/img10.20779c7.jpg";

/***/ }),
/* 276 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "img/img11.d5f6f48.jpg";

/***/ }),
/* 277 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "img/img12.46c6e9e.jpg";

/***/ }),
/* 278 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "img/img13.e3924e1.jpg";

/***/ }),
/* 279 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "img/img14.c9d931e.jpg";

/***/ }),
/* 280 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "img/img15.8fedc2a.jpg";

/***/ }),
/* 281 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "img/img16.2ec489a.jpg";

/***/ }),
/* 282 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "img/img17.2288e5d.jpg";

/***/ }),
/* 283 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "img/img18.850b033.jpg";

/***/ }),
/* 284 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "img/img19.bb82f5c.jpg";

/***/ }),
/* 285 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "img/img2.2a59268.jpg";

/***/ }),
/* 286 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "img/img20.2ec489a.jpg";

/***/ }),
/* 287 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "img/img21.683bc08.jpg";

/***/ }),
/* 288 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "img/img22.75d2d29.jpg";

/***/ }),
/* 289 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "img/img23.1054c8c.jpg";

/***/ }),
/* 290 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "img/img24.c282ea3.jpg";

/***/ }),
/* 291 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "img/img25.3b490ff.jpg";

/***/ }),
/* 292 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "img/img26.697e27c.jpg";

/***/ }),
/* 293 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "img/img27.e719c16.jpg";

/***/ }),
/* 294 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "img/img28.07eaebf.jpg";

/***/ }),
/* 295 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "img/img29.5a79352.jpg";

/***/ }),
/* 296 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "img/img3.5f95edd.jpg";

/***/ }),
/* 297 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "img/img30.c40a7c5.jpg";

/***/ }),
/* 298 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "img/img31.374c8c5.jpg";

/***/ }),
/* 299 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "img/img4.69ad444.png";

/***/ }),
/* 300 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "img/img5.9727c5f.jpg";

/***/ }),
/* 301 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "img/img6.2d41846.jpg";

/***/ }),
/* 302 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "img/img7.bd2decf.jpg";

/***/ }),
/* 303 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "img/img8.c783693.jpg";

/***/ }),
/* 304 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "img/img9.192f715.jpg";

/***/ }),
/* 305 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "img/img1.6663ae6.jpg";

/***/ }),
/* 306 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "img/img10.c38d33b.jpg";

/***/ }),
/* 307 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "img/img11.354a9b3.jpg";

/***/ }),
/* 308 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "img/img12.6550ef2.jpg";

/***/ }),
/* 309 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "img/img13.24b5c8d.jpg";

/***/ }),
/* 310 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "img/img14.ab2bd15.jpg";

/***/ }),
/* 311 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "img/img15.83147a4.jpg";

/***/ }),
/* 312 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "img/img16.1392aab.jpg";

/***/ }),
/* 313 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "img/img17.31f521d.jpg";

/***/ }),
/* 314 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "img/img18.cbec04b.jpg";

/***/ }),
/* 315 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "img/img19.2a511e4.jpg";

/***/ }),
/* 316 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "img/img2.7efbb69.jpg";

/***/ }),
/* 317 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "img/img20.331bab8.jpg";

/***/ }),
/* 318 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "img/img21.8607b5a.jpg";

/***/ }),
/* 319 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "img/img22.77a948c.jpg";

/***/ }),
/* 320 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "img/img23.25b4607.jpg";

/***/ }),
/* 321 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "img/img24.5267acb.jpg";

/***/ }),
/* 322 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "img/img25.f757855.jpg";

/***/ }),
/* 323 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "img/img26.a36204c.jpg";

/***/ }),
/* 324 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "img/img27.499563f.jpg";

/***/ }),
/* 325 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "img/img28.201021b.jpg";

/***/ }),
/* 326 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "img/img29.87d031a.jpg";

/***/ }),
/* 327 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "img/img3.6d6d438.jpg";

/***/ }),
/* 328 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "img/img30.bf9ad91.jpg";

/***/ }),
/* 329 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "img/img31.8b6a80c.jpg";

/***/ }),
/* 330 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "img/img32.5d6e46e.jpg";

/***/ }),
/* 331 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "img/img33.78767d7.jpg";

/***/ }),
/* 332 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "img/img34.092a76c.jpg";

/***/ }),
/* 333 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "img/img35.e536c82.jpg";

/***/ }),
/* 334 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "img/img36.7a87c6d.jpg";

/***/ }),
/* 335 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "img/img37.e3ed27b.jpg";

/***/ }),
/* 336 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "img/img38.73df74e.jpg";

/***/ }),
/* 337 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "img/img39.660521d.jpg";

/***/ }),
/* 338 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "img/img4.4de9c7c.jpg";

/***/ }),
/* 339 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "img/img40.d00f24b.jpg";

/***/ }),
/* 340 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "img/img41.492e95d.jpg";

/***/ }),
/* 341 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "img/img5.33e43e5.jpg";

/***/ }),
/* 342 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "img/img6.90715b6.jpg";

/***/ }),
/* 343 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "img/img7.18a51eb.jpg";

/***/ }),
/* 344 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "img/img8.9a435d0.jpg";

/***/ }),
/* 345 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "img/img9.523933f.jpg";

/***/ }),
/* 346 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "img/img1.557f01a.png";

/***/ }),
/* 347 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "img/img2.a3ce1a9.jpg";

/***/ }),
/* 348 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "img/img5.786eb8d.png";

/***/ }),
/* 349 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAOEAAADhCAYAAAA+s9J6AAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAABmGSURBVHhe7dPBji03kgRR/f9P96RjdiaLQZAZLFb15AFs52TyPqn++c/n87nq+yP8fC77/gg/n8u+P8LP57Lvj/Dzuez7I/x8Lvv+CD+fy74/ws/nsu+P8PO57Psj/Hwu+/4IP5/Lvj/Cz+ey74/w87ns+yP8fC77/gg/n8u+P8LP57Lvj/Dzuez7I/x8Lvv+CD+fy74/ws/nsvE/wn/++edXtcvuSmSbKrJNItukG+wdiWxT1WHnbjZp/L+kPfhmu+yuRLapItsksk26wd6RyDZVHXbuZpPG/0vag2+2y+5KZJsqsk0i26Qb7B2JbFPVYeduNmn8v6Q9+Ga77K5Etqki2ySyTbrB3pHINlUddu5mk8b/S9qDb7bL7kpkmyqyTSLbpBvsHYlsU9Vh5242afy/pD34ZmSblcg2byPbVJFtqjrsXCLbrES2udmk2dse9uB0mn0zkW1W6rBzK5Ftqsg2VTfYOxLZJp1m30yTxn+FPTidZt9MZJuVOuzcSmSbKrJN1Q32jkS2SafZN9Ok8V9hD06n2TcT2WalDju3EtmmimxTdYO9I5Ft0mn2zTRp/FfYg9Np9s1Etlmpw86tRLapIttU3WDvSGSbdJp9M00a/xX24ES2WYlsk8g2K5Ft/j9GtlmJbJPINiuRbdKk2dse9uBEtlmJbJM67FwV2SbtsruqyDapw86tRLap6rBziWyzEtkmTZq97WEPTmSblcg2qcPOVZFt0i67q4pskzrs3Epkm6oOO5fINiuRbdKk2dse9uBEtlmJbJM67FwV2SbtsruqyDapw86tRLap6rBziWyzEtkmTZq97WEPTmSblcg2qcPOVZFt0i67q4pskzrs3Epkm6oOO5fINiuRbdKk2dse9uBEtlmJbJPINifaZXediGxzM7JNItusRLZJk2Zve9iDE9lmJbJNIttUkW3SDfaORLZJu+yuE5FtEtlmJbJNmjR728MenMg2K5FtEtmmimyTbrB3JLJN2mV3nYhsk8g2K5Ft0qTZ2x724ES2WYlsk8g2VWSbdIO9I5Ft0i6760Rkm0S2WYlskybN3vawByeyzUpkm0S2qSLbpBvsHYlsk3bZXSci2ySyzUpkmzRp9raHPTiRbVYi2ySyTRXZJnXYuaoOO7cS2eZmZJtEtlmJbJMmzd72sAcnss1KZJvUYefSJLu/apfdlTrs3Il22V2JbLMS2SZNmr3tYQ9OZJuVyDapw86lSXZ/1S67K3XYuRPtsrsS2WYlsk2aNHvbwx6cyDYrkW1Sh51Lk+z+ql12V+qwcyfaZXclss1KZJs0afa2hz04kW1WItukDjuXJtn9VbvsrtRh5060y+5KZJuVyDZp0uxtD3twItusRLZJZJsqsk0V2eanItv8VGSbRLZJZJuVyDZp0uxtD3twOs2+mcg2VWSbqg4797YOO5c67FxVh51LZJt0mn0zTRr/FfbgdJp9M5Ftqsg2VR127m0ddi512LmqDjuXyDbpNPtmmjT+K+zB6TT7ZiLbVJFtqjrs3Ns67FzqsHNVHXYukW3SafbNNGn8V9iD02n2zUS2qSLbVHXYubd12LnUYeeqOuxcItuk0+ybadL4r7AH34xscyKyzYnINiuRbVYi2ySyzc0mzd72sAffjGyTyDaJbJPINolsk8g2iWyTyDaJbJPINolsk8g2N5s0e9vDHnwzsk0i2ySyTSLbJLJNItsksk0i2ySyTSLbJLJNItvcbNLsbQ978M3INolsk8g2iWyTyDaJbJPINolsk8g2iWyTyDaJbHOzSbO3PezBNyPbJLJNItsksk0i2ySyTSLbJLJNItsksk0i2ySyzc0mzd72sAffjGxzIrLNSmSblcg2K5FtEtkmkW1uNmn2tj/K/pET2aaKbLNSh51LHXZuJbJN+vzb96/ysP9ZEtmmimyzUoedSx12biWyTfr82/ev8rD/WRLZpopss1KHnUsddm4lsk36/Nv3r/Kw/1kS2aaKbLNSh51LHXZuJbJN+vzb+L+K/cOfiGzzNrJNFdnmZmSbE5Ftqsg2iWyTyDbptPEv2I84EdnmbWSbdJp9s4psk8g2VWSb1GHnqsg2iWyTyDbptPEv2I84EdnmbWSbdJp9s4psk8g2VWSb1GHnqsg2iWyTyDbptPEv2I84EdnmbWSbdJp9s4psk8g2VWSb1GHnqsg2iWyTyDbptPEv2I84EdnmbWSbdJp9s4psk8g2VWSb1GHnqsg2iWyTyDbptPEv2I84EdnmbWSbtMvuSmSbKrJNItuciGzzNrLNSqed/0LBfmyaZPen38Lelsg2VbvsrpXINolsk8g2qcPOrXTa+S8U7MemSXZ/+i3sbYlsU7XL7lqJbJPINolskzrs3Eqnnf9CwX5smmT3p9/C3pbINlW77K6VyDaJbJPINqnDzq102vkvFOzHpkl2f/ot7G2JbFO1y+5aiWyTyDaJbJM67NxKp53/wsN+WBXZJpFtTrTL7roZ2eZmZJtEtjnRpNnbCvYjUoedS2SbE+2yu262y+6qIttUkW0S2WYlsk2aNHtbwX5E6rBziWxzol1218122V1VZJsqsk0i26xEtkmTZm8r2I9IHXYukW1OtMvuutkuu6uKbFNFtklkm5XINmnS7G0F+xGpw84lss2JdtldN9tld1WRbarINolssxLZJk2ave1hD16JbJPINj9Vh537eh/Z5kSTZm972INXItuk0+ybVbvsrnSaffNtZJsqsk1Vh51LZJt02vgX7EesRLZJp9k3q3bZXek0++bbyDZVZJuqDjuXyDbptPEv2I9YiWyTTrNvVu2yu9Jp9s23kW2qyDZVHXYukW3SaeNfsB+xEtkmnWbfrNpld6XT7JtvI9tUkW2qOuxcItuk08a/YD9iJbLN28g2b+uwc6nDzlWRbW5Gtqki25xo0uxtC+yHJbLN28g2b+uwc6nDzlWRbVKHnavaZXdVkW1WItukSbO3LbAflsg2byPbvK3DzqUOO1dFtkkddq5ql91VRbZZiWyTJs3etsB+WCLbvI1s87YOO5c67FwV2SZ12LmqXXZXFdlmJbJNmjR72wL7YYls8zayzds67FzqsHNVZJvUYeeqdtldVWSblcg2adLsbQvshyWyzV+NbJPINiuRbarINlUddm4lss2JJs3etsB+WCLbpF1210oddi6RbRLZZqUOO5fINlUddq5qkt1fddr5LxTsxyayTdpld63UYecS2SaRbVbqsHOJbFPVYeeqJtn9Vaed/0LBfmwi26RddtdKHXYukW0S2WalDjuXyDZVHXauapLdX3Xa+S8U7Mcmsk3aZXet1GHnEtkmkW1W6rBziWxT1WHnqibZ/VWnjX/BfsRKZJuVyDYrddi5RLZJZJu3kW3eRrZ52y67a6VJs7c97MErkW1WIttU/Rb2tiqyTeqwcyuRbarINmmX3bXSpNnbHvbglcg2K5Ftqn4Le1sV2SZ12LmVyDZVZJu0y+5aadLsbQ978Epkm5XINlW/hb2timyTOuzcSmSbKrJN2mV3rTRp9raHPXglss1KZJuq38LeVkW2SR12biWyTRXZJu2yu1aaNHvbwx68EtlmJbLNb4tsU0W2+W+PbPO2SbO3LbAfljrsXOqwc4ls81ORbdIuu+ttZJvUYecS2SaRbVKHnUuTZm9bYD8sddi51GHnEtnmpyLbpF1219vINqnDziWyTSLbpA47lybN3rbAfljqsHOpw84lss1PRbZJu+yut5FtUoedS2SbRLZJHXYuTZq9bYH9sNRh51KHnUtkm5+KbJN22V1vI9ukDjuXyDaJbJM67FyaNHvbwx68UoedqyLbJLLNT0W2qeqwc28j2ySyTRXZ5m1kmzRp9raHPbhql91VtcvuqjrNvlm1y+5Kp9k3qzrs3EpkmzRp/F/ZHly1y+6q2mV3VZ1m36zaZXel0+ybVR12biWyTZo0/q9sD67aZXdV7bK7qk6zb1btsrvSafbNqg47txLZJk0a/1e2B1ftsruqdtldVafZN6t22V3pNPtmVYedW4lskyaN/yvbg6t22V1VHXZuJbJNFdnmRGSb1GHnUoedW4lsc6JJs7f9UfaPXNVh56rINolssxLZJnXYudRh5xLZJu2yu6pOO/+FP8D+4as67FwV2SaRbVYi26QOO5c67Fwi26RddlfVaee/8AfYP3xVh52rItskss1KZJvUYedSh51LZJu0y+6qOu38F/4A+4ev6rBzVWSbRLZZiWyTOuxc6rBziWyTdtldVaed/0LBfmwi26xEtnkb2aaKbHMisk0V2SaRbarINolsk8g2K02avW2B/bBEtlmJbJPINlUddi6RbVYi26QOO5fINolsU7XL7kpkm5Umzd62wH5YItusRLZJZJuqDjuXyDYrkW1Sh51LZJtEtqnaZXclss1Kk2ZvW2A/LJFtViLbJLJNVYedS2Sblcg2qcPOJbJNIttU7bK7EtlmpUmzty2wH5bINiuRbRLZpqrDziWyzUpkm9Rh5xLZJpFtqnbZXYlss9Kk2dse9uCbkW0S2ebrbmSbKrLNSpNmb3vYg6vINolsk06zb65Etkm77K5EtvmpOuxcIttU7bK70qTZ2x724CqyTSLbpNPsmyuRbdIuuyuRbX6qDjuXyDZVu+yuNGn2toc9uIpsk8g26TT75kpkm7TL7kpkm5+qw84lsk3VLrsrTZq97WEPriLbJLJNOs2+uRLZJu2yuxLZ5qfqsHOJbFO1y+5Kk2Zve9iDf1tkm0S2ORHZ5q9GtjkR2WalSbO3PezBK5FtEtmmimyTyDapw85VkW2qyDaJbJM67FzqsHMrkW0S2WalSbO3PezBK5FtEtmmimyTyDapw85VkW2qyDaJbJM67FzqsHMrkW0S2WalSbO3PezBK5FtEtmmimyTyDapw85VkW2qyDaJbJM67FzqsHMrkW0S2WalSbO3PezBK5FtEtmmimyTyDapw85VkW2qyDaJbJM67FzqsHMrkW0S2WalSbO3PezBX2uRbarINolsU0W2SWSbt5FtTjRp9raHPTh12LmVyDZVZJtEtlmpw85VTbL70y67K5FtUoedqyLbpNPGv2A/InXYuZXINlVkm0S2WanDzlVNsvvTLrsrkW1Sh52rItuk08a/YD8iddi5lcg2VWSbRLZZqcPOVU2y+9MuuyuRbVKHnasi26TTxr9gPyJ12LmVyDZVZJtEtlmpw85VTbL70y67K5FtUoedqyLbpNPGv2A/InXYua8zddi5lcg2K5FtfqpJs7e9ZD82kW2qyDYn6rBzVWSblXbZXVVkm6oOO1dFtllp0uxtL9mPTWSbKrLNiTrsXBXZZqVddlcV2aaqw85VkW1WmjR720v2YxPZpopsc6IOO1dFtllpl91VRbap6rBzVWSblSbN3vaS/dhEtqki25yow85VkW1W2mV3VZFtqjrsXBXZZqVJs7c97MFf/xvZ5quObFNFtllp0p/9I+ywc6nDzqUOO5d22V2JbJPINj9Vh51LN9g70qTxX2YPPlGHnUsddi512Lm0y+5KZJtEtvmpOuxcusHekSaN/zJ78Ik67FzqsHOpw86lXXZXItskss1P1WHn0g32jjRp/JfZg0/UYedSh51LHXYu7bK7EtkmkW1+qg47l26wd6RJ47/MHvzfHtmmqsPOJbJNItv8hTrs3Ikmzd72sAcnss1frcPOpQ47l8g2qcPOVZFtEtmmapfddaJJs7c97MGJbPNX67BzqcPOJbJN6rBzVWSbRLap2mV3nWjS7G0Pe3Ai2/zVOuxc6rBziWyTOuxcFdkmkW2qdtldJ5o0e9vDHpzINn+1DjuXOuxcItukDjtXRbZJZJuqXXbXiSbN3vawByeyzdeZOuzc28g2VbvsrhNNmr3tYQ9OZJtEtqki2ySyTeqwc7+tXXbXSh12Lu2yu9522vgX7Ecksk0i21SRbRLZJnXYud/WLrtrpQ47l3bZXW87bfwL9iMS2SaRbarINolskzrs3G9rl921UoedS7vsrredNv4F+xGJbJPINlVkm0S2SR127re1y+5aqcPOpV1219tOG/+C/YhEtvn6uTrs3Epkm6oOO/dTTZq97WEPTh12LpFt3ka2qdpld1WRbVbqsHOJbJPINlUddi6RbRLZpmrS7G0Pe3DqsHOJbPM2sk3VLrurimyzUoedS2SbRLap6rBziWyTyDZVk2Zve9iDU4edS2Sbt5FtqnbZXVVkm5U67Fwi2ySyTVWHnUtkm0S2qZo0e9vDHpw67Fwi27yNbFO1y+6qItus1GHnEtkmkW2qOuxcItsksk3VpNnbHvbgRLapItu8jWyzUoedqyLb/LdHtklkm0S2qZo0e9vDHpzINlW/mb033WDvSGSbm5Ft0g32jjRp/JfZgxPZpuo3s/emG+wdiWxzM7JNusHekSaN/zJ7cCLbVP1m9t50g70jkW1uRrZJN9g70qTxX2YPTmSbqt/M3ptusHckss3NyDbpBntHmjT+y+zBiWyzEtnmZmSbRLb5+rnINmnS7G0Pe3DqsHNVZJufqsPOJbLNSmSbRLZJZJvUYed+WzeMf9V+WOqwc1Vkm5+qw84lss1KZJtEtklkm9Rh535bN4x/1X5Y6rBzVWSbn6rDziWyzUpkm0S2SWSb1GHnfls3jH/VfljqsHNVZJufqsPOJbLNSmSbRLZJZJvUYed+WzeMf9V+WOqwc1Vkm78Q2eZEZJuVyDZ/oRvufPUi+4dPZJtEtlmJbJM67FzqsHMrkW0S2SbtsrsS2SbdcOerF9k/fCLbJLLNSmSb1GHnUoedW4lsk8g2aZfdlcg26YY7X73I/uET2SaRbVYi26QOO5c67NxKZJtEtkm77K5Etkk33PnqRfYPn8g2iWyzEtkmddi51GHnViLbJLJN2mV3JbJNumH8q/bDbka2SWSbE5Ft3tZh505Etklkm0S2SWSblSbN3vawB9+MbJM67Fwi26RddlfVafbNqg47l8g2iWyTyDYrTZq97WEPvhnZJnXYuUS2SbvsrqrT7JtVHXYukW0S2SaRbVaaNHvbwx58M7JN6rBziWyTdtldVafZN6s67Fwi2ySyTSLbrDRp9raHPfhmZJvUYecS2SbtsruqTrNvVnXYuUS2SWSbRLZZadLsbQ978M3INlVkm7d12LmVyDY/FdkmkW0S2SaRbVaaNHvbwx6cTrNvpg47lzrs3EqT7P5Etnkb2SaRbdIuuyvtsrvSpNnbHvbgdJp9M3XYudRh51aaZPcnss3byDaJbJN22V1pl92VJs3e9rAHp9Psm6nDzqUOO7fSJLs/kW3eRrZJZJu0y+5Ku+yuNGn2toc9OJ1m30wddi512LmVJtn9iWzzNrJNItukXXZX2mV3pUmztz3swYlssxLZJpFtqsg2J9pld339b2SblSbN3vawByeyzUpkm0S2qSLbVHXYuTTJ7k9km9Rh5xLZ5qci21SdNv4F+xGJbLMS2SaRbarINlUddi5NsvsT2SZ12LlEtvmpyDZVp41/wX5EItusRLZJZJsqsk1Vh51Lk+z+RLZJHXYukW1+KrJN1WnjX7Afkcg2K5FtEtmmimxT1WHn0iS7P5FtUoedS2Sbn4psU3Xa+BfsRySyzUpkm0S2qSLbrES2SWSb1GHnViLbVJFt/mqTZm972IMT2WYlsk0i26RJdn/aZXelXXZXFdmmqsPOVXXYuaoOO5cmzd72sAcnss1KZJtEtkmT7P60y+5Ku+yuKrJNVYedq+qwc1Uddi5Nmr3tYQ9OZJuVyDaJbJMm2f1pl92VdtldVWSbqg47V9Vh56o67FyaNHvbwx6cyDYrkW0S2SZNsvvTLrsr7bK7qsg2VR12rqrDzlV12Lk0afa2hz04kW1WItsksk0V2eZtZJu/GtnmbWSbqg47lybN3vawByeyzUpkm0S2qSLbvI1s81ORbao67NzbOuxc6rBzadLsbQ97cCLbrES2SWSbKrLN28g2PxXZpqrDzr2tw86lDjuXJs3e9rAHJ7LNSmSbRLapItu8jWzzU5Ftqjrs3Ns67FzqsHNp0uxtD3twItusRLZJZJsqss3byDY/FdmmqsPOva3DzqUOO5cmzd72sAcnss1KZJtEtrkZ2eYvRLY5UYedSx12Lk2ave1hD06n2TcT2SaRbdIuuyvdYO94G9mmqsPOpQ47lzrsXJo0e9vDHpxOs28msk0i26Rddle6wd7xNrJNVYedSx12LnXYuTRp9raHPTidZt9MZJtEtkm77K50g73jbWSbqg47lzrsXOqwc2nS7G0Pe3A6zb6ZyDaJbJN22V3pBnvH28g2VR12LnXYudRh59Kk2dse9uCbkW0S2WYlsk0V2WYlss3NyDZVHXYukW2qJs3e9rAH34xskzrsXBXZpopss9IuuyuRbVYi26TT7JtVk8Z/mT34ZmSb1GHnqsg2VWSblXbZXYlssxLZJp1m36yaNP7L7ME3I9ukDjtXRbapItustMvuSmSblcg26TT7ZtWk8V9mD74Z2SZ12Lkqsk0V2WalXXZXItusRLZJp9k3qyaN/zJ78M3INqnDzlWRbarINivtsrsS2WYlsk06zb5ZNen8L/t8Pv+n74/w87ns+yP8fC77/gg/n8u+P8LP57Lvj/Dzuez7I/x8Lvv+CD+fy74/ws/nsu+P8PO57Psj/Hwu+/4IP5/Lvj/Cz+ey74/w87ns+yP8fC77/gg/n8u+P8LP57Lvj/Dzuez7I/x8rvrPf/4HyZWSFB0EwaAAAAAASUVORK5CYII="

/***/ }),
/* 350 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "img/swiper1-1.b6af1ca.png";

/***/ }),
/* 351 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "img/swiper1-2.0468b29.png";

/***/ }),
/* 352 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "img/swiper1-3.e1bd6f0.png";

/***/ }),
/* 353 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "img/swiper1-4.573bae9.png";

/***/ }),
/* 354 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "img/swiper2-1.fa2573c.jpg";

/***/ }),
/* 355 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "img/swiper2-3.d027854.jpg";

/***/ }),
/* 356 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "img/swiper2-4.7eafbcb.jpg";

/***/ }),
/* 357 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "img/swiper2-6.5f803f2.jpg";

/***/ }),
/* 358 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "img/logo.ab3dffe.png";

/***/ }),
/* 359 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "img/qrCode.82f0263.jpg";

/***/ }),
/* 360 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "img/logo.34eda4c.png";

/***/ }),
/* 361 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "img/img1.f04d0fa.png";

/***/ }),
/* 362 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "img/img14.e55ce9e.png";

/***/ }),
/* 363 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "img/img15.33e7392.png";

/***/ }),
/* 364 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "img/img19.997286e.jpg";

/***/ }),
/* 365 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "img/img20.fc384ea.jpg";

/***/ }),
/* 366 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "img/img21.7e6e451.png";

/***/ }),
/* 367 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "img/img22.06e623b.png";

/***/ }),
/* 368 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "img/img23.115593b.png";

/***/ }),
/* 369 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "img/img24.1dffa88.jpg";

/***/ }),
/* 370 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "img/img25.1aaa839.png";

/***/ }),
/* 371 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "img/img27.65db417.png";

/***/ }),
/* 372 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "img/img28.d056433.png";

/***/ }),
/* 373 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "img/img29.1194fbb.png";

/***/ }),
/* 374 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "img/img30.d9c76d3.png";

/***/ }),
/* 375 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "img/img4.49b2687.png";

/***/ }),
/* 376 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "img/img5.d955952.png";

/***/ }),
/* 377 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "img/img6.908b4bd.png";

/***/ }),
/* 378 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "img/img7.8dfba51.png";

/***/ }),
/* 379 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEoAAABKCAMAAAArDjJDAAABWVBMVEUAAAA/OzpXU1JBPTxUUVBCPTxEQUBJRURFQUBCPj5STk1PTEtDPz5APDtDQD9EQD9APDtAPDtAPT1DPz5IQUFMTExNSUc/OzpAOzpEQT9EQD9CPj1CPTw/Ozo/Ozo/OztCPDxGQD1HQ0NVVVVEPz9DPz4/Ozo/PDmAgID///9FQT////9WU1KOjIs+Ojmgnp6TkJBDPz5TT05YVFRaV1ZIRENGQkFNSkmbmZhVUVBRTk1KR0b8/Pzv7+5QTEtCPTxpZmX6+vpcWVhMSEe1s7NmY2JPS0pFQUDs6+vz8vK3tbWrqamYlpVkYGBfXFv29vbo5+fDwsK7urq5t7enpaTNzMu+vLxvbGttampsaWj5+fnX1tbR0NCysbCJhob+/v7j4+PZ2diwrq6vrq2Rj45/fHx8eXh0cXBxbm3w8PDd3NzGxcTT0tLHxsa9vLuDgH96d3Z3dHTAv75BBkgtAAAAK3RSTlMAhfz7/vff+/rx/Pvo/PvCezMpHQ0H+2BQ0rWejnRGQCMVEgOxp2lWAgHYVEq85gAAA+lJREFUWMPt1llX2kAYBmBbIrhrW7XWtnaxtrVfGJ0JSchiAonsq4rWDffd7v//okJCEg0w6V0veG9gOIeHJGfeb+jrpZde/sM8f9QtE+/+QQoNPe6SyPh8UOlJP59G28vtE9VZKfIqoPR+hCAkiVVom58y4vTQp0DS5/EhDSGDM3LtpLiCE5xi9j8NQj2KCJsIVWV2O+mXVnHmJM6dXTLh93RpJoS3VhCCY0H+6ZM2sVKEOLec44ZmP9Okp/1iERoU3GIl/kC64dPn0KDgJhN5RJEmw8yValFwksGr4E2WMDtJi4J1HJrpKi3ODkvXYFNQVPCmR6qUpFgObAqW090f/cQAPgaHgnONv3Ek9TcRq+BQ6lcmPNlZmhvN5MFDJXckkm1RUTGzBy4FK2T4Q0fp7aAWBS8FuRhbqlhva4K+Bl4K9vDARAdp6guTUO9TUBXJ7+ZnW1gowH0KVoXQXHtqYVrLwgMK9jJi40r3sXkGDymIyoNv20mvB/A38FGwpgs1OFLkX4d+Kplgvkz5pTejwim0oaAg4FOOTe2Cn4JsenjBJz0blJVoKwcIRd2YJmLRhbsucWXnfQKNffTd3hgbcyMR1htNurdkvIt02Dekwgw6W2olxcaW3JwT1rM6QHrRWbD86Iz/DkeYVAXsfNN1z+TbIl/BzQH7y/McQ8/bblBy5UyoKynagarq+h7YyeOxiQ4jXb5Qwco+xlmXkj1UVLp098lApyH/JiQegJ1tsgyt/CAulcV43/m5yMvOE3RUKTrzMrMCdtbJtkOdSS32mJ+ene92AAo1sJIgRYeSHGol0xphR+Lw+FRfl7wOtSbnd4HP+akiSdg3yg69mKScNwOtWVKS4w61A1auhcx3a/qUmTD1uH8ZsW9hzbmsDYeKyylrNifIyDP6ifphmrc2TllbekDleKF5yclLMhjkTJ0aHxaPmtuJVyoWxdoPaEkrNV4Oz7X+J31BMvliiFQb3zDEmkVxFlVR+D/WlA/N0RC32sZ1g1DSu81+2FQtXW4+MJ7278NfbZUTCx5qV1TWGxXOhD7SAH+1V0056VIFMaYCbLgVpsettiqZp3AncqnGRWlmHuAWNypMjb/aJ6Kk3lGxBnVqsmqzwouBEW+1k7KyalNJIta7V5hS7YLGqRZVN0nyKN2lwl2rPYbzuyK/AfU7SmXTBUqFadWuycZhPVaCvKJlKRWmVfvW5H/UjZIa05a6VJie+btqX8jlE6O0zvM7lArTq60j4dIol2VErTC92oggQxeQSakwPe/CDBIMRPhRSoWDVZsYAqZUOFieDqY5jVLh4NVWaBUOXu2RhcW+Xnrp5X/PX085U+2pI60zAAAAAElFTkSuQmCC"

/***/ }),
/* 380 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEoAAABKCAMAAAArDjJDAAABX1BMVEUAAABTT09BQEBOSUlGRkY/OzlAOztCPTxFQUA/PDtAPDtKR0ZPT08+OjlAPDtDPj6tra1DPz5PS0pIRURFQUBCPz5EQT9CPz4/PDpAPDtBPTxDPj5EQD5CPj5AOzs+OzpAOjpCQD5HR0dEQD9APTs+Ojo/PDo/PDo/Ozs+PjxCPj1FQUBAOztCPjlEPDxDPz0/Ozk/OztDPT3///8+Ojnj4+OAfXzn5+dua2p0cXHAv75XU1NDPz5APDuysbBaVlXQz89nY2NRTkylpKNJRUNHREKWk5NNSklLSEdCPj3NzMzDwsLBv7/7+/tFQUC5t7ecmppPTEtKRkXb29rY19fHxsV6d3dVUVDT0tKrqamjoaGQjo1pZmVjYF9dWlnr6+vIx8fFxMSgnp6LiYhhXVzz8/Pi4eG0srKvrayop6aZl5aTkJCGg4N9enpraGf29vbx8PDKycm7urqxr6+sq6p8o0QxAAAAM3RSTlMA/hD7CoZw9uWl/PsE/Z8aAfz7+/vr0LxYNPru16+OdWEfDt6Ze2ZRQyzzyWg6IsGBSSpz2DXMAAADTUlEQVRYw+3WZ3PaMBjAcQnaQG2zV8hs02Z1t3oyDFJCXFzbUHYYSYDsPTq//xVaSGPODpTmeu0dv9f23zpJJwsNDAz8D+5ZzEy50W946RwFc1zwIerVcxtOwy0kT+gR6snMiFpbKSyZWdg9Z9Lje6gHj2zqforcaj3vm0A9cOKDFOkiQx0u1F0g/ZV0pXI9TL0AsN49JXqne9hQAAukbTeit0RaFvF91EGYDNmvPbtv6UhJoLdinno05ovGr2FrYF6fqq7qRUxTLrsk70U+tG1gPCa0UibMUpYxb75AbliijnBfqamgVe5YrDV+pp/UvWc8jRG9ZetQHykhxLMi6ZLKrOgdGaWEcR+LEPNU75vB/cDPMqRrSlzTSxqknvjZiS7S91xNeOgmuZPUkIeekTtJvRyJb5G7SU1aD1K9pU7e6RU6U85oa1B/vhkeRN/3mFoU9Xb6SJkZpAapv57arhyluqcO15e6pSJ1AKBi4VdKcECF6KVOMQDIF9s3hz+tTx2KVAENGIaz6xSyxzf0pYWoGgcKGqYZ0iY7hvUngyixrUTx886yTPdIU5V/jias5Y83S9tlnH6XSCYiqwprn+0bMmdBTUN8PUUasnmtuAWUycdZGQrNt9LcC2QZzZUOb6Quo1JFhDSUiyUp/vMjSeqfvr4iislYLCHHNxcVLScr9PgKl2KxTF16LCA0y0lSNhlrSQJL1iXAWo4lJPV947WTEuODAvrpIReVAYBpCY19Ial9Jb/LAEDFT8Oo4U2AVyi05Woban6dfFqWlvdUaIhLzDmF2sLjdpttxFrbxGJzhTRIANhsj50u9IPldXDU1sKt7l+Ws827LNDd5lNP7eNzqMOk9ypbviQNMvsMMI8MjUfPRdz80x0B7ADnRkaG/elkmhYa65HWdgAsyNAEvsrmop8IuVAOTlU7MmRx0MwapmJVy2cvcBAZm+NYTMkppbrMIgfSE2TsgU+tVCnOsf0vrLHljLnHcC1RlrFCT89Ux1tkzBXA+Uxx81vsnPEhNzLxglOixcjecaVEPfeRmXDAR7XaKijcqylkanbEC3IVA4YnbmTK5eQ8Vp4bnRTQLeZD4PfyYB9Gt7LMDs3MCagL1/DQwzAaGBj4t3wHetET0nklPHYAAAAASUVORK5CYII="

/***/ }),
/* 381 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 382 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 383 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 384 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 385 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "img/swiper1.c1f53f2.png";

/***/ }),
/* 386 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "img/swiper2.1b97dd0.png";

/***/ }),
/* 387 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "img/swiper3.d69f2d2.png";

/***/ }),
/* 388 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "img/swiper4.04ada01.png";

/***/ }),
/* 389 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEoAAABKCAMAAAArDjJDAAAAjVBMVEUAAABbWFhdWFhZV1dbWVlaWFhaWFhbW1taWVlZWFhZWVlaV1dbWVlbWVlZV1d/f39ZV1dgW1tZWFhZWFhgYGBZV1dnZ2daWFhaV1dZWVlcWVlaWFhaWVlbWVlcW1taV1daWFhaWFhaWFhiYmJZWFhcWlpcWlpaV1daWFhaWFhaWFhcWlpZV1daWFhZV1evLzveAAAALnRSTlMAVzT5b7CLOJB9U9tASvME7Rfn4RDVCMmUTyfCX0UstqeaZQzPLx6gh3OEI712Ci1MYwAAAzJJREFUWMPtltmaojAQhXUCDQiETQRkVxRc+rz/482YAGpDa8T55mb6XBgI8U9VpZLK7Ec/+tdKZQ83Inq9mwayarjFx41UmeIwCVXiY/Wly5GxmUD6hXDE0sBevo4q6HJ0Au1lkkPK0f7YXQn8e6WYpmm0tmjgq7U0O23Ze4TkOSmy+ZJzD7yA9x7RqvNM95+STrRaGIZhyoj+vJnd5FujU+uYhPQZSsKJL5Jb/PmV7e9CsrXzZygVXWD/uLYn4bcDG6wfu2fK0Lg83zQLlNp3CpGbt0qdW5Di4x3Fp560pq6UplKnyDAi6ZEWxq3ST9vts1m297N3pJCme2Rr9o6CuHvCx6MptVAOznUzH9mSlmVxt/TnqKx0AarHlQ2Qc2Ldfz0AoJkQal+DyBuHG2CoHvzofqKmabStCGpOSXiXM4kHeTsYJoBqEHxN65WGav86qkQxsg0j6u4fogploCPU6zG4O/XUX9Q3BoPjK2pMeRcxmQJApTmtXRgR7VHy4ovmbrsXDB92fZhvmgD0yHMhxPHr8MD7PlYSFrwlXtJtVBmxw2Lv+S+EfeUGLTG/yfENqVjIEiTiqAgR847kd/m9QMFaLxdHlZRNX/GAXfUBg0WLbIVRrsyN2AzO9fOlSTEXRTn4ZPXZZu7dm+VcQomjKGrHZ7WL4YnTfilFUSYLyXJwPej7/FwUNcevSyKNXYBIyE9NUZTBcsEZ3Mv6KHmFKOrE7LGIOkC1lhJVFLXiHbE/QEnsfrPHQTivAgY5QBmUFr0FCqM+2bVgyRLyfudIl+bsiW+cNY7crM/7smHr1qUhoThqllOHNdjcknyaXdqarF9AZWATb2OUTp9tNk3bby+ViRomq34haJg61nJ3qOBnDF9R5wEKZCC0XuxkAiZ/Y3HfxwbTHhWoA9XUy9qTJZIaLWnDY5U4Dwfr7sM6qNjUHG7nM9QJ1fnks5jfV3qymVLoZ9uS0OP6atG8gm/MXkZxZTKgq9JCSRMtJ2CFbAqKe3mIweWFqTWbjOKy9kqUZqz2PEe59V+7i8q28xZpR3q3MqInyq+pUiTbvZpieHhHVXYb2t18shbr2Y9+9J/pN+HccviTk2I0AAAAAElFTkSuQmCC"

/***/ }),
/* 390 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEoAAABKCAMAAAArDjJDAAAAh1BMVEUAAABZV1daWFhaV1daV1dZWFhaV1dZWFhaV1deXl5aV1dbWFhcWFhZWFhaWVlaV1daWFhtbW1aWFhZV1daV1dZV1dZWFhaWFhbWlpdWlpfX19oaGhZV1dZV1dZWFhaV1deXl5ZV1daWFhaWFhaWFhaWVlbWFhbWFhaWlpcXFxaWFhdWFhZV1epLKgwAAAALHRSTlMA0YvLvLHC2W8buE49vzf2lgZ15p37j1IxKw4L8OunVRjdiJl9RGhdSSKUJ5cQyXcAAAG4SURBVFjD7dTbkppAFIXhhQgqKkgj5wEFT+PMev/nS7VUpgpDZ2whSWWG7wJuqL+K3RswGv1NWVTxYdVbBiXfCK3Jw6zQyKEiGEPDkgIq1gxaDAcqpg0tU2NMDZxKnXUnJ9FOJbbZzf0is9JJrY6bFvfpVEl6LeLZlGCdDfSChv3pXk07Oel9Kow+2yvT6PTrXnHy9Al+41QW76T9ACnBm8MAKT9xpfx+ryynk5Vqz8od9+rP7tUylv71Xpl3e+V+7NW28KEjKJWzWvKg0fI33ClTiOjNVIIiQ6MKZpLHDdQpnCJLxWaJRlhZUnTCz5SumhdIOY9oPJ3yTe9d3hcUilS+7Ja2nn/PgOuLKU8l5VmREuxWtc89AnChvLqMFSl/1W3Rev5lK69bvgKvPPWaVZPKZ8UeO7oDpJCEU8x5HSKFOe0gwCApHA0n7Z1SKbbQ4Yc1VKxiDw1nLqGSekE9lybxxz9jriJKTqGW2CFvAjQ2VCvecvyOv5DWBm5OLBcqD86iDCDtgypDTwcPkhO66Ktms8QCvR2ZNZ9Wf2demw++vwuT5jfU34qRYIRBlOTaxzASF6P/zA/0gj89amX8GAAAAABJRU5ErkJggg=="

/***/ }),
/* 391 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 392 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEoAAABKCAMAAAArDjJDAAAAkFBMVEUAAABZV1dtbW1cWlpZV1dgYGBbWFhZV1dZWFhjY2NaV1daWFhbWFhaV1daWFhbWVleW1tZV1dZV1dZWFhaWFhaWFhZWFhaWFhgXV1bWVlbWlpdWlpaV1dZV1daWFhaWFhaWFhbWVlaV1dZWFhaWFhZWFhaV1daWFhaWFhaWFhdWVlZV1daWFhZWFhaWFhZV1dUL3TIAAAAL3RSTlMA+gcy9w9M76sLpohb85hIHNXPyKF3kFAVOSYh3bqMaVNDw5uVvrPrb2Ms5oThezWjFY4AAAP6SURBVFjDvVjpupowECUQdgFZrQju61V73v/tWsUYMITwtbedPwYZJslhZs4J2v+1dUKT9bdE8lGFFW7fEGkJT9d0D/4fPm9a1oJFyp6/GYu1sCxTG2+zAEAVrkvDgff6z4NjlOvwDiCwRkeaBnG0yWsKgPocM/K4rvNNFAc/xob6CePxo28uk2l7hslloz8GBvKxodJY4RBvx2JOlgqPgrjjQllQwTpDNC7UjrrKdYejIhnUEx79/MOhXyNyc0dPC37trrP0SkCuabZurXVxojvLHcqnPCWgHo80P1LYB2+ZL71tAHqc81gOBdnmP+Q5Hi9bc5UO7DDSX1d6FNpwytb6i1iW92YQG+3rM6G+2fXwKVl1YI1tszcHOm9YD1FPRQhqhLo6byxsWpFqFH1O+h51K1bUn2CLdmWFOEsQPWPPL3JMe52quuVfaDLbg+N1qPp9QsqWXpJak5p+ICXLOrKX0MEbLIdOh9KPOq/RBrN+lxKXV2bCVxDHK1dXKCXFh0kzONrmcHXZx2YwgdHvwbblUlXdh6/eMSWOhKVuDDNVN4oYRn4vFMs3t2S2rgilB9mbh/weKDM2TA+ayrYpG2W4CYnA+93VU4Zy7u+h95kQScU39WQJFU/wzVZJ917rpZnIRzClyakg+MZVfRdWjlA8tz97g7rXo7x8nlfB+LxyhLximTsy2y22qaWk8B0i1KCCvxfE++ed4Wtsv1rC4P3qH3ZRsbfrf9Xb75wbVtjL+56CccbzYC7woJqd93yPHf4/Cuys0gx7HHo0w4HPwJ9RKpmVqGSWopJx+8shQFzMzI6+2nF9Ze26+mpWxLBlJfYj3xKQY1f1BVun+Fk4T9Vn8HROCVN9MnPPIB0tOsvSOwG5p9msrUUDbCOVjk5Oc+qoFXKQ2KpzzgoXbUdNtW7/Itmwzw87HXuaKDAfbkTEeFRWMeKMY56SIRcD4fiT1wTnAZf09MQyb/qRu1l1zoOLyWrjts6D6QDyF6zYKdWK8gMBQPzWrgDQQx5ZcRPDkCPPd2/ZAKr9LEPNeEh3QONyva8A2BYTuDLkQ37HtKJpM62PjKmf1bNhTyN2dpEjb5DdJ3E+NuI/vzM8+S45mSIiggko8ld0Q7Vrvn7MsZc8o5jBvCavhEyCZMbTTr4T2b5ZOgvF0MWXiEx4+3zwq495z7h8Bhe1Sn03nvb1xjzoYwCOfNn4HwPBZ4KX7TjmPTZHwaB9WdhD85OnOeS5Lvca95Nqxu4njf98oM0Ex0YWbGRtaNuIUfF+D/4bCeYM+ckjYK2pzT2lvwmcYS6anlxNrRDUkGTa9XpIb8+xZBJNZXpl2/GQGvXIlS60UVYenUFPN6wj7Z/aL+bCXzldHz80AAAAAElFTkSuQmCC"

/***/ }),
/* 393 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "img/img19.4922c62.jpg";

/***/ }),
/* 394 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "img/img2.36b22f2.png";

/***/ }),
/* 395 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "img/img20.4a7c83c.jpg";

/***/ }),
/* 396 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "img/img3.a2be963.png";

/***/ }),
/* 397 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "img/img4.19982a6.png";

/***/ }),
/* 398 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "img/img5.183c5e8.png";

/***/ }),
/* 399 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "img/img6.62be7e7.png";

/***/ }),
/* 400 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "img/img7.91b37eb.png";

/***/ }),
/* 401 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "img/s1-img1.730dce9.jpg";

/***/ }),
/* 402 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "img/s1-img2.9da7087.png";

/***/ }),
/* 403 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "img/s1-img3.3726d79.png";

/***/ }),
/* 404 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "img/s1-img4.b36bb06.png";

/***/ }),
/* 405 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "img/s1-img5.cf34d13.png";

/***/ }),
/* 406 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "img/s1-img6.43b71bf.png";

/***/ }),
/* 407 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "img/s2-img1.37a2388.jpg";

/***/ }),
/* 408 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "img/s2-img2.512f04b.png";

/***/ }),
/* 409 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "img/s2-img3.400d749.png";

/***/ }),
/* 410 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "img/s2-img4.62271ca.png";

/***/ }),
/* 411 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "img/s2-img5.8e7f8ea.png";

/***/ }),
/* 412 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "img/s3-img1.9577ad9.jpg";

/***/ }),
/* 413 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "img/s3-img2.b1addbc.png";

/***/ }),
/* 414 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "img/s3-img3.035735c.png";

/***/ }),
/* 415 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "img/s3-img4.5b54181.png";

/***/ }),
/* 416 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "img/s3-img5.f5dffbd.png";

/***/ }),
/* 417 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "img/s3-img6.0bbbc6c.png";

/***/ }),
/* 418 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "img/swiper1.f046b3d.png";

/***/ }),
/* 419 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "img/swiper2.d037012.png";

/***/ }),
/* 420 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "img/swiper3.a210984.png";

/***/ }),
/* 421 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "img/swiper4.b5274de.png";

/***/ }),
/* 422 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "img/swiper5.1ff26cf.png";

/***/ }),
/* 423 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "img/img1.8dcc421.png";

/***/ }),
/* 424 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(155)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(82),
  /* template */
  __webpack_require__(451),
  /* scopeId */
  "data-v-6f78b2bf",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 425 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(157)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(83),
  /* template */
  __webpack_require__(453),
  /* scopeId */
  "data-v-dea9d29e",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 426 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(145)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(84),
  /* template */
  __webpack_require__(441),
  /* scopeId */
  "data-v-4fe7a06b",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 427 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(146)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(85),
  /* template */
  __webpack_require__(442),
  /* scopeId */
  "data-v-4ff5b7ec",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 428 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(147)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(86),
  /* template */
  __webpack_require__(443),
  /* scopeId */
  "data-v-5003cf6d",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 429 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(148)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(87),
  /* template */
  __webpack_require__(444),
  /* scopeId */
  "data-v-5011e6ee",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 430 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(149)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(88),
  /* template */
  __webpack_require__(445),
  /* scopeId */
  "data-v-501ffe6f",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 431 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(150)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(89),
  /* template */
  __webpack_require__(446),
  /* scopeId */
  "data-v-502e15f0",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 432 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(151)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(90),
  /* template */
  __webpack_require__(447),
  /* scopeId */
  "data-v-503c2d71",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 433 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(152)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(91),
  /* template */
  __webpack_require__(448),
  /* scopeId */
  "data-v-504a44f2",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 434 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(154)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(92),
  /* template */
  __webpack_require__(450),
  /* scopeId */
  "data-v-5b702cc8",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 435 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(144)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(93),
  /* template */
  __webpack_require__(440),
  /* scopeId */
  "data-v-30da343d",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 436 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(143)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(94),
  /* template */
  __webpack_require__(439),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 437 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(153)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(95),
  /* template */
  __webpack_require__(449),
  /* scopeId */
  "data-v-58ab1afe",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 438 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(156)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(96),
  /* template */
  __webpack_require__(452),
  /* scopeId */
  "data-v-70b55148",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 439 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "d-index"
  }, [_vm._m(0), _vm._m(1), _vm._m(2), _vm._m(3), _vm._m(4), _vm._m(5), _vm._m(6), _vm._m(7), _vm._m(8), _vm._m(9), _vm._m(10), _vm._m(11), _vm._m(12), _vm._m(13), _c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.scrollTop),
      expression: "scrollTop"
    }],
    staticClass: "scroll-top-btn",
    attrs: {
      "src": __webpack_require__(4)
    },
    on: {
      "click": _vm.backtop
    }
  })])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "top-swiper"
  }, [_c('div', {
    staticClass: "swiper-container"
  }, [_c('div', {
    staticClass: "swiper-wrapper"
  }, [_c('div', {
    staticClass: "swiper-slide"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(385)
    }
  })]), _c('div', {
    staticClass: "swiper-slide"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(386)
    }
  })]), _c('div', {
    staticClass: "swiper-slide"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(387)
    }
  })]), _c('div', {
    staticClass: "swiper-slide"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(388)
    }
  })])])]), _c('img', {
    staticClass: "logo",
    attrs: {
      "src": __webpack_require__(361)
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "brand-desc"
  }, [_c('div', {
    staticClass: "line1"
  }, [_vm._v("懂窝相信，家的样子，不应被任何风格所具象定义。")]), _c('div', {
    staticClass: "line3"
  }, [_vm._v("我们甄选有人性温度的好设计，以不过度张扬的生活审美、长久陪伴的细腻品质，"), _c('br'), _vm._v("为你的家一点一点增添动人温情，打造属于自己的理想生活。")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "module1"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("真正贴近用户的甄选"), _c('div', {
    staticClass: "border"
  })]), _c('div', {
    staticClass: "line1"
  }, [_vm._v("我们的每一件产品都经过专业选品团队反复对比甄选，力求设计、品质、性价比、功能和舒适度等维度的平衡。"), _c('br')]), _c('div', {
    staticClass: "line1"
  }, [_vm._v("与此同时，基于对欧美市场的调研及对国内消费者的家居审美与使用偏好的观察，我们综合权衡每个品类、每件产品"), _c('br'), _vm._v("的款式、风格与价格，力求将最优的选择呈现给对家居审美有追求的客户，让大家挑选过程更加从容。")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "module2"
  }, [_c('div', {
    staticClass: "item"
  }, [_c('img', {
    staticClass: "left",
    attrs: {
      "src": __webpack_require__(375)
    }
  }), _c('div', {
    staticClass: "right"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("品位设计，生活之审美")]), _c('div', {
    staticClass: "desc"
  }, [_vm._v("我们放眼全球搜罗精良产品，不盲目追随前卫和潮流，但也拒绝平庸审美，希望能用恰到好处的设计感，满足真实生活的需求与审美。")])])]), _c('div', {
    staticClass: "item"
  }, [_c('img', {
    staticClass: "left",
    attrs: {
      "src": __webpack_require__(376)
    }
  }), _c('div', {
    staticClass: "right"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("严控工艺，兼具品质与舒适")]), _c('div', {
    staticClass: "desc"
  }, [_vm._v("高品质与舒适度是我们选品的重要标准。懂窝所合作的国内外一线工厂，拥有稳定精良的质量把控体系。")]), _c('div', {
    staticClass: "desc"
  }, [_vm._v("每一件产品在出厂前，都经过材质、工艺、体验等方面反复检验与测试，懂窝选品团队更是对实物进行逐一体验，确保坐感或触感等各方面具备令人满意的舒适度。")])])]), _c('div', {
    staticClass: "item"
  }, [_c('img', {
    staticClass: "left",
    attrs: {
      "src": __webpack_require__(377)
    }
  }), _c('div', {
    staticClass: "right"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("源头直采，物超所值")]), _c('div', {
    staticClass: "desc"
  }, [_vm._v("在确保品质与舒适的同时，我们尽量控制成本，追求性价比。")]), _c('div', {
    staticClass: "desc"
  }, [_vm._v("专业买手深入供应链上游直采，从工厂直接到消费者，省去了品牌商、代理商、经销商等层层溢价，同时采用无库存敏捷供应链，优化运营效率与缩减成本，充分让客户感到物超所值。")])])]), _c('div', {
    staticClass: "item"
  }, [_c('img', {
    staticClass: "left",
    attrs: {
      "src": __webpack_require__(378)
    }
  }), _c('div', {
    staticClass: "right"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("多元风格，可混搭融合")]), _c('div', {
    staticClass: "desc"
  }, [_vm._v("我们的产品涵盖："), _c('br'), _vm._v("复古轻奢、粗犷工业、质朴原木、 现代北欧、当代摩登等多种风格。"), _c('br'), _vm._v("满足更多追求家居审美人群的喜好与需求。同时力求产品之间可以相互混搭，即便风格各异也毫不突兀。")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "module3"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("有人性温度的好设计"), _c('div', {
    staticClass: "border"
  })]), _c('div', {
    staticClass: "line1"
  }, [_vm._v("懂窝通过探索现代人居家生活，"), _c('br'), _vm._v("结合性格型态学，糅炼出"), _c('br'), _vm._v("「＋骛美」、「－物然」、「×质想」、「÷颜趣」四个产品系列。")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "module4"
  }, [_c('div', {
    staticClass: "item"
  }, [_c('img', {
    staticClass: "left",
    attrs: {
      "src": __webpack_require__(371)
    }
  }), _c('div', {
    staticClass: "right"
  }, [_c('div', {
    staticClass: "title"
  }, [_c('div', {
    staticClass: "icon"
  }, [_vm._v("➕")]), _c('div', {
    staticClass: "subTitle"
  }, [_c('div', {
    staticClass: "line1"
  }, [_vm._v("骛美")]), _c('div', {
    staticClass: "line2"
  }, [_vm._v("Aesthetic")])])]), _c('div', {
    staticClass: "desc"
  }, [_c('div', {
    staticClass: "line1"
  }, [_vm._v("更追求设计感的领袖家")]), _c('div', {
    staticClass: "line2"
  }, [_vm._v("渴望有序而规律"), _c('br'), _vm._v("充满设计感的家具"), _c('br'), _vm._v("带来更多安静与祥和")])])])]), _c('div', {
    staticClass: "item"
  }, [_c('img', {
    staticClass: "left",
    attrs: {
      "src": __webpack_require__(372)
    }
  }), _c('div', {
    staticClass: "right"
  }, [_c('div', {
    staticClass: "title"
  }, [_c('div', {
    staticClass: "icon"
  }, [_vm._v("➖")]), _c('div', {
    staticClass: "subTitle"
  }, [_c('div', {
    staticClass: "line1"
  }, [_vm._v("物然")]), _c('div', {
    staticClass: "line2"
  }, [_vm._v("Practicality")])])]), _c('div', {
    staticClass: "desc"
  }, [_c('div', {
    staticClass: "line1"
  }, [_vm._v("着重实用体验的生活家")]), _c('div', {
    staticClass: "line2"
  }, [_vm._v("渴望随遇而安的笃定"), _c('br'), _vm._v("给家更多温暖与实用"), _c('br'), _vm._v("是你触手可及的幸福。")])])])]), _c('div', {
    staticClass: "item"
  }, [_c('img', {
    staticClass: "left",
    attrs: {
      "src": __webpack_require__(373)
    }
  }), _c('div', {
    staticClass: "right"
  }, [_c('div', {
    staticClass: "title"
  }, [_c('div', {
    staticClass: "icon"
  }, [_vm._v("✖️")]), _c('div', {
    staticClass: "subTitle"
  }, [_c('div', {
    staticClass: "line1"
  }, [_vm._v("质想")]), _c('div', {
    staticClass: "line2"
  }, [_vm._v("Quality")])])]), _c('div', {
    staticClass: "desc"
  }, [_c('div', {
    staticClass: "line1"
  }, [_vm._v("专享细腻品质的思考家")]), _c('div', {
    staticClass: "line2"
  }, [_vm._v("喜欢独立思考"), _c('br'), _vm._v("坚持能深得你心的"), _c('br'), _vm._v("一定是经得起时间考验的")])])])]), _c('div', {
    staticClass: "item"
  }, [_c('img', {
    staticClass: "left",
    attrs: {
      "src": __webpack_require__(374)
    }
  }), _c('div', {
    staticClass: "right"
  }, [_c('div', {
    staticClass: "title"
  }, [_c('div', {
    staticClass: "icon"
  }, [_vm._v("➗")]), _c('div', {
    staticClass: "subTitle"
  }, [_c('div', {
    staticClass: "line1"
  }, [_vm._v("颜趣")]), _c('div', {
    staticClass: "line2"
  }, [_vm._v("Fun")])])]), _c('div', {
    staticClass: "desc"
  }, [_c('div', {
    staticClass: "line1"
  }, [_vm._v("敢尝有颜有趣的探索家")]), _c('div', {
    staticClass: "line2"
  }, [_vm._v("好看皮囊和有趣的灵魂都想要"), _c('br'), _vm._v("只有新鲜材质与趣意设计"), _c('br'), _vm._v("才能彰显你的与众不同")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "module5"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("产品品质源于品质工厂"), _c('div', {
    staticClass: "border"
  })]), _c('div', {
    staticClass: "line1"
  }, [_vm._v("懂窝所合作的家具家居工厂，均为国际一线家居品牌的源头制造商。"), _c('br'), _vm._v("工艺及环保标准符合欧美国家的进口标准。"), _c('br'), _vm._v("我们致力于将品质家具的优质体验，呈现给每一位懂窝的用户。")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "module6"
  }, [_c('div', {
    staticClass: "item"
  }, [_c('div', {
    staticClass: "text-box"
  }, [_c('div', {
    staticClass: "line1"
  }, [_vm._v("知名家具源头制造商")]), _c('div', {
    staticClass: "line2"
  }, [_vm._v("30多年家具制造经验，HAY、Bo Concept、圣奥、顾家"), _c('br'), _vm._v("等众多国内外知名品牌源头制造商。")])])]), _c('div', {
    staticClass: "item"
  }, [_c('div', {
    staticClass: "text-box"
  }, [_c('div', {
    staticClass: "line1"
  }, [_vm._v("实力家具外贸工厂")]), _c('div', {
    staticClass: "line2"
  }, [_vm._v("产品95％用于海外市场，"), _c('br'), _vm._v(" MADE.com、5 Horizon GroupPT Home "), _c('br'), _vm._v("Center、Castlery等国外知名电商及家具平台合作商。")])])]), _c('div', {
    staticClass: "item"
  }, [_c('div', {
    staticClass: "text-box"
  }, [_c('div', {
    staticClass: "line1"
  }, [_vm._v("国内知名沙发制造商")]), _c('div', {
    staticClass: "line2"
  }, [_vm._v("33年家具制造经验，产品远销法国、英国、俄罗斯、美"), _c('br'), _vm._v("国、加拿大等三十多个国家和地区。")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "module7"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("售卖产品 更是服务"), _c('div', {
    staticClass: "border"
  })]), _c('div', {
    staticClass: "line1"
  }, [_vm._v("每一位懂窝客户都将获得贴心周到的服务，至您踏入懂窝门店或与我们客服联系的那刻起，您将获得——专业的售"), _c('br'), _vm._v("前咨询服务、软装搭配服务、免费送货安装服务和及时响应的售后服务，让您整个家具购买体验顺畅而安心。")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "module8"
  }, [_c('div', {
    staticClass: "item"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(379)
    }
  }), _c('p', [_vm._v("3年"), _c('br'), _vm._v("质量保障")])]), _c('div', {
    staticClass: "item"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(380)
    }
  }), _c('p', [_vm._v("免费"), _c('br'), _vm._v("送货上门")])]), _c('div', {
    staticClass: "item"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(381)
    }
  }), _c('p', [_vm._v("免费"), _c('br'), _vm._v("专业安装")])]), _c('div', {
    staticClass: "item"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(382)
    }
  }), _c('p', [_vm._v("提前预定"), _c('br'), _vm._v("免费仓储")])]), _c('div', {
    staticClass: "item"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(383)
    }
  }), _c('p', [_vm._v("7天"), _c('br'), _vm._v("无理由退换")])]), _c('div', {
    staticClass: "item"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(384)
    }
  }), _c('p', [_vm._v("开具"), _c('br'), _vm._v("正规发票")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "module9"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("不同渠道 相同体验"), _c('div', {
    staticClass: "border"
  })]), _c('div', {
    staticClass: "line1"
  }, [_vm._v("我们致力于打造线上线下全品类场景化体验。"), _c('br'), _vm._v(" 通过懂窝线下店，您可以亲临有温度的加减乘除空间，通过场景化沉浸式体验，实地触摸、挑选心仪的产品，"), _c('br'), _vm._v("同时收获更多灵感启发；门店未展示的商品可通过懂窝天猫店和懂窝微信小程序轻松在线浏览，"), _c('br'), _vm._v("让您更便捷地拥有心仪的家居好物。")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "module10"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("懂窝线下体验店")]), _c('div', {
    staticClass: "cont"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(362)
    }
  }), _c('img', {
    attrs: {
      "src": __webpack_require__(363)
    }
  })]), _c('div', {
    staticClass: "address"
  }, [_vm._v("懂窝上海世博店 | 望达路1号B3-C 103")]), _c('div', {
    staticClass: "cont"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(365)
    }
  }), _c('img', {
    attrs: {
      "src": __webpack_require__(366)
    }
  })]), _c('div', {
    staticClass: "address"
  }, [_vm._v("懂窝上海南丰城店 | 长宁区遵义路100号虹桥南丰城南区L218")]), _c('div', {
    staticClass: "cont"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(367)
    }
  }), _c('img', {
    attrs: {
      "src": __webpack_require__(368)
    }
  })]), _c('div', {
    staticClass: "address"
  }, [_vm._v("懂窝上海LaLaport店 | 浦东新区新金桥路738号LaLaport 405&406")]), _c('div', {
    staticClass: "cont"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(369)
    }
  }), _c('img', {
    attrs: {
      "src": __webpack_require__(370)
    }
  })]), _c('div', {
    staticClass: "address"
  }, [_vm._v("懂窝上海万象城店 | 闵行区吴中路1599号万象城L533")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "module11"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("懂窝电商渠道")]), _c('div', {
    staticClass: "cont"
  }, [_c('div', {
    staticClass: "line1"
  }, [_vm._v("一键购买心仪好物")]), _c('div', {
    staticClass: "line2"
  }, [_vm._v("足不出户 体验便捷")]), _c('div', {
    staticClass: "code-box"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(55)
    }
  }), _c('p', [_vm._v("扫码进入"), _c('br'), _vm._v(" 懂窝天猫店")]), _c('img', {
    attrs: {
      "src": __webpack_require__(56)
    }
  }), _c('p', [_vm._v("扫码进入"), _c('br'), _vm._v(" 懂窝小程序")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "module12"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("品牌合作伙伴")]), _c('div', {
    staticClass: "border"
  }), _c('img', {
    attrs: {
      "src": __webpack_require__(364)
    }
  })])
}]}

/***/ }),
/* 440 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "d-findUs"
  }, [_vm._m(0), _vm._m(1), _vm._m(2), _vm._m(3), _vm._m(4), _vm._m(5), _vm._m(6), _c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.scrollTop),
      expression: "scrollTop"
    }],
    staticClass: "scroll-top-btn",
    attrs: {
      "src": __webpack_require__(4)
    },
    on: {
      "click": _vm.backtop
    }
  })])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "module1"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("懂窝线下体验店"), _c('div', {
    staticClass: "border"
  })]), _c('div', {
    staticClass: "line1"
  }, [_vm._v("懂窝线下体验店根据加减乘除四大产品系列进行划分布置，每个空间都是一个个家的故事，"), _c('br'), _vm._v("通过富有温度的场景打造，营造出沉浸式家居购物体验。")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "module2"
  }, [_c('div', {
    staticClass: "swiper-container d-swiper1"
  }, [_c('div', {
    staticClass: "swiper-wrapper"
  }, [_c('div', {
    staticClass: "swiper-slide"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(350)
    }
  })]), _c('div', {
    staticClass: "swiper-slide"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(351)
    }
  })]), _c('div', {
    staticClass: "swiper-slide"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(352)
    }
  })]), _c('div', {
    staticClass: "swiper-slide"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(353)
    }
  })])]), _c('div', {
    staticClass: "swiper-pagination"
  }), _c('div', {
    staticClass: "swiper-button-prev"
  }), _c('div', {
    staticClass: "swiper-button-next"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "module3"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("线上购物渠道"), _c('div', {
    staticClass: "border"
  })]), _c('div', {
    staticClass: "line1"
  }, [_vm._v("您不仅可以亲临懂窝体验店感受家的温度，"), _c('br'), _vm._v("还可以通过懂窝天猫店或懂窝微信小程序等线上渠道，"), _c('br'), _vm._v("轻松在线浏览懂窝产品，收获家居灵感及搭配方案，实现心目中家的样子。")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "module4"
  }, [_c('div', {
    staticClass: "line1"
  }, [_vm._v("一键购买心仪好物")]), _c('div', {
    staticClass: "line2"
  }, [_vm._v("足不出户 体验便捷")]), _c('div', {
    staticClass: "code-box"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(55)
    }
  }), _c('p', [_vm._v("扫码进入"), _c('br'), _vm._v(" 懂窝天猫店")]), _c('img', {
    attrs: {
      "src": __webpack_require__(56)
    }
  }), _c('p', [_vm._v("扫码进入"), _c('br'), _vm._v(" 懂窝小程序")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "module5"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("软装搭配服务"), _c('div', {
    staticClass: "border"
  })]), _c('div', {
    staticClass: "line1"
  }, [_vm._v("我们不仅提供设计、品质、性价比、功能和舒适度兼具的产品，"), _c('br'), _vm._v(" 还可根据客户需求提供量身定制的软装设计服务，帮您实现心目中家的样子。")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "module6"
  }, [_c('div', {
    staticClass: "line1"
  }, [_vm._v("懂窝软装设计服务提供包含家具、床品/地毯、灯具、软装饰品、装饰画、墙面和窗帘等七项软装设计咨询及搭配服务。")]), _c('div', {
    staticClass: "line1"
  }, [_vm._v("1.您可以与懂窝销售或客服联系，描绘您对家的期望与想象，我们将为您匹配专业设计师。"), _c('br'), _vm._v(" 2.设计师将与您进行深度沟通，挖掘您的设计需求，确定大致的设计方向。"), _c('br'), _vm._v(" 3并为您提供精心匹配的产品清单和量身定制的软装搭配方案，帮助您实现家的样子。")]), _c('div', {
    staticClass: "qr-code"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(349)
    }
  }), _c('p', [_vm._v("扫码了解更多")])]), _c('img', {
    staticClass: "img",
    attrs: {
      "src": __webpack_require__(348)
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "module7"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("客户设计案例")]), _c('div', {
    staticClass: "swiper-container d-swiper2"
  }, [_c('div', {
    staticClass: "swiper-wrapper"
  }, [_c('div', {
    staticClass: "swiper-slide"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(354)
    }
  })]), _c('div', {
    staticClass: "swiper-slide"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(355)
    }
  })]), _c('div', {
    staticClass: "swiper-slide"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(356)
    }
  })]), _c('div', {
    staticClass: "swiper-slide"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(357)
    }
  })])]), _c('div', {
    staticClass: "swiper-pagination"
  }), _c('div', {
    staticClass: "swiper-button-prev"
  }), _c('div', {
    staticClass: "swiper-button-next"
  })])])
}]}

/***/ }),
/* 441 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "d-case"
  }, [_c('img', {
    staticClass: "top-img",
    attrs: {
      "src": __webpack_require__(164)
    }
  }), _vm._m(0), _c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.scrollTop),
      expression: "scrollTop"
    }],
    staticClass: "scroll-top-btn",
    attrs: {
      "src": __webpack_require__(4)
    },
    on: {
      "click": _vm.backtop
    }
  })])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "case-num"
  }, [_vm._v("Vol.01")]), _c('div', {
    staticClass: "case-title"
  }, [_vm._v("有风景也有爱，建筑师夫妇把140㎡家打造成让人羡慕的样子")]), _c('div', {
    staticClass: "line1"
  }, [_vm._v("2017年夏天，建筑师一横和太太在上海松江买下了属于自己的第一套房。作为建筑师夫妇，在工作中为业主贡献了无数极具创意和设计感的作品，而在面对自己的家时，他们选择了大白墙为主的极简。")]), _c('div', {
    staticClass: "line1"
  }, [_vm._v("“每天的工作都要在无数的审美中选择，回家后只想要简单。于是我们从设计一开始就定下了设计原则：最少的装饰，最功能化的家具，最省事的家务。”")]), _c('img', {
    staticClass: "cont-img",
    attrs: {
      "src": __webpack_require__(175)
    }
  }), _c('div', {
    staticClass: "cont-title"
  }, [_vm._v("「背景信息」")]), _c('div', {
    staticClass: "line1"
  }, [_c('span', [_vm._v("关于屋主")]), _vm._v("屋主夫妇两人都是建筑师，男主人一横擅于空间整体规划及硬装打磨，女主人则喜欢研究软装功能与色彩搭配。他们信奉密斯·凡德罗Less is more的设计理念，共同打造的家，充满了极简美学和功能主义。")]), _c('div', {
    staticClass: "cont-title"
  }, [_vm._v("「房子的基本信息」")]), _c('div', {
    staticClass: "line1"
  }, [_c('span', [_vm._v("坐标：上海松江")]), _vm._v(" "), _c('span', [_vm._v("户型：四室两厅")]), _vm._v(" "), _c('span', [_vm._v("使用面积：140㎡")]), _vm._v(" "), _c('span', [_vm._v("装修风格：现代极简")]), _vm._v(" "), _c('span', [_vm._v("装修费用：40w+")])]), _c('img', {
    staticClass: "cont-img",
    attrs: {
      "src": __webpack_require__(178)
    }
  }), _c('div', {
    staticClass: "cont-title"
  }, [_vm._v("客餐厅：坐拥三面环景")]), _c('div', {
    staticClass: "line1"
  }, [_vm._v("拿到房子以后，一横首先想到的就是将客餐厅打通，并将南阳台包进客厅，形成一个宽敞的、坐拥三面环景的公共区域，最大程度将河景引入室内。白墙基调是窗外风景的最佳图底，公共空间最大化，邀请再多朋友来家Party也不怕。")]), _c('img', {
    staticClass: "cont-img",
    attrs: {
      "src": __webpack_require__(179)
    }
  }), _c('div', {
    staticClass: "line1"
  }, [_vm._v("大面积的落地窗，将室内外连为一体。配上可调节光线香格里拉帘，既有百叶一般的光影效果，又方便打理不怕积灰，再加一层白色纱帘，颜值与实用性都可兼顾。")]), _c('img', {
    staticClass: "cont-img",
    attrs: {
      "src": __webpack_require__(180)
    }
  }), _c('div', {
    staticClass: "line1"
  }, [_vm._v("白色的墙面与素雅的木纹砖地面，奠定了客餐厅极简的格调，软装的选用则在功能和色彩上做到实用与美观。")]), _c('div', {
    staticClass: "line1"
  }, [_vm._v("\"我们对家具的选择比较挑剔，喜欢具有实用性与品质感，同时兼具设计感与性价比的。\"说到买家具的经历，夫妻俩在某宝有过多次货不对版的坑，后来经朋友介绍来到懂窝，发现这里的家具与他们的观念不谋而合。")]), _c('img', {
    staticClass: "cont-img",
    attrs: {
      "src": __webpack_require__(181)
    }
  }), _c('div', {
    staticClass: "line1"
  }, [_vm._v("懂窝维特罗吊灯，星星点点的灯光像花瓣一样，中和极简的设计风格，让整体氛围变得温馨浪漫。")]), _c('img', {
    staticClass: "cont-img",
    attrs: {
      "src": __webpack_require__(182)
    }
  }), _c('div', {
    staticClass: "line1"
  }, [_vm._v("与大体量的沙发形成对比，茶几则选用轻盈的金属元素，精致的平行拉丝和环状拉丝，纹理与材质的细微差别，时尚耐看。")]), _c('img', {
    staticClass: "cont-img",
    attrs: {
      "src": __webpack_require__(183)
    }
  }), _c('div', {
    staticClass: "line1"
  }, [_vm._v("窗边放一把经典蝴蝶椅，搭配一张懂窝桑德罗羊皮毯，在充满北欧气息的大叶绿植簇拥下，向大师设计致敬，更为自己营造一方闲适空间。")]), _c('img', {
    staticClass: "cont-img",
    attrs: {
      "src": __webpack_require__(184)
    }
  }), _c('div', {
    staticClass: "line1"
  }, [_vm._v("客厅与餐厅之间，以一件蓝灰色的矮柜作为空间过渡，也是入门玄关的视觉落脚点，是一横亲手设计定制的。简约的柜体，加上黄铜底座，轻奢好看。")]), _c('img', {
    staticClass: "cont-img",
    attrs: {
      "src": __webpack_require__(165)
    }
  }), _c('div', {
    staticClass: "line1"
  }, [_vm._v("餐厅遵循简约的设计。懂窝马利克斯餐桌，实木质感温润，冬夏季都有最佳的触感，搭配黄铜桌脚，时尚轻盈。高低排布的吊灯及像圆月般饱满的落地灯，则为用餐提供恰到好处的光源，让气氛更加舒适。")]), _c('img', {
    staticClass: "cont-img",
    attrs: {
      "src": __webpack_require__(166)
    }
  }), _c('div', {
    staticClass: "cont-title"
  }, [_vm._v("厨房：橱柜量身定制")]), _c('div', {
    staticClass: "line1"
  }, [_vm._v("厨房与客餐厅相连，带有金属质感的橱柜精致大气，也是一横自己画图、根据家人身高定做的。台柜高度87cm，这样切菜洗碗都不会太累。橱柜下面有可自动感应的灯带，可以从外面控制开关。")]), _c('img', {
    staticClass: "cont-img",
    attrs: {
      "src": __webpack_require__(167)
    }
  }), _c('div', {
    staticClass: "line1"
  }, [_vm._v("洗碗机、净水器等电器在最初设计时就被规划入整体橱柜中，加上免拉手的抽屉，在厨房这种重油烟的区域没有一处死角。")]), _c('div', {
    staticClass: "cont-title"
  }, [_vm._v("玄关：一个多功能柜体")]), _c('div', {
    staticClass: "line1"
  }, [_vm._v("一个完整精密的收纳系统，是夫妻俩设计这个家的主要考虑之一。为此，一横亲手画图设计了全屋柜体，主要的宗旨是：外无负担，内有乾坤。")]), _c('div', {
    staticClass: "line1"
  }, [_vm._v("进门右侧是玄关柜，上部吊柜，放置不常用的杂物；下部高低两个柜体，可以用来放鞋子，中间凹进的部分，刚好可以坐着换鞋。中间设置隐藏的感应灯带。柜体与地面悬空，不仅可以放日常的鞋子，还能让扫地机器人通过。")]), _c('img', {
    staticClass: "cont-img",
    attrs: {
      "src": __webpack_require__(168)
    }
  }), _c('div', {
    staticClass: "line1"
  }, [_vm._v("作为玄关延伸的一部分，一面简约的穿衣镜，一幅落地的挂画，让主卧与走廊之间的色彩产生有趣的对话。")]), _c('img', {
    staticClass: "cont-img",
    attrs: {
      "src": __webpack_require__(169)
    }
  }), _c('div', {
    staticClass: "cont-title"
  }, [_vm._v("主卧：套房设计，收纳力max")]), _c('div', {
    staticClass: "line1"
  }, [_vm._v("主卧与主卫、儿童房呈套房设计。")]), _c('img', {
    staticClass: "cont-img",
    attrs: {
      "src": __webpack_require__(170)
    }
  }), _c('div', {
    staticClass: "line1"
  }, [_vm._v("主卧有别于客厅的白墙，选择了多乐士的午夜蓝，静谧、深邃如夜空。地板上墙作为床头板，将墙面黄金分割。床头隐藏灯带，加上垂坠的床头灯，让卧室的氛围显得安静而舒适，更加有利于睡眠。")]), _c('img', {
    staticClass: "cont-img",
    attrs: {
      "src": __webpack_require__(171)
    }
  }), _c('div', {
    staticClass: "line1"
  }, [_vm._v("主卧内利用墙体凹进的600公分的深度，做了4.8米长的整面柜体。270°的铰链，可以让柜体开门最大化，拿取衣物更加方便。")]), _c('div', {
    staticClass: "line1"
  }, [_vm._v("衣柜内搁板可以根据衣物长短进行调节，内置感应灯带，方便衣物挂取。为了杜绝卫生死角，床底架空，方便扫地机器人通过。")]), _c('img', {
    staticClass: "cont-img",
    attrs: {
      "src": __webpack_require__(172)
    }
  }), _c('div', {
    staticClass: "cont-title"
  }, [_vm._v("主卫：优雅爵士白")]), _c('div', {
    staticClass: "line1"
  }, [_vm._v("用爵士白砖铺设主卫，简约明亮。大小两个镜面的设置，方便夫妻俩同时使用。")]), _c('img', {
    staticClass: "cont-img",
    attrs: {
      "src": __webpack_require__(173)
    }
  }), _c('div', {
    staticClass: "line1"
  }, [_vm._v("蓝灰色的浴室柜也是自己画图定制，台盆半挂，做了400的进深，加上圆镜边缘的灯光，可以带来模拟自然光的效果，方便化妆。")]), _c('div', {
    staticClass: "line1"
  }, [_vm._v("浴室柜底部做了搁板，可以放置脏衣篮。同时离地面有一定高度，扫地机器人可以通过。")]), _c('div', {
    staticClass: "cont-title"
  }, [_vm._v("书房：建筑师的温馨日常")]), _c('div', {
    staticClass: "line1"
  }, [_vm._v("书房在进门左侧，这里是两个人的工作空间，也是一个临时客卧（用一张沙发床来实现）。")]), _c('img', {
    staticClass: "cont-img",
    attrs: {
      "src": __webpack_require__(174)
    }
  }), _c('div', {
    staticClass: "line1"
  }, [_vm._v("一横画图设计了一张3米左右的书桌，满足夫妻俩同时工作的需求。书桌下除了常见的抽屉柜体外，预留了收纳推车（篮子）的空间，可以用来放文件和打印纸等。同时，书房也预留了整整一面墙给未来的书架。")]), _c('div', {
    staticClass: "line1"
  }, [_vm._v("“有的时候设计不能做的太满，未来总是充满了不确定，给设计留点白，也是给自己的生活留点小期盼。” ")]), _c('img', {
    staticClass: "cont-img",
    attrs: {
      "src": __webpack_require__(176)
    }
  }), _c('div', {
    staticClass: "line1"
  }, [_vm._v("现在，一横夫妇已经搬进新家大半年了，无论工作有多辛苦，他们都知道家里有一份简单温馨在等候。每天就着朝霞吃早餐，伴着晚霞做晚饭，厨房不弯腰，没有油烟，连一横也爱上了做饭。每周放扫地机器人出来溜溜，看到看不到的地方都干干净净。")]), _c('img', {
    staticClass: "cont-img",
    attrs: {
      "src": __webpack_require__(177)
    }
  }), _c('div', {
    staticClass: "line1"
  }, [_vm._v("“很多时候，设计不仅仅只是好看与否，好的设计既可以带给你美的享受，还可以改善你的生活，让你开始享受生活。”")]), _c('div', {
    staticClass: "cont-title"
  }, [_vm._v("软装搭配心得")]), _c('div', {
    staticClass: "line1"
  }, [_vm._v("•  不要单纯看一件单品的好看与否，而是看功能与整体风格的协调性。"), _c('br'), _vm._v(" • 细腿儿的家具可以让地面露出的部分更多，让空间看起来更大。同时也可以让扫地机器人通过，减少做家务的时间。"), _c('br'), _vm._v(" •  定制全屋柜体，充分考虑使用细节，可以将杂物尽量收起来，不影响整体简约的格调。")])])
}]}

/***/ }),
/* 442 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "d-case"
  }, [_c('img', {
    staticClass: "top-img",
    attrs: {
      "src": __webpack_require__(185)
    }
  }), _vm._m(0), _c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.scrollTop),
      expression: "scrollTop"
    }],
    staticClass: "scroll-top-btn",
    attrs: {
      "src": __webpack_require__(4)
    },
    on: {
      "click": _vm.backtop
    }
  })])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "case-num"
  }, [_vm._v("Vol.02")]), _c('div', {
    staticClass: "case-title"
  }, [_vm._v("上海246㎡精装大平层，用家具与配饰沉淀出家的味道")]), _c('div', {
    staticClass: "line1"
  }, [_vm._v("上海浦东陆家嘴某楼盘。")]), _c('div', {
    staticClass: "line1"
  }, [_vm._v("金秋的空气中夹着桂花香，穿过一条两旁都是高大乔木的绿荫道，公寓楼前服务生把我们迎进门内。")]), _c('div', {
    staticClass: "line1"
  }, [_vm._v("今天窝仔要去探访客户Bingxin的家。")]), _c('img', {
    staticClass: "cont-img",
    attrs: {
      "src": __webpack_require__(196)
    }
  }), _c('div', {
    staticClass: "cont-title"
  }, [_vm._v("关于屋主")]), _c('div', {
    staticClass: "line1"
  }, [_vm._v("Bingxin和先生都是企业高管，两人相识并成家于德国，目前定居上海。家里还有一个可爱的混血宝贝Liam。")]), _c('div', {
    staticClass: "line1"
  }, [_vm._v("从德国到上海，总共搬过3次家。家里很多装饰都辗转陪伴多年，与懂窝的家具相融，充满了家的味道。")]), _c('img', {
    staticClass: "cont-img",
    attrs: {
      "src": __webpack_require__(207)
    }
  }), _c('div', {
    staticClass: "cont-title"
  }, [_vm._v("客餐厅：坐拥三面环景")]), _c('div', {
    staticClass: "line1"
  }, [_c('span', [_vm._v("坐标：上海浦东")]), _vm._v(" "), _c('span', [_vm._v("面积：246㎡")]), _vm._v(" "), _c('span', [_vm._v("户型：四室两厅")]), _vm._v(" "), _c('span', [_vm._v("风格：现代简约")]), _vm._v(" "), _c('span', [_vm._v("原始状态：精装修")])]), _c('div', {
    staticClass: "line1"
  }, [_vm._v("站在Bingxin家客餐厅的窗前，可以看到被绿意环绕的小区周边，再往远眺，则是上海陆家嘴的繁华景象。")]), _c('img', {
    staticClass: "cont-img",
    attrs: {
      "src": __webpack_require__(213)
    }
  }), _c('div', {
    staticClass: "line1"
  }, [_vm._v("在这样一个寸土寸金的位置，空间即意味着奢侈。Bingxin家有3个卧室，1个保姆房，1个大阳台，还有让人兴奋的一体式客餐厅。")]), _c('img', {
    staticClass: "cont-img",
    attrs: {
      "src": __webpack_require__(214)
    }
  }), _c('div', {
    staticClass: "line1"
  }, [_vm._v("德国的家是简约通体的白，上海的家，也希望在相对简洁的框架下，打造出满足一家人生活需求的居住与休闲空间，同时兼备必要的收纳与展示功能。")]), _c('div', {
    staticClass: "line1"
  }, [_vm._v("与懂窝结缘始于被产品所吸引，设计感强，简约耐看，非常符合她和先生西化的审美。与懂窝设计师深入沟通之后，更加让她笃定携手懂窝改造新家。")]), _c('img', {
    staticClass: "cont-img",
    attrs: {
      "src": __webpack_require__(215)
    }
  }), _c('div', {
    staticClass: "cont-title"
  }, [_vm._v("客餐厅，不一定要有电视")]), _c('div', {
    staticClass: "line1"
  }, [_vm._v("客餐厅占据了Bingxin家最大的面积，足有50㎡，连成长条，直通厨房。")]), _c('img', {
    staticClass: "cont-img",
    attrs: {
      "src": __webpack_require__(216)
    }
  }), _c('div', {
    staticClass: "line1"
  }, [_vm._v("设计的时候就考虑不要电视，一来怕影响孩子，二来，用书和音乐装点客厅，可以让家庭氛围更有质感。")]), _c('div', {
    staticClass: "line1"
  }, [_vm._v("这里是一家人活动最频繁的区域。设计师为它定义了5个功能：沙发区、餐厅、书柜、展示陈列、儿童玩乐区。")]), _c('img', {
    staticClass: "cont-img",
    attrs: {
      "src": __webpack_require__(217)
    }
  }), _c('img', {
    staticClass: "cont-img",
    attrs: {
      "src": __webpack_require__(218)
    }
  }), _c('div', {
    staticClass: "line1"
  }, [_vm._v("房子原先的墙面是灰色的，Bingxin比较喜欢灰蓝带来的沉郁格调，于是率性重新刷了色。")]), _c('img', {
    staticClass: "cont-img",
    attrs: {
      "src": __webpack_require__(186)
    }
  }), _c('div', {
    staticClass: "line1"
  }, [_vm._v("没有选择转角沙发，而用两张三人位沙发替代，“这样可以容纳更多人，两个人可以躺在不同沙发上，互不打扰”。")]), _c('img', {
    staticClass: "cont-img",
    attrs: {
      "src": __webpack_require__(187)
    }
  }), _c('div', {
    staticClass: "line1"
  }, [_vm._v("懂窝的巴罗沙发，外形极简大方，高弹靠背坐感舒适，宽大的包裹感，刚好符合Bingxin的需求。")]), _c('div', {
    staticClass: "line1"
  }, [_vm._v("拉里亚落地灯 摆在了两个沙发之间，偏工业风的设计，与整体气质并不违和，晚上躺在沙发上，可以在光源的映衬下看看书。")]), _c('img', {
    staticClass: "cont-img",
    attrs: {
      "src": __webpack_require__(188)
    }
  }), _c('div', {
    staticClass: "line1"
  }, [_vm._v("两把休闲椅与沙发呈围合之势，同样是素雅的米色，带有一定倾斜度的坐感非常舒适。")]), _c('img', {
    staticClass: "cont-img",
    attrs: {
      "src": __webpack_require__(189)
    }
  }), _c('div', {
    staticClass: "line1"
  }, [_vm._v("椅上点缀懂窝奥萨卡波西米亚风抱枕，精致的刺绣与色彩既抢眼又耐看。")]), _c('img', {
    staticClass: "cont-img",
    attrs: {
      "src": __webpack_require__(190)
    }
  }), _c('div', {
    staticClass: "line1"
  }, [_vm._v("一张几何形状的凯斯勒地毯，丰富跳跃的色彩，掩盖颜色略深的地板，让沙发区温暖而不沉闷。")]), _c('img', {
    staticClass: "cont-img",
    attrs: {
      "src": __webpack_require__(191)
    }
  }), _c('div', {
    staticClass: "line1"
  }, [_vm._v("黑色的圆形小边几，充满设计感的外形像是一件装饰，同时可以满足简单的置物需求。一个黄铜双层托盘，随手收纳桌面小物，很实用。")]), _c('img', {
    staticClass: "cont-img",
    attrs: {
      "src": __webpack_require__(192)
    }
  }), _c('div', {
    staticClass: "line1"
  }, [_vm._v("米色的B&O音响安静置于角落，待孩子睡下，坐在沙发边放上一段音乐，让身心放空，是Bingxin最轻松的时刻。")]), _c('img', {
    staticClass: "cont-img",
    attrs: {
      "src": __webpack_require__(193)
    }
  }), _c('div', {
    staticClass: "line1"
  }, [_vm._v("客厅边上，在设计师建议下做了一排米色的收纳柜，充当书架与展示区。这也是非常节省空间的做法，让客厅功能更多元，闲来无事，可以随手抽出一本书翻阅。")]), _c('img', {
    staticClass: "cont-img",
    attrs: {
      "src": __webpack_require__(194)
    }
  }), _c('div', {
    staticClass: "line1"
  }, [_vm._v("客厅及餐厅区域，单独辟开两块位置给到1岁半的儿子Liam，成为小家伙的玩乐空间。一个金属内框、实木面的矮柜，既可用来放小朋友的玩具，还可以当长凳。")]), _c('img', {
    staticClass: "cont-img",
    attrs: {
      "src": __webpack_require__(195)
    }
  }), _c('div', {
    staticClass: "cont-title"
  }, [_vm._v("用艺术画作装饰家")]), _c('div', {
    staticClass: "line1"
  }, [_vm._v("Bingxin和先生都很喜欢画，家里的墙面展示了不少两人收藏的画作。")]), _c('div', {
    staticClass: "line1"
  }, [_vm._v("推门进入玄关，映入眼帘是一幅热闹的山景，浓烈的橙黄，让人感受到家的温馨。")]), _c('img', {
    staticClass: "cont-img",
    attrs: {
      "src": __webpack_require__(197)
    }
  }), _c('div', {
    staticClass: "line1"
  }, [_vm._v("客厅尽头一幅相对大尺寸的画，是Bingxin出差时在广州一家画廊买的，当时看到觉得很触动，花了很贵的价钱买下。近看像是明黄与墨绿两种色彩的堆叠，远观，是一匹马的形象。")]), _c('img', {
    staticClass: "cont-img",
    attrs: {
      "src": __webpack_require__(198)
    }
  }), _c('div', {
    staticClass: "line1"
  }, [_vm._v("边柜上的黑白画作，选自懂窝，像花开至荼蘼，有一种凄冷的美。")]), _c('img', {
    staticClass: "cont-img",
    attrs: {
      "src": __webpack_require__(199)
    }
  }), _c('div', {
    staticClass: "line1"
  }, [_vm._v("家里的画大多跟随Bingxin一家多年，更迭迁徙，也没有刻意迎合现有的家居布置，却又非常映衬。")]), _c('img', {
    staticClass: "cont-img",
    attrs: {
      "src": __webpack_require__(200)
    }
  }), _c('div', {
    staticClass: "line1"
  }, [_vm._v("卧室延续了客厅的灰蓝色墙面，是更加让人安静的空间。竹编的窗帘，既通透又能确保隐私。")]), _c('img', {
    staticClass: "cont-img",
    attrs: {
      "src": __webpack_require__(201)
    }
  }), _c('div', {
    staticClass: "line1"
  }, [_vm._v("懂窝的绿色丝绒床，优雅的丝绒像藏着时间的故事，复古，精致，在灰蓝色的映衬下，更加彰显宁静的气场。")]), _c('img', {
    staticClass: "cont-img",
    attrs: {
      "src": __webpack_require__(202)
    }
  }), _c('div', {
    staticClass: "line1"
  }, [_vm._v("床头挂画的复古绿意与丝绒床呼应，气质神秘。")]), _c('img', {
    staticClass: "cont-img",
    attrs: {
      "src": __webpack_require__(203)
    }
  }), _c('div', {
    staticClass: "line1"
  }, [_vm._v("几张皮毛地毯，铺垫在床边，让脚感更加舒适，也增添了卧室的温暖氛围。")]), _c('img', {
    staticClass: "cont-img",
    attrs: {
      "src": __webpack_require__(204)
    }
  }), _c('div', {
    staticClass: "line1"
  }, [_vm._v("几个色彩斑斓的泥罐，是孟加拉的同事送给他们的礼物，点缀在角落里非常讨喜。")]), _c('img', {
    staticClass: "cont-img",
    attrs: {
      "src": __webpack_require__(205)
    }
  }), _c('div', {
    staticClass: "line1"
  }, [_vm._v("与卧室相连的是一个大阳台，天气好的时候可以看书赏景，月下小酌，是提升生活质量的一个必不可少的空间。")]), _c('img', {
    staticClass: "cont-img",
    attrs: {
      "src": __webpack_require__(206)
    }
  }), _c('div', {
    staticClass: "cont-title"
  }, [_vm._v("用久了的器物，会有家的味道")]), _c('div', {
    staticClass: "line1"
  }, [_vm._v("从德国到上海，Bingxin搬了3次家。虽然每次都是新家，却没有太多陌生感。因为这里填充的，很多都是用了很多年的器物。")]), _c('div', {
    staticClass: "line1"
  }, [_vm._v("要论最喜欢的，还是客厅的边柜上方，一个花纹复古的漆器摆饰，来自Bingxin家乡重庆的匠工细意雕琢，精致感十足。")]), _c('img', {
    staticClass: "cont-img",
    attrs: {
      "src": __webpack_require__(208)
    }
  }), _c('div', {
    staticClass: "line1"
  }, [_vm._v("餐厅与客厅之间以一张懂窝电视柜作为区隔。")]), _c('img', {
    staticClass: "cont-img",
    attrs: {
      "src": __webpack_require__(209)
    }
  }), _c('div', {
    staticClass: "line1"
  }, [_vm._v("费尔贝恩餐边柜，胡桃木饰面花纹流畅，与电视柜及木地板颜色迎合，气息沉静优雅。")]), _c('img', {
    staticClass: "cont-img",
    attrs: {
      "src": __webpack_require__(210)
    }
  }), _c('div', {
    staticClass: "line1"
  }, [_vm._v("一张实木餐桌，是从德国的家空运来的，木料厚重敦实，桌面有油渍、划痕，带着过往生活的印记，触目很亲切。")]), _c('img', {
    staticClass: "cont-img",
    attrs: {
      "src": __webpack_require__(211)
    }
  }), _c('div', {
    staticClass: "line1"
  }, [_vm._v("这些用久了的器物，带着家的气息，穿越尘嚣，沉淀出家的味道。而总有一天，选自懂窝的家具，也会融入其中，成为家的一部分。")]), _c('img', {
    staticClass: "cont-img",
    attrs: {
      "src": __webpack_require__(212)
    }
  }), _c('div', {
    staticClass: "cont-title1"
  }, [_vm._v(" Q&A")]), _c('div', {
    staticClass: "line2"
  }, [_c('span', [_vm._v("Q：为什么选择懂窝的家具？")]), _vm._v("在懂窝展厅看到，家具非常简约有设计感，我们在德国的家也是通体的白色，家具也非常简约。这样的风格比较符合我们的审美。")]), _c('div', {
    staticClass: "line2"
  }, [_c('span', [_vm._v("Q：您最喜欢懂窝的哪件家具？")]), _vm._v("最喜欢客厅的沙发，很好看，坐感也非常舒服。大的靠包软软的，长度也可以满足我们两个人分别躺卧。")]), _c('div', {
    staticClass: "line2"
  }, [_c('span', [_vm._v("Q：看到您家很多装饰品，在软饰搭配这块您有什么心得？")]), _vm._v("从整体色彩上，我比较喜欢灰蓝的沉静感，可以让人心情很安静。这些挂画基本都是我们旅途中买的，比如床头那，带有一点绿色觉得和绿色丝绒床很搭，摆上去刚好也合适。还是看感觉搭配吧。")]), _c('div', {
    staticClass: "line2"
  }, [_c('span', [_vm._v("Q：整个房子改造花费多少？")]), _vm._v("懂窝产品性价比很高，客餐厅还有卧室区域基本是在懂窝买的家具，总共5万多吧。")])])
}]}

/***/ }),
/* 443 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "d-case"
  }, [_c('img', {
    staticClass: "top-img",
    attrs: {
      "src": __webpack_require__(219)
    }
  }), _vm._m(0), _c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.scrollTop),
      expression: "scrollTop"
    }],
    staticClass: "scroll-top-btn",
    attrs: {
      "src": __webpack_require__(4)
    },
    on: {
      "click": _vm.backtop
    }
  })])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "case-num"
  }, [_vm._v("Vol.03")]), _c('div', {
    staticClass: "case-title"
  }, [_vm._v("上海175㎡暗黑系霸道总裁风，花100万装修只为这种feel")]), _c('div', {
    staticClass: "line1"
  }, [_vm._v("有人喜欢把家装成北欧风，有人则喜欢“暗戳戳”的低调范，在属于你的家里，怎样都是合理的。")]), _c('div', {
    staticClass: "line1"
  }, [_vm._v("今天窝仔要给大家介绍的客户陈小姐的家，她的家，绝非用“个性”二字可以形容。")]), _c('img', {
    staticClass: "cont-img",
    attrs: {
      "src": __webpack_require__(51)
    }
  }), _c('div', {
    staticClass: "cont-title"
  }, [_vm._v("「背景信息」")]), _c('div', {
    staticClass: "line1"
  }, [_c('span', [_vm._v("关于屋主")]), _vm._v("陈小姐与先生也是家居领域的从商者，为了方便家里两个孩子上学，投入重金在上海黄浦区核心地段购置了这套学区房。由于职业背景缘故，两人对家居品位都有着非常高的审美与追求。")]), _c('div', {
    staticClass: "cont-title"
  }, [_vm._v("「房子的基本信息」")]), _c('div', {
    staticClass: "line1"
  }, [_c('span', [_vm._v("坐标：上海黄浦")]), _vm._v(" "), _c('span', [_vm._v("面积：175㎡")]), _vm._v(" "), _c('span', [_vm._v("户型：三室一厅")])]), _c('img', {
    staticClass: "cont-img",
    attrs: {
      "src": __webpack_require__(227)
    }
  }), _c('div', {
    staticClass: "line1"
  }, [_vm._v("房子的原始状态是毛坯房，男主人偏爱暗黑系的霸道总裁风，简约大气又不乏精致感，为了呈现出满意的效果，装修前后耗时一年之久。")]), _c('div', {
    staticClass: "cont-title"
  }, [_vm._v("玄关：简约摩登的气质")]), _c('div', {
    staticClass: "line1"
  }, [_vm._v("进门入玄关，以通透的柜体遮挡区隔，视线可及客餐厅，有种犹抱琵琶半遮面的效果。男主人偏爱冷色调，大面积的黑白与玄关天花处暗藏的灯带，将气质定格在简约摩登。")]), _c('img', {
    staticClass: "cont-img",
    attrs: {
      "src": __webpack_require__(228)
    }
  }), _c('div', {
    staticClass: "line1"
  }, [_vm._v("右手边是厨房，推拉门节省了空间。平时小孩在客厅玩，做饭的大人也能随时掌握他们的动向。")]), _c('img', {
    staticClass: "cont-img",
    attrs: {
      "src": __webpack_require__(51)
    }
  }), _c('div', {
    staticClass: "line1"
  }, [_vm._v("墙面采用大面积深棕色木饰面，虽然被家里老人吐槽说太暗了，但却为整个空间奠定了沉稳大气的基调。")]), _c('img', {
    staticClass: "cont-img",
    attrs: {
      "src": __webpack_require__(229)
    }
  }), _c('div', {
    staticClass: "line1"
  }, [_vm._v("隔断柜架的底部，也有隐藏灯带，让整个空间显得轻盈通透。上下灯带交相呼应，打造出自然柔和的照明效果。")]), _c('img', {
    staticClass: "cont-img",
    attrs: {
      "src": __webpack_require__(52)
    }
  }), _c('div', {
    staticClass: "line1"
  }, [_vm._v("地面是大面积石砖，纹路清晰自然，水墨的意蕴从地面延伸到墙上，中和木饰面的暗色调，让玄关空间更加灵活有机。")]), _c('div', {
    staticClass: "cont-title"
  }, [_vm._v("客餐厅：做足收纳，实用美观")]), _c('div', {
    staticClass: "line1"
  }, [_c('span', [_vm._v("餐厅，处处体现细心")]), _vm._v(" "), _c('span', [_vm._v("经过玄关，右转来到餐厅。")])]), _c('img', {
    staticClass: "cont-img",
    attrs: {
      "src": __webpack_require__(230)
    }
  }), _c('div', {
    staticClass: "line1"
  }, [_vm._v("这个空间的墙面依然是深色为主，吊顶和地面则是白色。")]), _c('img', {
    staticClass: "cont-img",
    attrs: {
      "src": __webpack_require__(231)
    }
  }), _c('div', {
    staticClass: "line1"
  }, [_vm._v("餐厅的主角是一整套懂窝餐桌椅。蒙塔娜餐桌 有着北美橡木的原始粗犷，经擦色涂装工艺处理，呈现出独特的做旧风味，而桌腿则为实心铸铁打造，如枝干般遒劲有力。这种硬朗的工业风，与整个空间的气质相得益彰。")]), _c('img', {
    staticClass: "cont-img",
    attrs: {
      "src": __webpack_require__(50)
    }
  }), _c('div', {
    staticClass: "line1"
  }, [_vm._v("一张蒙塔娜长凳跟餐桌配套，独特的燕尾榫成为富有巧思的点缀，两个小孩排排坐着吃饭，亲密无间又讨喜，是父辈想带给他们的快乐。")]), _c('img', {
    staticClass: "cont-img",
    attrs: {
      "src": __webpack_require__(220)
    }
  }), _c('div', {
    staticClass: "line1"
  }, [_vm._v("同时搭配四张达希尔餐椅，造型纤细优雅，颜色材质和餐桌相匹配。")]), _c('img', {
    staticClass: "cont-img",
    attrs: {
      "src": __webpack_require__(221)
    }
  }), _c('div', {
    staticClass: "line1"
  }, [_vm._v("餐厅左侧墙面有一个内嵌的置物台，可以放水壶、茶叶等物品，吃饭时还可以暂时放置碗盘，整个区域都保持着美而不乱，实用又好看。")]), _c('img', {
    staticClass: "cont-img",
    attrs: {
      "src": __webpack_require__(52)
    }
  }), _c('div', {
    staticClass: "line1"
  }, [_vm._v("餐厅区收纳功能必不可少，餐桌后面是一整面储物柜，深色玻璃起到遮掩效果，减少了杂乱感。")]), _c('img', {
    staticClass: "cont-img",
    attrs: {
      "src": __webpack_require__(50)
    }
  }), _c('div', {
    staticClass: "cont-title"
  }, [_vm._v("客厅，提升温馨感")]), _c('div', {
    staticClass: "line1"
  }, [_vm._v("紧邻餐厅的就是客厅，相对其他区域显得很明亮。设计很简洁，以白、灰为主。")]), _c('img', {
    staticClass: "cont-img",
    attrs: {
      "src": __webpack_require__(222)
    }
  }), _c('div', {
    staticClass: "line1"
  }, [_vm._v("这里是一家人活动的主要空间，增加了很多温馨的元素。比如沙发墙面采用浅灰色皮质软包，相比石材墙面，多了几分柔和。")]), _c('img', {
    staticClass: "cont-img",
    attrs: {
      "src": __webpack_require__(223)
    }
  }), _c('div', {
    staticClass: "line1"
  }, [_vm._v("电视墙依然延续了大面积石材，与地面呼应，简洁耐看。窗外透进来的自然光，经墙面反射，让客厅区因此显得明亮通透。")]), _c('img', {
    staticClass: "cont-img",
    attrs: {
      "src": __webpack_require__(224)
    }
  }), _c('div', {
    staticClass: "line1"
  }, [_vm._v("一张萨斯基亚地毯，为客厅的温馨感加分，低调的外观没有喧宾夺主，厚实柔软的触感，让这里成为小朋友们玩耍的最佳领地。")]), _c('img', {
    staticClass: "cont-img",
    attrs: {
      "src": __webpack_require__(225)
    }
  }), _c('div', {
    staticClass: "line1"
  }, [_vm._v("沙发是现代风格的懂窝热卖款弗雷德里克窄扶手四人沙发，造型简洁大方，宽大舒适。定制的棉麻面料，既温馨，又结实耐用。")]), _c('img', {
    staticClass: "cont-img",
    attrs: {
      "src": __webpack_require__(226)
    }
  }), _c('div', {
    staticClass: "line1"
  }, [_vm._v("房子是家的容器，承载了居住者的个性主张、兴趣与爱。这种暗黑系也是你喜欢的feel吗？欢迎留言告诉我们。")]), _c('div', {
    staticClass: "line1"
  }, [_vm._v("看了这么多客户家，窝仔越发觉得，不管住在怎样的房子里，每个人都应该把对生活的热情投入到每一天，再平凡的日子，也能迸发出不平凡的精彩。")]), _c('div', {
    staticClass: "cont-title"
  }, [_vm._v("装修巧思")]), _c('div', {
    staticClass: "line1"
  }, [_vm._v("•  收纳柜门选用深色玻璃，弱化杂乱感，也方便找东西")]), _c('div', {
    staticClass: "line1"
  }, [_vm._v("•  利用边角位置巧妙设计置物台，方便日常随手置物")]), _c('div', {
    staticClass: "line1"
  }, [_vm._v("•  把卫生间的门“藏”进墙面，既美观又隐蔽")]), _c('div', {
    staticClass: "cont-title1"
  }, [_vm._v(" Q&A")]), _c('div', {
    staticClass: "line2"
  }, [_c('span', [_vm._v("Q：为什么选择懂窝的家具？")]), _vm._v("装完硬装后逛家具，碰巧看到懂窝的风格跟我家很搭，价格又合理，就选择懂窝了。")]), _c('div', {
    staticClass: "line2"
  }, [_c('span', [_vm._v("Q：在软装搭配方面有什么心得？")]), _vm._v("都是让懂窝的软装搭配师帮我搭配的，大件的床、沙发、地毯，小件的抱枕、茶几、灯，搭配在一起的效果都不错。")]), _c('div', {
    staticClass: "line2"
  }, [_c('span', [_vm._v("Q：花了多少钱装修？")]), _vm._v("从硬装到软装，前前后后总共花了一百万左右吧。")])])
}]}

/***/ }),
/* 444 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "d-case"
  }, [_c('img', {
    staticClass: "top-img",
    attrs: {
      "src": __webpack_require__(53)
    }
  }), _vm._m(0), _c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.scrollTop),
      expression: "scrollTop"
    }],
    staticClass: "scroll-top-btn",
    attrs: {
      "src": __webpack_require__(4)
    },
    on: {
      "click": _vm.backtop
    }
  })])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "case-num"
  }, [_vm._v("Vol.04")]), _c('div', {
    staticClass: "case-title"
  }, [_vm._v("上海市区一套房，郊外一栋度假屋，生活这样真挺好！")]), _c('div', {
    staticClass: "line1"
  }, [_vm._v("经济发展水平越高，越多的中产阶级会渴望返璞归真，栖居田园。")]), _c('div', {
    staticClass: "line1"
  }, [_vm._v("平时工作、学习在市区，周末住郊外感受辽阔乡野，懂窝客户Josie就是这样。她把上海崇明老宅改造翻新，成了一家人周末小聚度假的胜地。")]), _c('div', {
    staticClass: "cont-title"
  }, [_vm._v("认识屋主")]), _c('div', {
    staticClass: "line1"
  }, [_vm._v("Josie，美丽的二娃宝妈。早年从事画廊工作，对美和艺术有独到理解与认知，喜欢研究服饰、家居搭配，游历世界各地，擅于发现美，更把美带到生活的点滴里。")]), _c('div', {
    staticClass: "cont-title"
  }, [_vm._v("房子的基本信息")]), _c('div', {
    staticClass: "line1"
  }, [_c('span', [_vm._v("坐标：上海崇明 ")]), _vm._v(" "), _c('span', [_vm._v("户型：三层楼别墅")]), _vm._v(" "), _c('span', [_vm._v("装修风格：现代轻奢")])]), _c('img', {
    staticClass: "cont-img",
    attrs: {
      "src": __webpack_require__(234)
    }
  }), _c('div', {
    staticClass: "cont-title"
  }, [_vm._v("崇明自住宅翻新，颠覆传统“乡村风”")]), _c('div', {
    staticClass: "line1"
  }, [_vm._v("Josie先生是上海崇明人，这栋房子是崇明父母家的自住宅。老人家年纪大了，希望能改善下居住环境，Josie也希望在乡下给孩子们留更多玩耍的空间。于是一家人决定对老宅进行翻新。")]), _c('div', {
    staticClass: "line1"
  }, [_vm._v("崇明有很多别墅，装修都比较传统，简单的白墙和装饰，在Josie看来是对空间的一种浪费。所以在装修自己家的时候，就着意颠覆传统“乡村风”。")]), _c('img', {
    staticClass: "cont-img",
    attrs: {
      "src": __webpack_require__(235)
    }
  }), _c('div', {
    staticClass: "line1"
  }, [_vm._v("上下三层楼，一楼空间主要是客厅和老人卧室，二楼是Josie一家的生活空间，三楼是健身房和孩子们的娱乐室。")]), _c('div', {
    staticClass: "line1"
  }, [_vm._v("房子的硬装整体以轻奢风为主，墙面和天花都用了很多石膏板、线，更不乏大理石、金线勾勒，凸显轻奢时尚的气质。")]), _c('div', {
    staticClass: "line1"
  }, [_vm._v("Josie对色彩的搭配有很多自己的理解，比如一楼整体以米色、灰色为主，简约耐看。相对沉稳的配色也能迎合老人的审美偏好。")]), _c('img', {
    staticClass: "cont-img",
    attrs: {
      "src": __webpack_require__(53)
    }
  }), _c('div', {
    staticClass: "line1"
  }, [_vm._v("二楼是客厅、主卧和2个儿童房。客厅墙面没有跟随近几年非常流行的复古绿，而是选用淡绿色，让空间显得更宽敞，也很跳跃有活力。")]), _c('div', {
    staticClass: "cont-title"
  }, [_vm._v("三次装修，不断迭代的审美")]), _c('div', {
    staticClass: "line1"
  }, [_vm._v("家具的选择迎合硬装色彩和整体轻奢的氛围。")]), _c('div', {
    staticClass: "line1"
  }, [_vm._v("除了定制柜体之外，基本全数购自懂窝，除了一楼客厅的茶几略显小了以外，Josie对自己的搭配甚是满意。")]), _c('img', {
    staticClass: "cont-img",
    attrs: {
      "src": __webpack_require__(236)
    }
  }), _c('div', {
    staticClass: "line1"
  }, [_vm._v("毕竟，这是经历过三次装修淬炼出的审美。")]), _c('div', {
    staticClass: "line1"
  }, [_vm._v("早年第一次装修，是自己的婚房，那时候非常喜欢北欧某品牌的家具，但用久了会觉得品质稍差一些。第二次装修学区房，买了一堆黑胡桃木色的家具，但学区房空间太小，时间长了又会觉得压抑。")]), _c('div', {
    staticClass: "line1"
  }, [_vm._v("崇明的别墅，比前面两套房子都要大很多，Josie的审美，也开始跃升到对品质、简约风格的追求。")]), _c('img', {
    staticClass: "cont-img",
    attrs: {
      "src": __webpack_require__(237)
    }
  }), _c('div', {
    staticClass: "line1"
  }, [_vm._v("她想起初到先生家，看到陈旧过时家具的那种感受，觉得自己再怎样，也要为孩子们打造一个10年20年都仍然耐看的家居环境。")]), _c('div', {
    staticClass: "line1"
  }, [_vm._v("“简约耐看的家具，同时兼具品质感，时间久了也不会觉得过时。”")]), _c('div', {
    staticClass: "cont-title"
  }, [_vm._v("懂窝的家具，为空间注入灵魂")]), _c('div', {
    staticClass: "line1"
  }, [_vm._v("懂窝的产品与Josie的审美不谋而合。")]), _c('div', {
    staticClass: "line1"
  }, [_vm._v("一楼客厅的弗雷德里克沙发，线条简约利落，米白色优雅耐看。意大利头层牛皮，高贵的品质感与绰约的空间气质非常吻合。")]), _c('img', {
    staticClass: "cont-img",
    attrs: {
      "src": __webpack_require__(238)
    }
  }), _c('div', {
    staticClass: "line1"
  }, [_vm._v("一盏艾尔弗雷德地灯，搭配在沙发边，轻巧精致，幽静的夜晚，像一轮圆月点缀角落。")]), _c('div', {
    staticClass: "line1"
  }, [_vm._v("坎普顿边几可以置物收纳，把零碎物件“藏”起来，是Josie所秉承的家居美学理念：把杂物收起来，外观尽可能赏心悦目，随着时间推移，目之所及的地方还可以摆上更多喜欢的物件。")]), _c('img', {
    staticClass: "cont-img",
    attrs: {
      "src": __webpack_require__(239)
    }
  }), _c('div', {
    staticClass: "line1"
  }, [_vm._v("主卧带阳台，马利克斯双人床与床头柜，进口楸木实木气质温暖。")]), _c('img', {
    staticClass: "cont-img",
    attrs: {
      "src": __webpack_require__(240)
    }
  }), _c('div', {
    staticClass: "line1"
  }, [_vm._v("书房也是Josie使用频率很高的地方，胡桃木色莱拉书桌与欧文台灯在丝绒窗帘映衬下，营造出一处静谧的读书角。")]), _c('img', {
    staticClass: "cont-img",
    attrs: {
      "src": __webpack_require__(232)
    }
  }), _c('div', {
    staticClass: "line1"
  }, [_vm._v("三楼是一家人的活动空间兼衣帽间，练瑜伽、跑步，小孩玩耍，都有足够的空间。福斯抽象画摆在一角，运动完了可以坐下赏画静思，在这样一个空间里放空身心，是Josie在国外游历所习得的生活方式。")]), _c('div', {
    staticClass: "line1"
  }, [_vm._v("在这栋度假屋里，荡涤工作日在城市里沾染的喧嚣，吐纳一方悠然与静谧，这样的家，大概也是很多人的梦想吧。")]), _c('img', {
    staticClass: "cont-img",
    attrs: {
      "src": __webpack_require__(233)
    }
  }), _c('div', {
    staticClass: "cont-title1"
  }, [_vm._v(" Q&A")]), _c('div', {
    staticClass: "line2"
  }, [_c('span', [_vm._v("Q：整个装修花了多少预算？")]), _vm._v("A：硬装是找朋友做的，其实没花太多，大概30万左右，家具软装这些50多万，加上老房拆改工程、电器等，100万左右吧。")]), _c('div', {
    staticClass: "line2"
  }, [_c('span', [_vm._v("Q：为什么想花这么多预算或精力来装修这套房子？")]), _vm._v("A：平时工作、上学住在上海市区，生活其实挺累的，孩子们周末也没太多地方去玩，加上长辈们也想改善下居住环境，就把房子彻底翻新改造一下，这样大家都会住得非常舒服。一个小时的车程也不会太远，一家人也可以经常团聚。")]), _c('div', {
    staticClass: "line2"
  }, [_c('span', [_vm._v("Q：你对装修或色彩搭配这块有什么个人偏好吗？")]), _vm._v("A：其实我是一个颜值控，喜欢有设计感、美的东西，然后对这些也比较挑剔。从家具搭配风格看，我比较偏向简约耐看的，因为家具要用10年、20年，它应该是品质上经久耐用的，设计上又不易过时的。同时色彩可以亮一些，这样会让氛围更加跳跃，也比较温馨。")]), _c('div', {
    staticClass: "line2"
  }, [_c('span', [_vm._v("Q：为什么选购懂窝的产品？")]), _vm._v("A：我家除了一些柜体，基本上的成品家具都在懂窝买的。还是比较符合我个人审美吧，包括品质细节这些都不错，比如床头柜里面还有一层绒布，很精致。")])])
}]}

/***/ }),
/* 445 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "d-case"
  }, [_c('img', {
    staticClass: "top-img",
    attrs: {
      "src": __webpack_require__(54)
    }
  }), _vm._m(0), _c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.scrollTop),
      expression: "scrollTop"
    }],
    staticClass: "scroll-top-btn",
    attrs: {
      "src": __webpack_require__(4)
    },
    on: {
      "click": _vm.backtop
    }
  })])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "case-num"
  }, [_vm._v("Vol.05")]), _c('div', {
    staticClass: "case-title"
  }, [_vm._v("上海93㎡萌趣三口之家，每天都像生活在游乐场")]), _c('div', {
    staticClass: "line1"
  }, [_vm._v("懂窝客户Sarah家有一个3岁的萌娃，为了给孩子创造一个充满童趣的空间，特地请了设计师夏天来做改造，把家变成“游乐场”。")]), _c('div', {
    staticClass: "cont-title"
  }, [_vm._v("关于屋主")]), _c('div', {
    staticClass: "line1"
  }, [_vm._v("Sarah，辣妈&手账达人。她与先生都是动漫迷，喜欢日式元素，手工咖啡重度爱好者。家有3岁萌娃。")]), _c('div', {
    staticClass: "cont-title"
  }, [_vm._v("关于设计师")]), _c('div', {
    staticClass: "line1"
  }, [_c('span', [_vm._v("独立设计师夏天，《天天向上》特邀嘉宾，擅长色彩搭配及充满童趣的设计。")])]), _c('div', {
    staticClass: "cont-title"
  }, [_vm._v("房子的基本信息")]), _c('div', {
    staticClass: "line1"
  }, [_c('span', [_vm._v("坐标：上海闵行")]), _vm._v(" "), _c('span', [_vm._v("面积：93㎡")]), _vm._v(" "), _c('span', [_vm._v("户型：两室一厅")])]), _c('img', {
    staticClass: "cont-img",
    attrs: {
      "src": __webpack_require__(242)
    }
  }), _c('div', {
    staticClass: "cont-title"
  }, [_vm._v("玄关：手工达人的创作空间")]), _c('div', {
    staticClass: "line1"
  }, [_vm._v("进门是一个简单的玄关。")]), _c('div', {
    staticClass: "line1"
  }, [_vm._v("辣妈Sarah是一个手工达人，嫌家里的防盗门有些旧了，就贴上毛毡“修缮一番”，好看又隔音。")]), _c('div', {
    staticClass: "line1"
  }, [_vm._v("左手边原先是一个转角，做成玄关柜，收纳进出门的杂物。")]), _c('img', {
    staticClass: "cont-img",
    attrs: {
      "src": __webpack_require__(243)
    }
  }), _c('div', {
    staticClass: "cont-title"
  }, [_vm._v("客餐厅：给生活更多玩乐空间")]), _c('div', {
    staticClass: "line1"
  }, [_vm._v("客餐厅连通成为一个大区域，厨房、小吧台、沙发区、餐厅区（观影区、收纳区）、地台儿童玩乐区一字排开。")]), _c('img', {
    staticClass: "cont-img",
    attrs: {
      "src": __webpack_require__(54)
    }
  }), _c('div', {
    staticClass: "cont-title"
  }, [_vm._v("地台，孩子的专属领地")]), _c('div', {
    staticClass: "line1"
  }, [_vm._v("为了让孩子有独立的玩乐空间，阳台做成高出地面的10㎡地台。")]), _c('div', {
    staticClass: "line1"
  }, [_vm._v("在这里，小朋友可以爬到柜子里找玩具，坐在懂窝Q萌的布墩上看风景，在小书桌边看绘本……地暖给这个冬天更多玩乐的理由。")]), _c('div', {
    staticClass: "line1"
  }, [_vm._v("地台上，特意留了3个小孔，用来放土种树，和孩子一同成长。")]), _c('img', {
    staticClass: "cont-img",
    attrs: {
      "src": __webpack_require__(244)
    }
  }), _c('div', {
    staticClass: "cont-title"
  }, [_vm._v("餐厅，也是休闲娱乐区")]), _c('div', {
    staticClass: "line1"
  }, [_vm._v("打破原先的客厅区，将其变成餐厅区，带来更多活动空间。")]), _c('div', {
    staticClass: "line1"
  }, [_vm._v("懂窝岩板桌，简洁设计，木元素餐椅，加入一点暖色。")]), _c('div', {
    staticClass: "line1"
  }, [_vm._v("电视墙做成白色收纳柜，进入卧室的门也是白色，与橱柜连为整体，关上就像一整面墙。")]), _c('div', {
    staticClass: "line1"
  }, [_vm._v("这里同时也是观影区，平时把投影幕布隐藏起来。闲暇时刻，一家人围桌而坐，或者坐在地台上观影。")]), _c('img', {
    staticClass: "cont-img",
    attrs: {
      "src": __webpack_require__(245)
    }
  }), _c('div', {
    staticClass: "cont-title"
  }, [_vm._v("沙发休闲区与岛台区")]), _c('div', {
    staticClass: "line1"
  }, [_vm._v("Sarah的家弱化了沙发区的功能，只放了一张两人座沙发。")]), _c('div', {
    staticClass: "line1"
  }, [_vm._v("夫妻俩都是咖啡重度爱好者，一个功能齐备的吧台区，满足随手冲咖啡的需求。")]), _c('div', {
    staticClass: "line1"
  }, [_vm._v("小豆丁形状的玻璃墙，能和在次卧玩耍的小朋友互动。")]), _c('div', {
    staticClass: "line1"
  }, [_vm._v("另一面墙做成了洞洞板兼黑板墙，展示夫妻俩的收藏，还满足了孩子的涂涂画画。")]), _c('img', {
    staticClass: "cont-img",
    attrs: {
      "src": __webpack_require__(246)
    }
  }), _c('div', {
    staticClass: "cont-title"
  }, [_vm._v("主卧：宁静的“蓝色海洋”")]), _c('div', {
    staticClass: "line1"
  }, [_vm._v("公共区域与私密性相对强的卧室、卫浴区，以白色的对门区隔。")]), _c('div', {
    staticClass: "line1"
  }, [_vm._v("主卧，蓝色的气质，让睡眠空间更宁静。")]), _c('div', {
    staticClass: "line1"
  }, [_vm._v("还做了一个步入式衣帽间，以丝绒布帘隔开。")]), _c('div', {
    staticClass: "line1"
  }, [_vm._v("床边放置了一个黄铜小边几代替床头柜，用来随手放手机、杯子。")]), _c('img', {
    staticClass: "cont-img",
    attrs: {
      "src": __webpack_require__(247)
    }
  }), _c('div', {
    staticClass: "cont-title"
  }, [_vm._v("次卧：用撞色勾勒出活力")]), _c('div', {
    staticClass: "line1"
  }, [_vm._v("墙面做了色块处理，脏粉与灰的撞色，让空间多了很多活力。")]), _c('div', {
    staticClass: "line1"
  }, [_vm._v("懂窝的沙发墩，灰色的布面与墙面呼应，Q萌外形很契合空间的气质。")]), _c('div', {
    staticClass: "line1"
  }, [_vm._v("木床与灰色背景墙搭配，并不突兀。")]), _c('div', {
    staticClass: "line1"
  }, [_vm._v("飘窗堆了几个懂窝的抱枕，闲时可随时倚靠。")]), _c('img', {
    staticClass: "cont-img",
    attrs: {
      "src": __webpack_require__(248)
    }
  }), _c('div', {
    staticClass: "cont-title"
  }, [_vm._v("卫生间：干湿分离，好看实用")]), _c('div', {
    staticClass: "line1"
  }, [_vm._v("卫生间干湿分离设计。")]), _c('div', {
    staticClass: "line1"
  }, [_vm._v("淋浴区用黑色杆子隔开，贴上小花砖，用黑色梯子做收纳，风格很网红。")]), _c('div', {
    staticClass: "line1"
  }, [_vm._v("干区黑色镜面浴室柜，用来收纳化妆品及洗漱用品，样式很高级。")]), _c('div', {
    staticClass: "line1"
  }, [_vm._v("底部用灯带勾勒，收纳洗脸盆等，方便实用。")]), _c('div', {
    staticClass: "line1"
  }, [_vm._v("洗衣机烘干机，刚好安置一旁。")]), _c('div', {
    staticClass: "cont-title"
  }, [_vm._v("这样一个家，有趣，有爱，其乐融融，是最温馨最日常的生活状态。")]), _c('img', {
    staticClass: "cont-img",
    attrs: {
      "src": __webpack_require__(241)
    }
  }), _c('div', {
    staticClass: "cont-title1"
  }, [_vm._v(" Q&A")]), _c('div', {
    staticClass: "line2"
  }, [_c('span', [_vm._v("Q：为什么选择购买懂窝家具？")]), _vm._v("一开始是被懂窝家具的颜值所吸引，设计简约很有时尚感。后面仔细研究过产品，品质也非常好，一些设计细节（比如边角的处理）对小朋友也非常友好。")]), _c('div', {
    staticClass: "line2"
  }, [_c('span', [_vm._v("Q：希望给孩子打造一个怎样的家？")]), _vm._v("家是一个最让人放松的地方。我希望他能在这里开心的玩，快乐的长大。充满正能量，不仅有趣，还很有爱。")])])
}]}

/***/ }),
/* 446 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "d-case"
  }, [_c('img', {
    staticClass: "top-img",
    attrs: {
      "src": __webpack_require__(249)
    }
  }), _vm._m(0), _c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.scrollTop),
      expression: "scrollTop"
    }],
    staticClass: "scroll-top-btn",
    attrs: {
      "src": __webpack_require__(4)
    },
    on: {
      "click": _vm.backtop
    }
  })])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "case-num"
  }, [_vm._v("Vol.06")]), _c('div', {
    staticClass: "case-title"
  }, [_vm._v("设计师爆改上海50㎡老房，示范小户型改造神操作")]), _c('div', {
    staticClass: "line1"
  }, [_vm._v("50㎡的房子可以玩出啥花样？窝仔的设计师朋友周琴，居然打造出客厅、卧室、厨房、餐厅、阳台、书房、储物区7大功能区，而且几乎任何边角位置都被充分利用，简直堪比大户型！")]), _c('img', {
    staticClass: "cont-img",
    attrs: {
      "src": __webpack_require__(260)
    }
  }), _c('div', {
    staticClass: "cont-title"
  }, [_vm._v("「背景信息」")]), _c('div', {
    staticClass: "line1"
  }, [_c('span', [_vm._v("关于屋主")]), _vm._v("设计师周琴，知性女汉子一枚。从业近10年，帮无数业主实现过家的样子，在设计自住房的时候，自然要好好玩上一把。一个手枪型、只有50㎡的上海老房，让她充分挑战了设计极限。")]), _c('div', {
    staticClass: "cont-title"
  }, [_vm._v("「房子的基本信息」")]), _c('div', {
    staticClass: "line1"
  }, [_c('span', [_vm._v("坐标：上海普陀")]), _vm._v(" "), _c('span', [_vm._v("户型：两室两厅")]), _vm._v(" "), _c('span', [_vm._v("使用面积：49㎡")]), _vm._v(" "), _c('span', [_vm._v("原始状态：80年代老房")]), _vm._v(" "), _c('span', [_vm._v("装修风格：现代轻奢")])]), _c('img', {
    staticClass: "cont-img",
    attrs: {
      "src": __webpack_require__(267)
    }
  }), _c('div', {
    staticClass: "line1"
  }, [_vm._v("原始房型图长得像一把手枪，很多建于70、80年代的上海老房都有这个特点——没有厅。拿到房子以后，周琴首先想到就是按功能需求重新做空间划分。")]), _c('div', {
    staticClass: "cont-title"
  }, [_vm._v("客厅 15.5㎡：将卧室一分为二变出厅")]), _c('div', {
    staticClass: "line1"
  }, [_vm._v("北卧室和南卧室是连一长条的，原本的想法是把中间的墙拿掉，让客厅更大些，敲墙的时候发现是混凝土，就放弃了。")]), _c('img', {
    staticClass: "cont-img",
    attrs: {
      "src": __webpack_require__(268)
    }
  }), _c('div', {
    staticClass: "line1"
  }, [_vm._v("所以现在看到的客厅，是从原来的卧室一分为二改造出来的，中间采用三联动移门＋窗帘作为隔断。白天可以将窗帘拉开，这样光可以透进来。")]), _c('img', {
    staticClass: "cont-img",
    attrs: {
      "src": __webpack_require__(269)
    }
  }), _c('div', {
    staticClass: "line1"
  }, [_vm._v("电视墙一侧之前是通往餐厅的门洞，砌高60公分，让电视墙有了延伸，看起来客厅好像更大了。同时坐在客厅可透过门洞望向餐厅，两个空间有了联动，视觉上也更通透。")]), _c('img', {
    staticClass: "cont-img",
    attrs: {
      "src": __webpack_require__(270)
    }
  }), _c('div', {
    staticClass: "line1"
  }, [_vm._v("小户型整体硬装比较简单，主要采用大量软装进行装饰。整体的风格复古、轻奢、有质感，墙上的画组合摆放，看似毫无章法又很和谐。")]), _c('img', {
    staticClass: "cont-img",
    attrs: {
      "src": __webpack_require__(271)
    }
  }), _c('div', {
    staticClass: "line1"
  }, [_vm._v("复古绿沙发、实木电视柜和边柜，都是外形简洁、相对细腿儿的款，可以让空间看起来更大。")]), _c('img', {
    staticClass: "cont-img",
    attrs: {
      "src": __webpack_require__(272)
    }
  }), _c('div', {
    staticClass: "cont-title"
  }, [_vm._v("卧室 8㎡：无靠背床节省空间")]), _c('div', {
    staticClass: "line1"
  }, [_vm._v("从客厅延续到卧室的咖色硅藻泥墙，主要为了满足卧室的无靠背床。用硅藻泥做床头，相对涂料来说没那么脆弱，质感更好。")]), _c('img', {
    staticClass: "cont-img",
    attrs: {
      "src": __webpack_require__(273)
    }
  }), _c('div', {
    staticClass: "line1"
  }, [_vm._v("中间拉上一条金色不锈钢U型槽，像精致的腰封。")]), _c('div', {
    staticClass: "line1"
  }, [_vm._v("小窍门：施工顺序是先做墙面涂料，后做金线条，最后做硅藻泥。")]), _c('img', {
    staticClass: "cont-img",
    attrs: {
      "src": __webpack_require__(250)
    }
  }), _c('div', {
    staticClass: "line1"
  }, [_vm._v("为了节省空间，床两侧没有设置常规的床头柜，而是摆了两张非常简单的角几，用来随手放东西。")]), _c('img', {
    staticClass: "cont-img",
    attrs: {
      "src": __webpack_require__(251)
    }
  }), _c('div', {
    staticClass: "line1"
  }, [_vm._v("正对床是一面顶天立地的衣柜，门采用的是模压板材质，黑色长拉手，这样的处理可以弱化它在空间的存在感，看起来非常简约。")]), _c('img', {
    staticClass: "cont-img",
    attrs: {
      "src": __webpack_require__(252)
    }
  }), _c('div', {
    staticClass: "line1"
  }, [_vm._v("衣柜尺寸经过缜密计算，柜体占据53公分，过道49公分，刚好方便走路。")]), _c('div', {
    staticClass: "line1"
  }, [_vm._v("小窍门：做成开门的衣柜，更节省空间。如果做成移门，轨道需要8公分左右。")]), _c('img', {
    staticClass: "cont-img",
    attrs: {
      "src": __webpack_require__(253)
    }
  }), _c('div', {
    staticClass: "cont-title"
  }, [_vm._v("阳台 4㎡：一个人的休闲区")]), _c('div', {
    staticClass: "line1"
  }, [_vm._v("阳台也包含到卧室内，让空间看起来更大了。洗衣、晾衣和休闲娱乐，都可以在这里得到满足。")]), _c('div', {
    staticClass: "line1"
  }, [_vm._v("小窍门：洗衣机上部分有一些管道，做了柜子即可收纳又可遮挡。")]), _c('img', {
    staticClass: "cont-img",
    attrs: {
      "src": __webpack_require__(254)
    }
  }), _c('div', {
    staticClass: "cont-title"
  }, [_vm._v("餐厅 3.6㎡：卡座式设计更实用")]), _c('div', {
    staticClass: "line1"
  }, [_vm._v("餐厅做成卡座式，更能节约空间，同样采用硅藻泥水泥漆做靠背。原木色餐桌可以打开，扩大后能有1.2*0.8米，足够三五朋友聚餐。")]), _c('img', {
    staticClass: "cont-img",
    attrs: {
      "src": __webpack_require__(255)
    }
  }), _c('div', {
    staticClass: "line1"
  }, [_vm._v("周琴很喜欢墨绿色，家里无处不在的墨绿。餐厅内更是刷上一整面墨绿，复古又时尚。简单拉根绳，挂几张照片，充满温馨感。")]), _c('img', {
    staticClass: "cont-img",
    attrs: {
      "src": __webpack_require__(256)
    }
  }), _c('div', {
    staticClass: "line1"
  }, [_vm._v("唯一的遗憾是灯被工人装错了位置，好在灯是可以上下调节的，所以不会碰头。")]), _c('div', {
    staticClass: "cont-title"
  }, [_vm._v("厨房 2.8㎡：挑战史上最小厨房")]), _c('div', {
    staticClass: "line1"
  }, [_vm._v("周琴笑称她家有“史上最小的厨房”。长度2.2米，宽度1.18米，煤气灶台面做了55公分，过道还留了63公分，下柜部分全部做了抽屉，比开门好用，收纳力很强大。")]), _c('img', {
    staticClass: "cont-img",
    attrs: {
      "src": __webpack_require__(257)
    }
  }), _c('div', {
    staticClass: "line1"
  }, [_vm._v("如果是开门，基本上下柜只能设计2层，但是做抽屉，可以做3层。靠水槽边上，留了一块地方放松下的蒸烤一体机，当微波炉使用。")]), _c('img', {
    staticClass: "cont-img",
    attrs: {
      "src": __webpack_require__(258)
    }
  }), _c('div', {
    staticClass: "line1"
  }, [_vm._v("厨房右边的三联动移门叠在一起刚好跟橱柜宽度一致，白色鱼骨砖颜值很高，但是缝隙很大，建议做美缝，否则后期油腻很难打理。")]), _c('img', {
    staticClass: "cont-img",
    attrs: {
      "src": __webpack_require__(259)
    }
  }), _c('div', {
    staticClass: "cont-title"
  }, [_vm._v("卫生间 2㎡：向厨房借面积")]), _c('div', {
    staticClass: "line1"
  }, [_vm._v("老榆木台面做的洗手盆，由于空间狭窄，台面厚度只有30厘米，所以做了台上盆＋墙排水＋墙出水，节约空间的同时，台盆下面也看不到难看的污水管，增加收纳空间。")]), _c('img', {
    staticClass: "cont-img",
    attrs: {
      "src": __webpack_require__(261)
    }
  }), _c('div', {
    staticClass: "cont-title"
  }, [_vm._v("书房 8.4㎡：办公收纳两不误")]), _c('div', {
    staticClass: "line1"
  }, [_vm._v("这是被保留最完整的一个空间，也是周琴平时待得最多的地方。")]), _c('img', {
    staticClass: "cont-img",
    attrs: {
      "src": __webpack_require__(262)
    }
  }), _c('div', {
    staticClass: "line1"
  }, [_vm._v("灰色的墙面，用爱格板仿实木色作为整个台面，视觉高度统一，各种抽屉特别好用。")]), _c('img', {
    staticClass: "cont-img",
    attrs: {
      "src": __webpack_require__(263)
    }
  }), _c('div', {
    staticClass: "line1"
  }, [_vm._v("因为没有玄关，鞋子不够放，这面柜子主要用来放包包，鞋子，以及一些杂物的。")]), _c('img', {
    staticClass: "cont-img",
    attrs: {
      "src": __webpack_require__(264)
    }
  }), _c('div', {
    staticClass: "cont-title"
  }, [_vm._v("储物柜：小户型收纳实用方案")]), _c('div', {
    staticClass: "line1"
  }, [_vm._v("厨房太迷你，所以冰箱是放过道这里的，比较遗憾的是门洞不一样高，因为上面有结构梁。")]), _c('img', {
    staticClass: "cont-img",
    attrs: {
      "src": __webpack_require__(265)
    }
  }), _c('div', {
    staticClass: "line1"
  }, [_vm._v("冰箱周边定制了一组柜子，白色哑光模压材质，拉手用的是比较简洁的黑长拉手。对小户型来说非常实用。")]), _c('img', {
    staticClass: "cont-img",
    attrs: {
      "src": __webpack_require__(266)
    }
  }), _c('div', {
    staticClass: "line1"
  }, [_vm._v("看完这个家，你还会觉得小户型不够用吗？窝仔反而觉得小而美，住起来更温馨了。")])])
}]}

/***/ }),
/* 447 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "d-case"
  }, [_c('img', {
    staticClass: "top-img",
    attrs: {
      "src": __webpack_require__(274)
    }
  }), _vm._m(0), _c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.scrollTop),
      expression: "scrollTop"
    }],
    staticClass: "scroll-top-btn",
    attrs: {
      "src": __webpack_require__(4)
    },
    on: {
      "click": _vm.backtop
    }
  })])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "case-num"
  }, [_vm._v("Vol.07")]), _c('div', {
    staticClass: "case-title"
  }, [_vm._v("65㎡精致小户型，处女座男生的神仙日子")]), _c('div', {
    staticClass: "line1"
  }, [_vm._v("每个细节精心设计、专门的娱乐室、融入潮流元素，这简直是年轻人的梦想屋啊")]), _c('div', {
    staticClass: "line1"
  }, [_vm._v("窝仔今天拜访的客户，是一名处女座男生。一起看看他精心打造的65㎡精致小屋吧。")]), _c('div', {
    staticClass: "cont-title"
  }, [_vm._v("关于屋主")]), _c('div', {
    staticClass: "line1"
  }, [_vm._v("屋主华先生追求精致生活，在房子的装修中，融入了很多自己的心思。")]), _c('div', {
    staticClass: "line1"
  }, [_vm._v("华先生与心爱的人相识3年，两人有很多共同爱好，也很有默契。")]), _c('div', {
    staticClass: "line1"
  }, [_vm._v("虽然现在是独自居住，但他计划这套房子以后用作婚房，所以在装修中也加入很多对未来生活的期待。")]), _c('img', {
    staticClass: "cont-img",
    attrs: {
      "src": __webpack_require__(285)
    }
  }), _c('div', {
    staticClass: "cont-title"
  }, [_vm._v("「房子的基本信息」")]), _c('div', {
    staticClass: "line1"
  }, [_c('span', [_vm._v("坐标：上海静安")]), _vm._v(" "), _c('span', [_vm._v("面积：65㎡")]), _vm._v(" "), _c('span', [_vm._v("户型：两室一厅")])]), _c('img', {
    staticClass: "cont-img",
    attrs: {
      "src": __webpack_require__(296)
    }
  }), _c('div', {
    staticClass: "line1"
  }, [_vm._v("虽然屋主年初时才搬进来，但整洁程度还是超出了我们的预计。处女座的“天生优势”被发挥得淋漓尽致。")]), _c('div', {
    staticClass: "line1"
  }, [_vm._v("不仅如此，精心搭配的装饰花卉，加之屋主心爱的玄凤鹦鹉，给我们呈上了一场“鸟语花香”的视听享受。")]), _c('div', {
    staticClass: "cont-title"
  }, [_vm._v("玄关&客厅"), _c('br'), _vm._v("三大巧思，给小户型加分")]), _c('div', {
    staticClass: "line1"
  }, [_vm._v("还没进屋，就发现了主人的小心思。")]), _c('div', {
    staticClass: "line1"
  }, [_vm._v("大门上，主人亲手粘贴了毛毡。“Home is where we are”，给人回到家的温馨感。")]), _c('img', {
    staticClass: "cont-img",
    attrs: {
      "src": __webpack_require__(299)
    }
  }), _c('div', {
    staticClass: "line1"
  }, [_vm._v("进入大门，第一个空间是客餐厅。")]), _c('div', {
    staticClass: "line2"
  }, [_vm._v("巧思1：精心搭配，展示精致生活")]), _c('div', {
    staticClass: "line1"
  }, [_vm._v("客厅面积不大，家具摆放比较紧凑，没有多余的物件。给人的整体感觉，是精致、轻奢。")]), _c('img', {
    staticClass: "cont-img",
    attrs: {
      "src": __webpack_require__(300)
    }
  }), _c('div', {
    staticClass: "line1"
  }, [_vm._v("硬装色调定调之后，软装其实无需过分复杂，只要家具挑选得当，就轻松搭配出了精致轻奢风。")]), _c('img', {
    staticClass: "cont-img",
    attrs: {
      "src": __webpack_require__(301)
    }
  }), _c('div', {
    staticClass: "line1"
  }, [_vm._v("深蓝色的伊丽莎白沙发，颜色沉静，坐感柔软，一进屋就可以立刻坐下放松。")]), _c('img', {
    staticClass: "cont-img",
    attrs: {
      "src": __webpack_require__(302)
    }
  }), _c('div', {
    staticClass: "line1"
  }, [_vm._v("粉色、灰色的安普天鹅绒抱枕，跟深蓝形成对比，把优雅气质提到最佳。")]), _c('img', {
    staticClass: "cont-img",
    attrs: {
      "src": __webpack_require__(303)
    }
  }), _c('div', {
    staticClass: "line1"
  }, [_vm._v("沙发的丝绒材质，配上手感顺滑的桑德罗羊皮毯，让原本简洁的客厅，更有了一丝低调的奢华质感。")]), _c('img', {
    staticClass: "cont-img",
    attrs: {
      "src": __webpack_require__(304)
    }
  }), _c('div', {
    staticClass: "line1"
  }, [_vm._v("在木地板上铺一张圆形的莫西兔毛地毯，中和了木地板的硬朗，把温馨感衬托到极致。")]), _c('img', {
    staticClass: "cont-img",
    attrs: {
      "src": __webpack_require__(275)
    }
  }), _c('div', {
    staticClass: "line2"
  }, [_vm._v("巧思2：墙面做柜体，增加收纳空间")]), _c('div', {
    staticClass: "line1"
  }, [_vm._v("很多人会担心，小户型没有足够的收纳空间，设计师给了很好的解决方案。"), _c('br'), _vm._v(" 把客厅墙面打造成柜体，增加了不少的收纳空间。")]), _c('img', {
    staticClass: "cont-img",
    attrs: {
      "src": __webpack_require__(276)
    }
  }), _c('div', {
    staticClass: "line1"
  }, [_vm._v("白色柜门与白色墙面融为一体。厨房的门，也在其中。"), _c('br'), _vm._v(" 把凌乱和油烟，都藏了起来。做饭的油烟和吵闹，也不会打扰到公共区域。")]), _c('img', {
    staticClass: "cont-img",
    attrs: {
      "src": __webpack_require__(277)
    }
  }), _c('div', {
    staticClass: "line2"
  }, [_vm._v("巧思3：餐桌靠窗设计，不占地又实用")]), _c('div', {
    staticClass: "line1"
  }, [_vm._v("紧邻主沙发的，是一张嵌入式餐桌，与墙面收纳柜连成一体。")]), _c('img', {
    staticClass: "cont-img",
    attrs: {
      "src": __webpack_require__(278)
    }
  }), _c('div', {
    staticClass: "line1"
  }, [_vm._v("挨着窗户，在这里吃饭、喝茶时，还可以欣赏到窗外的景色。")]), _c('img', {
    staticClass: "cont-img",
    attrs: {
      "src": __webpack_require__(279)
    }
  }), _c('div', {
    staticClass: "line1"
  }, [_vm._v("搭配两张懂窝餐椅，绒面材质和金属椅腿，轻巧不繁杂，轻奢的质感与沙发区域相映成趣。")]), _c('img', {
    staticClass: "cont-img",
    attrs: {
      "src": __webpack_require__(280)
    }
  }), _c('div', {
    staticClass: "cont-title"
  }, [_vm._v("娱乐室 "), _c('br'), _vm._v("次卧改成娱乐室，使用率翻倍")]), _c('div', {
    staticClass: "line1"
  }, [_vm._v("房子的重头戏之一，就是华先生专门打造的娱乐室。"), _c('br'), _vm._v(" 这个房间本来是次卧，改成娱乐室，使用率更高，也弥补了客餐厅有限的功能。")]), _c('img', {
    staticClass: "cont-img",
    attrs: {
      "src": __webpack_require__(281)
    }
  }), _c('div', {
    staticClass: "line1"
  }, [_vm._v("娱乐室里，靠墙摆放了一台钢琴。因为两人都爱好钢琴，华先生为此专门购入。")]), _c('img', {
    staticClass: "cont-img",
    attrs: {
      "src": __webpack_require__(282)
    }
  }), _c('div', {
    staticClass: "line1"
  }, [_vm._v("聊得兴起，他现场为我们弹奏了几首曲子，屋里立刻充满了艺术气息。")]), _c('img', {
    staticClass: "cont-img",
    attrs: {
      "src": __webpack_require__(283)
    }
  }), _c('div', {
    staticClass: "line1"
  }, [_vm._v("除了钢琴，还计划在这间房配一台投影仪，在家也能随时欣赏精彩大片。"), _c('br'), _vm._v(" 一张舒服的沙发，是看电影的必备。")]), _c('div', {
    staticClass: "line1"
  }, [_vm._v("米白色的巴罗羽绒填充沙发，与深粉色墙面搭配，安静沉稳。")]), _c('img', {
    staticClass: "cont-img",
    attrs: {
      "src": __webpack_require__(284)
    }
  }), _c('div', {
    staticClass: "line1"
  }, [_vm._v("一张小茶几，方便放零食、茶水。跟客厅一样的圆形兔毛地毯，让房间更加温暖，就算冬天光脚也不觉得冷，观影的同时更加放松。")]), _c('img', {
    staticClass: "cont-img",
    attrs: {
      "src": __webpack_require__(286)
    }
  }), _c('div', {
    staticClass: "line1"
  }, [_vm._v("灰色系棉麻质地的冬丽抱枕，跟浅色沙发刚好搭配，也与地毯的颜色呼应。")]), _c('img', {
    staticClass: "cont-img",
    attrs: {
      "src": __webpack_require__(287)
    }
  }), _c('div', {
    staticClass: "line1"
  }, [_vm._v("角落的欧文黄铜地灯，光线柔和温馨，把娱乐室烘托得更加惬意。")]), _c('img', {
    staticClass: "cont-img",
    attrs: {
      "src": __webpack_require__(288)
    }
  }), _c('div', {
    staticClass: "cont-title"
  }, [_vm._v("卧室"), _c('br'), _vm._v(" 沉静不失浪漫，还有“金屋藏娇”")]), _c('div', {
    staticClass: "line1"
  }, [_vm._v("卧室的配色跟娱乐室截然不同，沉静的蓝色墙面，一走进来，人就自然放松了。"), _c('br'), _vm._v(" 灰色的娜塔莎丝绒双人床，搭配蓝色的墙面，显得和谐优雅。")]), _c('img', {
    staticClass: "cont-img",
    attrs: {
      "src": __webpack_require__(289)
    }
  }), _c('div', {
    staticClass: "line1"
  }, [_vm._v("床上艾塔四件套也经过了精心挑选，灰蓝双面配色，高密贡缎质地。")]), _c('img', {
    staticClass: "cont-img",
    attrs: {
      "src": __webpack_require__(290)
    }
  }), _c('div', {
    staticClass: "line1"
  }, [_vm._v("华先生还特意在床头摆了鲜花，生活精致程度可见一斑。闻着花香，睡在这舒服的大床上，梦也更甜美了。")]), _c('img', {
    staticClass: "cont-img",
    attrs: {
      "src": __webpack_require__(291)
    }
  }), _c('div', {
    staticClass: "line1"
  }, [_vm._v("房间一角的海尔格羽毛落地灯，光线轻柔，把卧室的氛围营造得更浪漫。")]), _c('img', {
    staticClass: "cont-img",
    attrs: {
      "src": __webpack_require__(292)
    }
  }), _c('img', {
    staticClass: "cont-img",
    attrs: {
      "src": __webpack_require__(293)
    }
  }), _c('div', {
    staticClass: "line1"
  }, [_vm._v("“躲”在房间阳台的，是华先生心爱的宠物“秋秋”（音），一只漂亮的玄凤鹦鹉。")]), _c('img', {
    staticClass: "cont-img",
    attrs: {
      "src": __webpack_require__(294)
    }
  }), _c('div', {
    staticClass: "line1"
  }, [_vm._v("它居住的鸟笼跟主人的家一样精致，娱乐、饮食设施一应俱全，堪称鸟笼“豪宅”。")]), _c('div', {
    staticClass: "cont-title"
  }, [_vm._v("厨房&卫生间"), _c('br'), _vm._v(" 简洁实用，同时紧跟潮流")]), _c('div', {
    staticClass: "line1"
  }, [_vm._v("厨房和卫生间则以白色为主色调，让小空间不显拥挤。")]), _c('img', {
    staticClass: "cont-img",
    attrs: {
      "src": __webpack_require__(295)
    }
  }), _c('div', {
    staticClass: "line1"
  }, [_vm._v("卫生间采用了时下流行的谷仓门设计，别出心裁，同时也更节省空间。")]), _c('img', {
    staticClass: "cont-img",
    attrs: {
      "src": __webpack_require__(297)
    }
  }), _c('div', {
    staticClass: "line1"
  }, [_vm._v("镜子也紧跟科技，圆形镜面围绕触控灯带，洗漱、化妆时照得一清二楚。")]), _c('img', {
    staticClass: "cont-img",
    attrs: {
      "src": __webpack_require__(298)
    }
  }), _c('div', {
    staticClass: "cont-title"
  }, [_vm._v("装修巧思")]), _c('div', {
    staticClass: "line1"
  }, [_vm._v("•  房子的功能可以因人而异，比如把次卧改成娱乐室")]), _c('div', {
    staticClass: "line1"
  }, [_vm._v("•  定好了硬装，软装无需复杂，几件家具就能搭出精致感")]), _c('div', {
    staticClass: "line1"
  }, [_vm._v("•  墙面改柜体，增加收纳空间，采用白色柜门，与墙面融为一体")]), _c('div', {
    staticClass: "line1"
  }, [_vm._v("•  卫生间采用谷仓门设计，既新潮又节省空间")]), _c('div', {
    staticClass: "cont-title1"
  }, [_vm._v(" Q&A")]), _c('div', {
    staticClass: "line2"
  }, [_c('span', [_vm._v("Q：为什么会选择懂窝的家具呢？")]), _vm._v("挑选家具时，设计师推荐了我另一家。但是那家的色调太深沉了。后来我发现了懂窝，设计更丰富，性价比也高，所以就在懂窝买了。")]), _c('div', {
    staticClass: "line2"
  }, [_c('span', [_vm._v("Q：在软装搭配方面有什么心得？")]), _vm._v("懂窝的软装搭配师有帮我推荐。然后我根据家里的装修基调，加上自己的喜好，挑选了几款家具，碰巧挑了两款懂窝的热卖沙发。")])])
}]}

/***/ }),
/* 448 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "d-case"
  }, [_c('img', {
    staticClass: "top-img",
    attrs: {
      "src": __webpack_require__(305)
    }
  }), _vm._m(0), _c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.scrollTop),
      expression: "scrollTop"
    }],
    staticClass: "scroll-top-btn",
    attrs: {
      "src": __webpack_require__(4)
    },
    on: {
      "click": _vm.backtop
    }
  })])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "case-num"
  }, [_vm._v("Vol.08")]), _c('div', {
    staticClass: "case-title"
  }, [_vm._v("不请设计师，魔都小两口玩转91㎡两房，软装配色美出天际")]), _c('img', {
    staticClass: "cont-img",
    attrs: {
      "src": __webpack_require__(316)
    }
  }), _c('div', {
    staticClass: "line1"
  }, [_vm._v("Siney夫妇是典型的90后，崇尚自我，喜欢时尚潮流。他们对生活审美的追求，就表达在这套新房里。")]), _c('img', {
    staticClass: "cont-img",
    attrs: {
      "src": __webpack_require__(327)
    }
  }), _c('div', {
    staticClass: "line1"
  }, [_vm._v("两人经历了长达9年的爱情长跑，去年领证结婚，今年年初搬进新居，感情生活水到渠成。生活里的一切，都呈现着不多不少、刚刚好的状态。")]), _c('img', {
    staticClass: "cont-img",
    attrs: {
      "src": __webpack_require__(338)
    }
  }), _c('div', {
    staticClass: "line1"
  }, [_vm._v("装修没有请设计师，而是由夫妻俩亲自设计。空间功能、多个细节，都按照两人的喜好来定，打造出属于自己的完美新居。")]), _c('img', {
    staticClass: "cont-img",
    attrs: {
      "src": __webpack_require__(341)
    }
  }), _c('div', {
    staticClass: "line2"
  }, [_vm._v("Siney的先生对空间布局颇有研究，根据两人的生活习惯，"), _c('br'), _vm._v(" 对原始户型做了不少的调整。")]), _c('div', {
    staticClass: "line1"
  }, [_vm._v("挪动餐厅墙面，增加活动空间"), _c('br'), _vm._v("储物间改成衣帽间，更适合时尚达人"), _c('br'), _vm._v(" 卫生间干湿分离，可同时使用、互不干扰"), _c('br'), _vm._v("次卧当工作室，满足在家办公需求")]), _c('img', {
    staticClass: "cont-img",
    attrs: {
      "src": __webpack_require__(342)
    }
  }), _c('div', {
    staticClass: "line1"
  }, [_vm._v("改造后的客餐厅，有强烈的通透感，这里是家里主要的活动区域。")]), _c('img', {
    staticClass: "cont-img",
    attrs: {
      "src": __webpack_require__(343)
    }
  }), _c('div', {
    staticClass: "line1"
  }, [_vm._v("两人喜欢玩switch，需要大一点的活动空间，所以客厅搭配不复杂，保留空间的宽敞度。")]), _c('img', {
    staticClass: "cont-img",
    attrs: {
      "src": __webpack_require__(344)
    }
  }), _c('div', {
    staticClass: "line1"
  }, [_vm._v("Siney从小学芭蕾，有良好的艺术熏陶，加上老公对装修的研究，两人在软装上都有很不错的审美水平。家里的大件小件，都由两人亲自挑选搭配。")]), _c('img', {
    staticClass: "cont-img",
    attrs: {
      "src": __webpack_require__(345)
    }
  }), _c('div', {
    staticClass: "line1"
  }, [_vm._v("转角沙发宽大舒适，贵妃位坐卧皆宜。阳台采光充足，视野开阔，坐在这里感觉很棒。"), _c('br'), _vm._v(" 这段时间因为疫情，Siney经常在家办公，所以除了次卧外，这里也成了她临时的“办公区”。")]), _c('img', {
    staticClass: "cont-img",
    attrs: {
      "src": __webpack_require__(306)
    }
  }), _c('div', {
    staticClass: "line1"
  }, [_vm._v("客厅沙发区的挂画、抱枕和吕格地毯经过了精心搭配，三者从色彩到图案，都相互呼应")]), _c('img', {
    staticClass: "cont-img",
    attrs: {
      "src": __webpack_require__(307)
    }
  }), _c('div', {
    staticClass: "line1"
  }, [_vm._v("窗帘则与沙发同为灰色，形成呼应。")]), _c('img', {
    staticClass: "cont-img",
    attrs: {
      "src": __webpack_require__(308)
    }
  }), _c('div', {
    staticClass: "line1"
  }, [_vm._v("客厅区还配了一张达拉斯懒人沙发，可以随时挪动。")]), _c('div', {
    staticClass: "line1"
  }, [_vm._v("妈妈隔三差五过来玩，喜欢把懒人沙发放在阳台上，坐着晒太阳，享受慵懒时光。")]), _c('img', {
    staticClass: "cont-img",
    attrs: {
      "src": __webpack_require__(309)
    }
  }), _c('div', {
    staticClass: "line1"
  }, [_vm._v("Siney对自己挑的这套詹森茶几赞不绝口，颜值高、又实用，小个茶几还能放角落当边几。朋友来家里玩，都问她在哪买的。")]), _c('img', {
    staticClass: "cont-img",
    attrs: {
      "src": __webpack_require__(310)
    }
  }), _c('div', {
    staticClass: "line1"
  }, [_vm._v("客厅的收纳柜不多，精选了两款，是同一系列。")]), _c('div', {
    staticClass: "line1"
  }, [_vm._v("游戏卡、电子产品等物品，都放在埃尔坎电视柜里，保持客厅的干净整洁。")]), _c('img', {
    staticClass: "cont-img",
    attrs: {
      "src": __webpack_require__(311)
    }
  }), _c('div', {
    staticClass: "line1"
  }, [_vm._v("生活用品、化妆品之类，则放在靠近卫生间的埃尔坎五斗柜里，方便拿取和使用。")]), _c('img', {
    staticClass: "cont-img",
    attrs: {
      "src": __webpack_require__(312)
    }
  }), _c('div', {
    staticClass: "line1"
  }, [_vm._v("可以看到，在选择家具、家居时，两人还很注意细节。柜子、拉森大理石挂钟等物件上，都采用了黄铜材质，打造轻奢的质感。")]), _c('img', {
    staticClass: "cont-img",
    attrs: {
      "src": __webpack_require__(313)
    }
  }), _c('div', {
    staticClass: "line1"
  }, [_vm._v("挪动了餐厅和卫生间之间的墙壁，餐厅变大了，卫生间空间也依然足够。家人朋友来家里玩，有了更宽阔的活动区域。")]), _c('img', {
    staticClass: "cont-img",
    attrs: {
      "src": __webpack_require__(314)
    }
  }), _c('div', {
    staticClass: "line1"
  }, [_vm._v("全黑色实木的蒙塔娜餐桌，面积宽大，平时两人在家吃饭很宽敞，家人朋友偶尔来玩，也很够用。")]), _c('div', {
    staticClass: "line1"
  }, [_vm._v("搭配四张黑色的罗谢尔温莎餐椅，再配上Siney挑选的坐垫和椅腿套，餐厅的氛围既高级又有趣。")]), _c('img', {
    staticClass: "cont-img",
    attrs: {
      "src": __webpack_require__(315)
    }
  }), _c('div', {
    staticClass: "line1"
  }, [_vm._v("餐桌上的欧文台灯，黄铜材质与家具吻合。靠墙摆放的艾伯特装饰画，让餐厅有了艺术的气息。")]), _c('img', {
    staticClass: "cont-img",
    attrs: {
      "src": __webpack_require__(317)
    }
  }), _c('div', {
    staticClass: "line1"
  }, [_vm._v("花瓶也是很好的装饰品，一套哈里斯花瓶高低错落，带来层叠有致的美妙景致。")]), _c('img', {
    staticClass: "cont-img",
    attrs: {
      "src": __webpack_require__(318)
    }
  }), _c('div', {
    staticClass: "line1"
  }, [_vm._v("搭配的一张希科地毯，厚实柔软，条纹图案，让餐厅空间的温馨感更加饱满。")]), _c('img', {
    staticClass: "cont-img",
    attrs: {
      "src": __webpack_require__(319)
    }
  }), _c('div', {
    staticClass: "line1"
  }, [_vm._v("整墙餐边柜是定制的，收纳能力充足，兼具展示功能。")]), _c('img', {
    staticClass: "cont-img",
    attrs: {
      "src": __webpack_require__(320)
    }
  }), _c('div', {
    staticClass: "line1"
  }, [_vm._v("架子上摆放着Siney最爱的pop mart玩偶，这整盒的玩偶都是抽盲盒得来的，花了好一番功夫呢！")]), _c('img', {
    staticClass: "cont-img",
    attrs: {
      "src": __webpack_require__(321)
    }
  }), _c('div', {
    staticClass: "line1"
  }, [_vm._v("与餐桌相对的是入户处，安装了全身镜和挂钩，简洁实用。")]), _c('img', {
    staticClass: "cont-img",
    attrs: {
      "src": __webpack_require__(322)
    }
  }), _c('img', {
    staticClass: "cont-img",
    attrs: {
      "src": __webpack_require__(323)
    }
  }), _c('div', {
    staticClass: "line1"
  }, [_vm._v("紧挨大门处，本来有一个储物间，Siney家把储物间的开口调整到了主卧内，并把它改成了步入式衣帽间。")]), _c('img', {
    staticClass: "cont-img",
    attrs: {
      "src": __webpack_require__(324)
    }
  }), _c('div', {
    staticClass: "line1"
  }, [_vm._v("衣帽间收纳能力超强，同时也是更衣室，符合时尚爱美的年轻人的需求。")]), _c('img', {
    staticClass: "cont-img",
    attrs: {
      "src": __webpack_require__(325)
    }
  }), _c('div', {
    staticClass: "line1"
  }, [_vm._v("主卧墙面是时下流行的单面刷色，湖蓝色气质恬静。"), _c('br'), _vm._v(" 灰色的娜塔莎丝绒双人床，轻奢时尚，适合主卧的风格和Siney家的时尚感。")]), _c('img', {
    staticClass: "cont-img",
    attrs: {
      "src": __webpack_require__(326)
    }
  }), _c('div', {
    staticClass: "line1"
  }, [_vm._v("衣帽间收纳力已经足够，床头就只搭配一个海拉床头柜，放手机、纸巾等小物件。")]), _c('img', {
    staticClass: "cont-img",
    attrs: {
      "src": __webpack_require__(328)
    }
  }), _c('div', {
    staticClass: "line1"
  }, [_vm._v("另一边是一张梳妆台，放一些化妆品、首饰等物件，Siney有时候也会在这梳妆打扮。")]), _c('img', {
    staticClass: "cont-img",
    attrs: {
      "src": __webpack_require__(329)
    }
  }), _c('div', {
    staticClass: "line1"
  }, [_vm._v("黄铜单椅搭一张桑德罗羊皮毯，色系跟床头的哈特维尔台灯相匹配，小角落也透露着生活的精致感")]), _c('img', {
    staticClass: "cont-img",
    attrs: {
      "src": __webpack_require__(330)
    }
  }), _c('div', {
    staticClass: "line1"
  }, [_vm._v("飘窗上放满了各式各样的娃娃，流露出90后女生可爱的一面。")]), _c('img', {
    staticClass: "cont-img",
    attrs: {
      "src": __webpack_require__(331)
    }
  }), _c('div', {
    staticClass: "line1"
  }, [_vm._v("几个主要活动空间的灯饰都经过精心挑选，圆润的白色玻璃灯罩，配合黄铜质感，让家里的灯光效果和谐统一。")]), _c('img', {
    staticClass: "cont-img",
    attrs: {
      "src": __webpack_require__(332)
    }
  }), _c('img', {
    staticClass: "cont-img",
    attrs: {
      "src": __webpack_require__(333)
    }
  }), _c('div', {
    staticClass: "line1"
  }, [_vm._v("先生从事金融行业，Siney则从事外企咨询业。两人工作都很忙，平时还要在家办公，所以次卧被用作了工作室。")]), _c('img', {
    staticClass: "cont-img",
    attrs: {
      "src": __webpack_require__(334)
    }
  }), _c('div', {
    staticClass: "line1"
  }, [_vm._v("次卧也是单面刷色，淡粉墙面，配上同色系的窗帘，气质温柔，让人自然冷静下来，很适合工作时的情绪。")]), _c('img', {
    staticClass: "cont-img",
    attrs: {
      "src": __webpack_require__(335)
    }
  }), _c('div', {
    staticClass: "line1"
  }, [_vm._v("卫生间的处理考虑得很细致，盥洗室跟卫生间隔开。可单独使用，还能借到客厅的光线，在这里化妆方便又自然。")]), _c('img', {
    staticClass: "cont-img",
    attrs: {
      "src": __webpack_require__(336)
    }
  }), _c('div', {
    staticClass: "line1"
  }, [_vm._v("卫生间干湿分离，厕所和淋浴间能同时使用、互不干扰，符合年轻人快速的生活节奏。")]), _c('img', {
    staticClass: "cont-img",
    attrs: {
      "src": __webpack_require__(337)
    }
  }), _c('div', {
    staticClass: "line1"
  }, [_vm._v("在家做饭的机会不多，厨房被收拾得整齐干净。墙面全贴瓷砖，非常好清理。")]), _c('img', {
    staticClass: "cont-img",
    attrs: {
      "src": __webpack_require__(339)
    }
  }), _c('div', {
    staticClass: "line1"
  }, [_vm._v("冰箱上的趣味便签板，不经意间又透露了小年轻的生活趣意。")]), _c('img', {
    staticClass: "cont-img",
    attrs: {
      "src": __webpack_require__(340)
    }
  }), _c('div', {
    staticClass: "cont-title1"
  }, [_vm._v(" Q&A")]), _c('div', {
    staticClass: "line2"
  }, [_c('span', [_vm._v("Q：新家的装修审美很不错，有请设计师吗？")]), _vm._v("Siney：我们没有请设计师，搭配都是自己定的。老公对布局有过研究，对灯光的要求也很严格，比如主卧的射灯，光束打在床头必须一定要对称。")]), _c('div', {
    staticClass: "line2"
  }, [_c('span', [_vm._v("Q：对软装搭配有什么心得，挑选家具时在意哪些方面呢？")]), _vm._v("Siney：选家具时，我们比较看重样式和性价比。在大众点评上看到懂窝，就过来逛了，当时就觉得家具很好看。就来回逛了几次，挑选了好多款心仪的家具和小件。")])])
}]}

/***/ }),
/* 449 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "d-liftHome"
  }, [_vm._m(0), _c('div', {
    staticClass: "module2"
  }, [_c('router-link', {
    staticClass: "item",
    attrs: {
      "to": "/case8"
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(395)
    }
  }), _c('div', {
    staticClass: "num"
  }, [_vm._v("Vol.08")]), _c('div', {
    staticClass: "desc"
  }, [_vm._v("不请设计师，魔都小两口玩转91㎡两房，软装配色美出天际")])]), _c('router-link', {
    staticClass: "item",
    attrs: {
      "to": "/case7"
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(393)
    }
  }), _c('div', {
    staticClass: "num"
  }, [_vm._v("Vol.07")]), _c('div', {
    staticClass: "desc"
  }, [_vm._v("65㎡精致小户型，处女座男生的神仙日子")])]), _c('router-link', {
    staticClass: "item",
    attrs: {
      "to": "/case6"
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(394)
    }
  }), _c('div', {
    staticClass: "num"
  }, [_vm._v("Vol.06")]), _c('div', {
    staticClass: "desc"
  }, [_vm._v("设计师爆改上海50㎡老房，示范小户型改造神操作")])]), _c('router-link', {
    staticClass: "item",
    attrs: {
      "to": "/case5"
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(396)
    }
  }), _c('div', {
    staticClass: "num"
  }, [_vm._v("Vol.05")]), _c('div', {
    staticClass: "desc"
  }, [_vm._v("上海93㎡萌趣三口之家，每天都像生活在游乐场")])]), _c('router-link', {
    staticClass: "item",
    attrs: {
      "to": "/case4"
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(397)
    }
  }), _c('div', {
    staticClass: "num"
  }, [_vm._v("Vol.04")]), _c('div', {
    staticClass: "desc"
  }, [_vm._v("上海市区一套房，郊外一栋度假屋，生活这样真挺好！")])]), _c('router-link', {
    staticClass: "item",
    attrs: {
      "to": "/case3"
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(398)
    }
  }), _c('div', {
    staticClass: "num"
  }, [_vm._v("Vol.03")]), _c('div', {
    staticClass: "desc"
  }, [_vm._v("上海175㎡暗黑系霸道总裁风，花100万装修只为这种feel")])]), _c('router-link', {
    staticClass: "item",
    attrs: {
      "to": "/case2"
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(399)
    }
  }), _c('div', {
    staticClass: "num"
  }, [_vm._v("Vol.02")]), _c('div', {
    staticClass: "desc"
  }, [_vm._v("上海246㎡精装大平层，用家具与配饰沉淀出家的味道")])]), _c('router-link', {
    staticClass: "item",
    attrs: {
      "to": "/case1"
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(400)
    }
  }), _c('div', {
    staticClass: "num"
  }, [_vm._v("Vol.01")]), _c('div', {
    staticClass: "desc"
  }, [_vm._v("有风景也有爱，建筑师夫妇把140㎡家打造成让人羡慕的样子")])])], 1), _vm._m(1), _vm._m(2), _vm._m(3), _vm._m(4), _vm._m(5), _c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.scrollTop),
      expression: "scrollTop"
    }],
    staticClass: "scroll-top-btn",
    attrs: {
      "src": __webpack_require__(4)
    },
    on: {
      "click": _vm.backtop
    }
  })])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "module1"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("懂窝客户的家"), _c('div', {
    staticClass: "border"
  })]), _c('div', {
    staticClass: "line1"
  }, [_vm._v("对家居审美有追求、对生活品质不将就，懂窝客户的家，是我们最好的样板房。"), _c('br'), _vm._v(" 记录懂窝产品搭配出的丰富生活场景，更记录每个寻常人家的温馨故事。")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "module3"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("晒单活动"), _c('div', {
    staticClass: "border"
  })]), _c('div', {
    staticClass: "line1"
  }, [_vm._v("热爱分享是热爱生活的体现，记录生活点滴时刻，启发更多家居灵感。"), _c('br'), _vm._v(" 懂窝生活家们，欢迎与我们联系，拍下懂窝产品在您家的使用场景，秀出你的生活你的家。")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "module4"
  }, [_c('div', {
    staticClass: "item"
  }, [_c('div', {
    staticClass: "left"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(389)
    }
  }), _c('div', {
    staticClass: "line"
  })]), _c('div', {
    staticClass: "right"
  }, [_vm._v("途径1：通过"), _c('span', [_vm._v("天猫晒图")]), _vm._v("，并将相同内容发布到逛逛"), _c('br'), _vm._v("途径2：通过"), _c('span', [_vm._v("小红书晒图并@懂窝")])])]), _c('div', {
    staticClass: "item"
  }, [_c('div', {
    staticClass: "left"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(390)
    }
  }), _c('div', {
    staticClass: "line"
  })]), _c('div', {
    staticClass: "right"
  }, [_vm._v("天猫："), _c('span', [_vm._v("15字以上+3张以上美图/视频")]), _c('br'), _vm._v("小红书："), _c('span', [_vm._v("50字以上+3张以上美图/视频")])])]), _c('div', {
    staticClass: "item"
  }, [_c('div', {
    staticClass: "left"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(391)
    }
  }), _c('div', {
    staticClass: "line"
  })]), _c('div', {
    staticClass: "right"
  }, [_c('span', [_vm._v("文字内容生动，能凸显懂窝产品特性")]), _c('br'), _c('span', [_vm._v("图片美观，构图清晰，能体现懂窝产品特点")])])]), _c('div', {
    staticClass: "item"
  }, [_c('div', {
    staticClass: "left"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(392)
    }
  })]), _c('div', {
    staticClass: "right"
  }, [_c('span', [_vm._v("天猫晒单：将晒单截图给天猫客服，即享20元现金红包；实付1500元-5000元的订单即享50元现金红包；实付5000元以上即享1%返现。")]), _c('br'), _c('span', [_vm._v("其他渠道晒单：将晒单截图给对接搭配师，即享20元现金红包；实付1500元-5000元的订单即享50元现金红包；实付5000元以上即享1%返现。")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "module5"
  }, [_c('div', {
    staticClass: "item"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(401)
    }
  }), _c('div', {
    staticClass: "text"
  }, [_c('span', [_vm._v("来自懂窝屋主"), _c('br'), _vm._v(" @华先生")]), _c('br'), _vm._v(" 伊丽莎白Elizabeth沙发"), _c('br'), _vm._v(" 娜塔莎Natasha双人床"), _c('br'), _vm._v("巴罗Barrow沙发")]), _c('img', {
    attrs: {
      "src": __webpack_require__(402)
    }
  }), _c('div', {
    staticClass: "text"
  }, [_c('span', [_vm._v("来自懂窝屋主"), _c('br'), _vm._v(" @Tracy")]), _c('br'), _vm._v("莱拉 Leila 书桌")]), _c('img', {
    attrs: {
      "src": __webpack_require__(403)
    }
  }), _c('div', {
    staticClass: "text"
  }, [_c('span', [_vm._v("来自懂窝屋主"), _c('br'), _vm._v(" @h**y")]), _c('br'), _vm._v(" 丹维尔Danville沙发")]), _c('img', {
    attrs: {
      "src": __webpack_require__(404)
    }
  }), _c('div', {
    staticClass: "text"
  }, [_c('span', [_vm._v("来自懂窝屋主"), _c('br'), _vm._v(" @赵小姐")]), _c('br'), _vm._v(" 瑞森Riesen餐椅"), _c('br'), _vm._v(" 彭特Puente餐桌")]), _c('img', {
    attrs: {
      "src": __webpack_require__(405)
    }
  }), _c('div', {
    staticClass: "text"
  }, [_c('span', [_vm._v("来自懂窝屋主"), _c('br'), _vm._v(" @赵女士")]), _c('br'), _vm._v(" 巴罗Barrow沙发")]), _c('img', {
    attrs: {
      "src": __webpack_require__(406)
    }
  }), _c('div', {
    staticClass: "text"
  }, [_c('span', [_vm._v("来自懂窝屋主"), _c('br'), _vm._v(" @周小姐")]), _c('br'), _vm._v(" 埃尔温Erwin沙发")])]), _c('div', {
    staticClass: "item"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(407)
    }
  }), _c('div', {
    staticClass: "text"
  }, [_c('span', [_vm._v("来自懂窝屋主"), _c('br'), _vm._v(" @陈小姐")]), _c('br'), _vm._v(" 弗雷德里克 Frederik 沙发 "), _c('br'), _vm._v(" 海尔格 Helgar 羽毛落地灯")]), _c('img', {
    attrs: {
      "src": __webpack_require__(408)
    }
  }), _c('div', {
    staticClass: "text"
  }, [_c('span', [_vm._v("来自懂窝屋主"), _c('br'), _vm._v(" @香り")]), _c('br'), _vm._v(" 艾尔弗雷德 Alfred 地灯")]), _c('img', {
    attrs: {
      "src": __webpack_require__(409)
    }
  }), _c('div', {
    staticClass: "text"
  }, [_c('span', [_vm._v("来自懂窝屋主"), _c('br'), _vm._v(" @宫小姐")]), _c('br'), _vm._v(" 普莱森顿 Pleasanton 沙发")]), _c('img', {
    attrs: {
      "src": __webpack_require__(410)
    }
  }), _c('div', {
    staticClass: "text"
  }, [_c('span', [_vm._v("来自懂窝屋主"), _c('br'), _vm._v(" @李小姐")]), _c('br'), _vm._v(" 埃尔温Erwin沙发")]), _c('img', {
    attrs: {
      "src": __webpack_require__(411)
    }
  }), _c('div', {
    staticClass: "text"
  }, [_c('span', [_vm._v("来自懂窝屋主"), _c('br'), _vm._v(" @孙女士")]), _c('br'), _vm._v(" 埃尔温Erwin沙发")])]), _c('div', {
    staticClass: "item"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(412)
    }
  }), _c('div', {
    staticClass: "text"
  }, [_c('span', [_vm._v("来自懂窝屋主"), _c('br'), _vm._v(" @罗小姐 ")]), _c('br'), _vm._v(" 杰洛德Jarrod布艺沙发 "), _c('br'), _vm._v(" 琳内尔Linnell双人床")]), _c('img', {
    attrs: {
      "src": __webpack_require__(413)
    }
  }), _c('div', {
    staticClass: "text"
  }, [_c('span', [_vm._v("来自懂窝屋主"), _c('br'), _vm._v("  @Bingxin ")]), _c('br'), _vm._v("  巴罗 Barrow 沙发 "), _c('br'), _vm._v(" 拉里亚 Llaria 地灯")]), _c('img', {
    attrs: {
      "src": __webpack_require__(414)
    }
  }), _c('div', {
    staticClass: "text"
  }, [_c('span', [_vm._v("来自懂窝屋主"), _c('br'), _vm._v(" @欧先生 ")]), _c('br'), _vm._v(" 普莱森顿 Pleasanton 沙发")]), _c('img', {
    attrs: {
      "src": __webpack_require__(415)
    }
  }), _c('div', {
    staticClass: "text"
  }, [_c('span', [_vm._v("来自懂窝屋主"), _c('br'), _vm._v(" @陈先生 ")]), _c('br'), _vm._v(" 巴罗 Barrow 沙发")]), _c('img', {
    attrs: {
      "src": __webpack_require__(416)
    }
  }), _c('div', {
    staticClass: "text"
  }, [_c('span', [_vm._v("来自懂窝屋主"), _c('br'), _vm._v(" @王女士 ")]), _c('br'), _vm._v(" 巴罗 Barrow 沙发")]), _c('img', {
    attrs: {
      "src": __webpack_require__(417)
    }
  }), _c('div', {
    staticClass: "text"
  }, [_c('span', [_vm._v("来自懂窝屋主"), _c('br'), _vm._v(" @郑女士 ")]), _c('br'), _vm._v(" 埃尔温Erwin沙发")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "module6"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("客户口碑反馈"), _c('div', {
    staticClass: "border"
  })]), _c('div', {
    staticClass: "line1"
  }, [_vm._v("口碑源于产品和服务，懂窝成立以来深受客户喜爱，在小红书、大众"), _c('br'), _vm._v("点评等平台拥有超高人气口碑，连续位列大众点评上海地区成品家具前三。感谢您的反馈，帮助我们持之以恒做得更好。")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "module7"
  }, [_c('div', {
    staticClass: "swiper-container"
  }, [_c('div', {
    staticClass: "swiper-wrapper"
  }, [_c('div', {
    staticClass: "swiper-slide"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(418)
    }
  })]), _c('div', {
    staticClass: "swiper-slide"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(419)
    }
  })]), _c('div', {
    staticClass: "swiper-slide"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(420)
    }
  })]), _c('div', {
    staticClass: "swiper-slide"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(421)
    }
  })]), _c('div', {
    staticClass: "swiper-slide"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(422)
    }
  })])]), _c('div', {
    staticClass: "swiper-pagination"
  }), _c('div', {
    staticClass: "swiper-button-prev"
  }), _c('div', {
    staticClass: "swiper-button-next"
  })])])
}]}

/***/ }),
/* 450 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "d-contactUs"
  }, [_vm._m(0), _c('div', {
    staticClass: "tab"
  }, [_c('div', {
    staticClass: "cont"
  }, _vm._l((_vm.tabDta), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "item",
      class: {
        activeClass: item.active
      },
      on: {
        "click": function($event) {
          return _vm.clickTab(index)
        }
      }
    }, [_vm._v(_vm._s(item.text))])
  }), 0)]), (_vm.currentTab == 1) ? _c('div', {
    staticClass: "cooperation"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("合作咨询")]), _c('div', {
    staticClass: "desc"
  }, [_vm._v("任何问题，欢迎扫码添加懂窝（dongwo_wx）咨询")]), _c('img', {
    staticClass: "qrCode",
    attrs: {
      "src": __webpack_require__(347)
    }
  })]) : _c('div', {
    staticClass: "recruitment"
  }, [_vm._m(1), _vm._l((_vm.recruitmentData), function(item1, index1) {
    return _c('div', {
      key: index1,
      staticClass: "content"
    }, [_c('div', {
      staticClass: "jobs-title",
      on: {
        "click": function($event) {
          return _vm.clickOpen(item1.open, index1)
        }
      }
    }, [_vm._v(_vm._s(item1.title)), _c('span', {
      class: {
        'open-class': item1.open
      }
    })]), _vm._l((item1.contData), function(item2, index2) {
      return _c('div', {
        directives: [{
          name: "show",
          rawName: "v-show",
          value: (item1.open),
          expression: "item1.open"
        }],
        key: index2,
        staticClass: "item"
      }, _vm._l((item2), function(item3, index3) {
        return _c('div', {
          key: index3,
          staticClass: "lable"
        }, [_vm._v(_vm._s(item3))])
      }), 0)
    })], 2)
  })], 2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "topImg"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(346)
    }
  }), _c('div', {
    staticClass: "title"
  }, [_vm._v("联系我们")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "teite"
  }, [_vm._v("懂窝广招贤才"), _c('br'), _vm._v("简历投递：HR@dwnest.com")])
}]}

/***/ }),
/* 451 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "d-footer"
  }, [_c('div', {
    staticClass: "top"
  }, [_vm._m(0), _c('div', {
    staticClass: "center"
  }, [_c('div', {
    staticClass: "item"
  }, [_c('div', {
    staticClass: "title"
  }, [_c('router-link', {
    attrs: {
      "to": "/index"
    }
  }, [_c('span', [_vm._v("关于懂窝")])])], 1), _c('div', {
    staticClass: "lable",
    on: {
      "click": function($event) {
        return _vm.clickLable('brand-desc')
      }
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/index?scrollEl=brand-desc"
    }
  }, [_c('span', [_vm._v("品牌介绍")])])], 1), _c('div', {
    staticClass: "lable",
    on: {
      "click": function($event) {
        return _vm.clickLable('module3')
      }
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/index?scrollEl=module3"
    }
  }, [_c('span', [_vm._v("产品介绍")])])], 1), _c('div', {
    staticClass: "lable",
    on: {
      "click": function($event) {
        return _vm.clickLable('module5')
      }
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/index?scrollEl=module3"
    }
  }, [_c('span', [_vm._v("合作工厂")])])], 1), _c('div', {
    staticClass: "lable",
    on: {
      "click": function($event) {
        return _vm.clickLable('module12')
      }
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/index?scrollEl=module10"
    }
  }, [_c('span', [_vm._v("品牌合作伙伴")])])], 1)]), _c('div', {
    staticClass: "item"
  }, [_c('div', {
    staticClass: "title"
  }, [_c('router-link', {
    attrs: {
      "to": "/serviceRules"
    }
  }, [_c('span', [_vm._v("服务政策")])])], 1), _c('div', {
    staticClass: "lable",
    on: {
      "click": function($event) {
        return _vm.clickLable('module5')
      }
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/index?scrollEl=module5"
    }
  }, [_c('span', [_vm._v("服务特色")])])], 1), _c('div', {
    staticClass: "lable"
  }, [_c('router-link', {
    attrs: {
      "to": "/serviceRules?currentTab=1"
    }
  }, [_c('span', [_vm._v("配送说明")])])], 1), _c('div', {
    staticClass: "lable"
  }, [_c('router-link', {
    attrs: {
      "to": "/serviceRules?currentTab=2"
    }
  }, [_c('span', [_vm._v("售后服务")])])], 1), _c('div', {
    staticClass: "lable"
  }, [_c('router-link', {
    attrs: {
      "to": "/serviceRules?currentTab=3"
    }
  }, [_c('span', [_vm._v("常见问题")])])], 1)]), _c('div', {
    staticClass: "item"
  }, [_c('div', {
    staticClass: "title"
  }, [_c('router-link', {
    attrs: {
      "to": "/contactUs"
    }
  }, [_c('span', [_vm._v("联系我们")])])], 1), _c('div', {
    staticClass: "lable"
  }, [_c('router-link', {
    attrs: {
      "to": "/contactUs?currentTab=1"
    }
  }, [_c('span', [_vm._v("合作咨询")])])], 1), _c('div', {
    staticClass: "lable"
  }, [_c('router-link', {
    attrs: {
      "to": "/contactUs?currentTab=2"
    }
  }, [_c('span', [_vm._v("招聘信息")])])], 1)])]), _vm._m(1)]), _c('div', {
    staticClass: "bottom"
  }, [_vm._v("上海素造网络科技有限公司版权所有  |  沪ICP备19016235号  |   © Copyright 2019 All Rights Reserved")])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "left"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(358)
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "right"
  }, [_c('div', {
    staticClass: "cont"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(359)
    }
  }), _c('p', [_vm._v("微信公众号")])])])
}]}

/***/ }),
/* 452 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "d-serviceRules"
  }, [_vm._m(0), _c('div', {
    staticClass: "tab"
  }, [_c('div', {
    staticClass: "cont"
  }, _vm._l((_vm.tabDta), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "item",
      class: {
        activeClass: item.active
      },
      on: {
        "click": function($event) {
          return _vm.clickTab(index)
        }
      }
    }, [_vm._v(_vm._s(item.text))])
  }), 0)]), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.currentTab == 1),
      expression: "currentTab == 1"
    }],
    staticClass: "distribution"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("配送安装范围")]), _vm._m(1), _c('div', {
    staticClass: "title"
  }, [_vm._v("大件入户说明")]), _vm._m(2)]), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.currentTab == 2),
      expression: "currentTab == 2"
    }],
    staticClass: "after-sales"
  }, [_vm._m(3), _vm._m(4), _vm._m(5), _vm._m(6)]), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.currentTab == 3),
      expression: "currentTab == 3"
    }],
    staticClass: "Q-A"
  }, [_vm._m(7), _vm._m(8)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "topImg"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(423)
    }
  }), _c('div', {
    staticClass: "title"
  }, [_vm._v("服务政策")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_c('span', [_vm._v("·懂窝配送范围涵盖全国各地(除新疆、西藏、青海三省)。")]), _vm._v(" "), _c('span', [_vm._v("·大件家具提供免费配送服务,小件家居按城市距离分级,您可能需要承担不同金额的快递费。")]), _vm._v(" "), _c('span', [_vm._v("·全拆装大件家具在上海地区支持免费“送货上门及组装”服务(具体详情请治懂窝客服)。")]), _vm._v(" "), _c('span', [_vm._v("·悬挂灯具部分,目前尚未提供吊灯与顶棚的安装接电服务,敬请见谅。")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_c('span', [_vm._v("·大件家具的物流由懂窝甄选的第三方服务公司为您服务,服务公司或懂窝工作人员会与您致电预约上门时间,期间请保持电话通畅。")]), _vm._v(" "), _c('span', [_vm._v("·目前尚不支持指定时间上门服务,请您预估合理的收货时间,避免因到货后无法收货而产生的仓储费用,懂窝为您提供3个自然日的免费仓储,超过3个工作日开始收取仓储费。该笔费用将由物流公司直接向您收取,请您支付前仔细核对")]), _vm._v(" "), _c('span', [_vm._v("·若您的住所没有电梯或电梯无法使用,七楼及七楼以下,由懂窝合作的第三方公司给您免费提供上楼服务;若入户后有楼层或地下室的,则按抬楼楼层总数来计算费用。")]), _vm._v(" "), _c('span', [_vm._v("·因部分家具尺寸较大,请在购买前对楼梯、电梯、房门等入户结构进行尺寸测量,确认能否上楼入户。")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "item"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("售后服务")]), _c('div', {
    staticClass: "content"
  }, [_c('span', [_vm._v("·关于发货:一般情况下,生产周期为45-60天,具体请与客服沟通。")]), _vm._v(" "), _c('span', [_vm._v("·关于配送:全国大部分地区,包邮送货入户。无电梯或者电梯不可进情况下,七楼以上需颜外加收上楼费用。")]), _vm._v(" "), _c('span', [_vm._v(" ·关于仓储:货物到达当地后,3日内免费仓储,超出后则按照10元/天/m³进行收费。")]), _vm._v(" "), _c('span', [_vm._v("·关于安装:请与在线客服关系,我们安排工人师傅与您孩约上门安装时间(免费安装)")]), _vm._v(" "), _c('span', [_vm._v(" ·关于退换货:提供七天无理由退换货服务,如因用户原因产生退换货,则需支付10%-20%不等的耗损费。缺失包装,另需支"), _c('br'), _vm._v(" 付5%-10%的费用。")]), _vm._v(" "), _c('span', [_vm._v(" ·关于质保:所出售的大件家具产品,提供三年质保服务:非人为因素的商品损坏,提供免费维修服务")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "item"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("三年质保服务")]), _c('div', {
    staticClass: "content"
  }, [_c('span', [_vm._v("·懂窝为出售的家具产品提供为期三年的质量保障服务。质保期内，若产品在正常使用和维护的情况下出现问题，请第一时间联系懂窝客服，若属于产品本身质量问题(非人为原因),我们将为您维修,直至问题解决.质保期以产品实际签收日期为起始日,请您在签收货物单据时,注意查看交货日期。")]), _vm._v(" "), _c('span', [_vm._v("·质保期限内,若因产品质量问题而产生的售后相关费用,由懂窝承担;非产品质量问题,产生的售后相关费用,由客户承担。超出质保期限，懂窝将根据实际情况为您提供服务,并收取原材料成本、上门维修费等合理费用,具体金额将会在每次服务发生前与您商定。")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "item"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("退换货政策")]), _c('div', {
    staticClass: "content"
  }, [_c('span', [_vm._v("·甲方自签收之日起7天内，如因非产品本身质量问题等主观原因可以提出“七天无理由退换货”的申请。")]), _vm._v(" "), _c('span', [_vm._v("·由于家具属于定做的商品,甲方提出无理由退换货的，需支付相应耗损费。")]), _vm._v(" "), _c('span', [_vm._v("·若退换货订单中包含赠品,甲方需将赠品寄回,若赠品破损或遗失，需扣除赠品价值等额的货款。若您已经开具发票而发票遗失,则相应的退税点(13%)需由您承担。")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "item"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("无法受理范围")]), _c('div', {
    staticClass: "content"
  }, [_c('span', [_vm._v("·因拍摄设备 、显示器、光线等原因产生的色差,不属于商品质量问题")]), _vm._v(" "), _c('span', [_vm._v("·因商品测量标准不一致导致的尺寸问题,在相关标准规定的尺寸误差内,不属于商品质量问题;")]), _vm._v(" "), _c('span', [_vm._v("·材料，工艺产生的天然瑕疵,不属于商品质量问题")]), _vm._v(" "), _c('span', [_vm._v("·未按懂窝标准收货程序签收，拆包不当造成的损坏")]), _vm._v(" "), _c('span', [_vm._v("·未按照懂窝产品组装说明书操作，错误组装造成的产品损坏")]), _vm._v(" "), _c('span', [_vm._v("·未按照组装说明书要求，自行更换部件造成的损坏")]), _vm._v(" "), _c('span', [_vm._v("·自行拆装 、调换产品,或在错误的环境使用造成的损坏")]), _vm._v(" "), _c('span', [_vm._v("·非专业人士修理导致的损坏")]), _vm._v(" "), _c('span', [_vm._v("·由于不正当使用产品或部件造成的人身和财产损失")]), _vm._v(" "), _c('span', [_vm._v("·不能提供购买凭证或者擅自更改购买日期者")]), _vm._v(" "), _c('span', [_vm._v("·因其它不可抗拒力(地震,火灾)等造成的产品损坏")]), _vm._v(" "), _c('span', [_vm._v("·其它使用，维护，保管不当及人为损坏的情况")]), _vm._v(" "), _c('span', [_vm._v("·玻璃镜子发生霉变和雾光的三包期限为六个月。")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "item"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("关于配送")]), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "lable"
  }, [_vm._v("Q：不同类型的家居，上楼配送安装是一样的费用嘛？")]), _c('span', [_vm._v("A：七楼及一下免费上楼，八层(含八层)起边几、茶几、餐桌、餐椅、床头柜等按15元/层/件计算;沙发、床垫、床、柜体(床头柜除外)、排骨架、大理石产品等按30元/层/件计算。若入户后有楼层或地下室的，则按抬楼楼层总数来计算费用。")]), _c('div', {
    staticClass: "lable"
  }, [_vm._v("Q:如何预约上门时间？")]), _c('span', [_vm._v("A:懂窝目前尚不支持指定时间上门服务，请您预估合理的收货时间，避免到货后无法收货而产生仓储费用。")]), _c('div', {
    staticClass: "lable"
  }, [_vm._v("Q:家具的配送范围？")]), _c('span', [_vm._v("A：懂窝配送范围覆盖全国各地，除新疆、西藏、青海三省。大件免费配送，小件按城市距离分级。")]), _c('div', {
    staticClass: "lable"
  }, [_vm._v("Q：能免费上门组装嘛？")]), _c('span', [_vm._v("A:全拆大件家具，在上海地区支持免费“送货上门及组装”服务，详情可联系客服。")]), _c('div', {
    staticClass: "lable"
  }, [_vm._v("Q：买的吊灯能帮忙安装吗？")]), _c('span', [_vm._v("A：懂窝目前尚未提供吊灯与顶棚的安装接电服务，敬请见谅。")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "item"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("关于售后")]), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "lable"
  }, [_vm._v("Q:下单后多久能到货")]), _c('span', [_vm._v("A：家具为定做商品，一般情况下，生产周期为45-60天，具体请与客服沟通。")]), _c('div', {
    staticClass: "lable"
  }, [_vm._v("Q：家具到家后不满意，我能退货吗？")]), _c('span', [_vm._v("A：甲方自签收之日起7天内，如因非产品本身质量问题等主观原因可以提出“七天无理由退换货”的申请。")]), _c('div', {
    staticClass: "lable"
  }, [_vm._v("Q：家具使用时有损伤，怎么办？")]), _c('span', [_vm._v("A：我们为所出售的大件家具产品，提供三年质保服务，非人为因素的商品损坏，提供免费维修服务。")])])])
}]}

/***/ }),
/* 453 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "d-header"
  }, [_c('div', {
    staticClass: "cont"
  }, [_vm._m(0), _c('div', {
    staticClass: "right"
  }, [_c('div', {
    staticClass: "item"
  }, [_c('router-link', {
    attrs: {
      "to": "/index"
    }
  }, [_c('span', [_vm._v("关于懂窝")])])], 1), _c('div', {
    staticClass: "item"
  }, [_c('router-link', {
    attrs: {
      "to": "/findUs"
    }
  }, [_c('span', [_vm._v("找到我们")])])], 1), _c('div', {
    staticClass: "item"
  }, [_c('router-link', {
    attrs: {
      "to": "/lifeHome"
    }
  }, [_c('span', [_vm._v("懂窝生活家")])])], 1)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "logo"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(360)
    }
  })])
}]}

/***/ }),
/* 454 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('dw-header'), _c('router-view'), _c('dw-footer')], 1)
},staticRenderFns: []}

/***/ })
],[99]);


// WEBPACK FOOTER //
// js/app.7f0e56100f309e6d3ba3.js